import { Exercise } from "../../../../models/types";


export const exercisesList: Exercise[] = [
  {
    name: "Stability Ball Dead Bug",
    shortYouTubeDemonstration: "https://youtu.be/5jDEulwWs04",
    inDepthYouTubeExplanation: "https://youtu.be/Sa4ZWmnSC5o",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Rectus Femoris",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Postural",
  },
  {
    name: "Bodyweight Glute Bridge",
    shortYouTubeDemonstration:
      "https://youtu.be/ncpMkhXAykg?si=a_b3ot2rsThtz4DE",
    inDepthYouTubeExplanation: "https://youtu.be/wPM8icPu6H8",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Bird Dog",
    shortYouTubeDemonstration:
      "https://youtu.be/tU-WZsouVjo?si=Ti1JUU03OqgnmtX6",
    inDepthYouTubeExplanation: "https://youtu.be/-LRjkbEy-qU",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Quadruped",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Postural",
  },
  {
    name: "Stability Ball Russian Twist ",
    shortYouTubeDemonstration:
      "https://youtu.be/2rbbUJR-Nx4?si=aAPlfM1RYBeErvZk",
    inDepthYouTubeExplanation: "https://youtu.be/fh-sDpg1P48",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Feet Elevated Crunch ",
    shortYouTubeDemonstration: "https://youtu.be/ByXVlY2L3nw",
    inDepthYouTubeExplanation: "https://youtu.be/meo3bhh8NPk",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Hanging Knee Raise ",
    shortYouTubeDemonstration:
      "https://youtu.be/RPBH_Dw5hUo?si=SqKs_FnqsPMuLdq0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Rectus Femoris",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Mountain Climber",
    shortYouTubeDemonstration: "https://youtu.be/W0RoAqlFzrA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Push Up",
    shortYouTubeDemonstration: "https://youtu.be/Kbhl_O1N4aw",
    inDepthYouTubeExplanation: "https://youtu.be/Jrh9F8L2NJ4",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Knee Hover Bird Dog",
    shortYouTubeDemonstration: "https://youtu.be/fGaqVUHB1aA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Hover Quadruped",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Postural",
  },
  {
    name: "Stability Ball V Up Pass",
    shortYouTubeDemonstration: "https://youtu.be/n4UPDi5BuL0",
    inDepthYouTubeExplanation: "https://youtu.be/Lrmlsxk3zx4",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Dead Bug",
    shortYouTubeDemonstration: "https://youtu.be/jbWmbhElf3Q",
    inDepthYouTubeExplanation: "https://youtu.be/g_BYB0R-4Ws",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Rectus Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Postural",
  },
  {
    name: "Bodyweight Alternating Heel Taps",
    shortYouTubeDemonstration: "https://youtu.be/URWXz0DmE7s",
    inDepthYouTubeExplanation: "https://youtu.be/IVppNiu0hvw",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Lateral Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Flutter Kicks",
    shortYouTubeDemonstration: "https://youtu.be/e_s7uBNPnow",
    inDepthYouTubeExplanation: "https://youtu.be/DNx0PYv7_L8",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Kneeling Forearm Plank",
    shortYouTubeDemonstration: "https://youtu.be/Ns1NS9ThNhI",
    inDepthYouTubeExplanation: "https://youtu.be/5HyOjaj7atU",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Seated Ab Circles",
    shortYouTubeDemonstration: "https://youtu.be/GflQ_ymx9Nw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Hanging Oblique Knee Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Stability Ball Stir the Pot",
    shortYouTubeDemonstration: "https://youtu.be/IfOtFv6zz8I",
    inDepthYouTubeExplanation:
      "https://youtu.be/FpH1C25VyXE?si=hAzBuHZIBIX0MG4j",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Spinal Rotational",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Alternating Lateral Kick Through",
    shortYouTubeDemonstration: "https://youtu.be/1jCudOtlLsc",
    inDepthYouTubeExplanation: "https://youtu.be/86NNY5U6jqk",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Hover Quadruped",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Animal Flow",
  },
  {
    name: "Ring Hanging L Sit Flutter Kicks ",
    shortYouTubeDemonstration: "https://youtu.be/Y7Ua1YRsqd0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Slam Ball Russian Twist",
    shortYouTubeDemonstration: "https://youtu.be/qyZ0pAtgo_Y",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Slam Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Dumbbell Crush Grip Otis Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Dumbbell Side Plank Reach Through ",
    shortYouTubeDemonstration: "https://youtu.be/Ec9Ymqhe5i4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Lateral Flexion",
    MovementPatternCount2: "Spinal Rotational",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ab Wheel Kneeling Rollout",
    shortYouTubeDemonstration: "https://youtu.be/QB2Gj1QGfjQ",
    inDepthYouTubeExplanation: "https://youtu.be/A3uK5TPzHq8",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Ab Wheel",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Seated Crunch",
    shortYouTubeDemonstration: "https://youtu.be/gQT76pz_X9Y",
    inDepthYouTubeExplanation: "https://youtu.be/vg1KU7HNbyw",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Kneeling Crunch",
    shortYouTubeDemonstration: "https://youtu.be/ToJeyhydUxU",
    inDepthYouTubeExplanation: "https://youtu.be/vsAPBAg0fb0",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Medicine Ball V Up",
    shortYouTubeDemonstration:
      "https://youtu.be/E0WFCTnN728?si=YvTVZvOCRm_hjh2B",
    inDepthYouTubeExplanation: "https://youtu.be/7MY2agzydDw",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Medicine Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Knee Tuck",
    shortYouTubeDemonstration: "https://youtu.be/z2tctrNfTrY",
    inDepthYouTubeExplanation: "https://youtu.be/EXIJ4dILenc",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: "Anti-Extension",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Lateral Knee Tuck",
    shortYouTubeDemonstration: "https://youtu.be/nedEXGnhHak",
    inDepthYouTubeExplanation: "https://youtu.be/Jz9UDCeyuBo",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Archer Row ",
    shortYouTubeDemonstration: "https://youtu.be/O0wf46CgVZg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Dumbbell Turkish Get Up",
    shortYouTubeDemonstration: "https://youtu.be/saYKvqSscuY",
    inDepthYouTubeExplanation: "https://youtu.be/MlDLOiN42d4",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Bodyweight Bear Crawl",
    shortYouTubeDemonstration: "https://youtu.be/8y-C1wUb-3c",
    inDepthYouTubeExplanation: "https://youtu.be/Wgt1vdZ_YYk",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Hover Quadruped",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Animal Flow",
  },
  {
    name: "Stability Ball Knee Tuck",
    shortYouTubeDemonstration:
      "https://youtu.be/Q8MnsYG5sbk?si=8Aln2doES1PVTKQP",
    inDepthYouTubeExplanation: "https://youtu.be/PbCgRWzQPc8",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Hanging Leg Raise ",
    shortYouTubeDemonstration: "https://youtu.be/IMWzJ7zkklA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette L Sit",
    shortYouTubeDemonstration: "https://youtu.be/lLu9U0G7Ogw",
    inDepthYouTubeExplanation: "https://youtu.be/rzK07x9QeNY",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Standing Walkout Plank",
    shortYouTubeDemonstration: "https://youtu.be/R6SMJ-TzgZo",
    inDepthYouTubeExplanation: "https://youtu.be/R6SMJ-TzgZo",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Eccentric Pull Up",
    shortYouTubeDemonstration: "https://youtu.be/4vEoBieXyKk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Climb",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/1bBP54xKHbQ",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Ipsilateral Bird Dog",
    shortYouTubeDemonstration: "https://youtu.be/8e1m4FNO7t8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Quadruped",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Copenhagen Plank Knee to Elbow",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/DrSAMHlAk4I",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Side)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Eccentric Chin Up",
    shortYouTubeDemonstration:
      "https://youtu.be/QvgPN5XfDX8?si=0U64Q99rkmh8yNmO",
    inDepthYouTubeExplanation: "https://youtu.be/Gh3vyrtzkmY",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Dumbbell Seated Shoulder External Rotation",
    shortYouTubeDemonstration:
      "https://youtu.be/HeY0G79zbGA?si=qV6g26pqatUMpDew",
    inDepthYouTubeExplanation: "https://youtu.be/XKCfeJp4Qo0",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Seated Cuban Rotation",
    shortYouTubeDemonstration: "https://youtu.be/oYGHjG0jZuA",
    inDepthYouTubeExplanation: "https://youtu.be/Ia8KK_P8r6Y",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Cuban Rotation",
    shortYouTubeDemonstration: "https://youtu.be/_Cfrbn8dxH4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Cable Half Kneeling Contralateral Shoulder External Rotation 90 Degrees",
    shortYouTubeDemonstration:
      "https://youtu.be/Ff4Dg3T4pNQ?si=xU9cm-kpyPdrIwA0",
    inDepthYouTubeExplanation: "https://youtu.be/eM0V87yceog",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Miniband Fire Hydrant",
    shortYouTubeDemonstration: "https://youtu.be/gnzypKUFU6Y",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Quadruped",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Medicine Ball Russian Twist",
    shortYouTubeDemonstration: "https://youtu.be/vT8p57mXVDo?feature=shared",
    inDepthYouTubeExplanation: "https://youtu.be/5BF32n07JBY",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Medicine Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Side Plank",
    shortYouTubeDemonstration: "https://youtu.be/_R389Jk0tIo",
    inDepthYouTubeExplanation: "https://youtu.be/rCxF2nG9vQ0",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Lateral Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Cable Reverse Crunch",
    shortYouTubeDemonstration:
      "https://youtu.be/3Mn_4KTDTi0?si=3zBBQ33AQDN7XPp4",
    inDepthYouTubeExplanation: "https://youtu.be/Ss3G7RnIjV4",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Rope Half Kneeling High to Low Chop",
    shortYouTubeDemonstration: "https://youtu.be/hUbRkz4AxkE",
    inDepthYouTubeExplanation: "https://youtu.be/KOh8cxe2ziE",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Rope Half Kneeling Low to High Chop",
    shortYouTubeDemonstration: "https://youtu.be/48LIxDpby_E?feature=shared",
    inDepthYouTubeExplanation: "https://youtu.be/AA7q2T4IOCk",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Double Kettlebell Bottoms Up Overhead Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Rope Staggered Stance High to Low Chop ",
    shortYouTubeDemonstration: "https://youtu.be/FFaeQW7hwYs?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/jnG8cjO0fMQ?si=8rvMJWRgsZskHMP9",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Rope Staggered Stance Low to High Chop",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Dumbbell Windmill",
    shortYouTubeDemonstration: "https://youtu.be/EVLXzqAzAHI",
    inDepthYouTubeExplanation:
      "https://youtu.be/0gMRrtTN5OE?si=UAizRA3GShfFTChg",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Double Kettlebell Bottoms Up Front Rack Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Kettlebell Front Rack Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Feet On Wall Mountain Climber ",
    shortYouTubeDemonstration:
      "https://youtu.be/jGwHfj957eU?si=i-ZtryUkm2Geud9J",
    inDepthYouTubeExplanation: "https://youtu.be/OcGkhubaWzE",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Slider Double Kettlebell Suitcase Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/1SlpUMsiiiw?si=WnEVv0WTROHdU4eR",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Hollow Body Hold",
    shortYouTubeDemonstration: "https://youtu.be/4xRpGgttca8",
    inDepthYouTubeExplanation: "https://youtu.be/hf00_b2sRdc",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Dumbbell Crush Grip Hollow Body Hold",
    shortYouTubeDemonstration: "https://youtu.be/Wo-pGZst6l0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bar Inverted Hanging Crunch",
    shortYouTubeDemonstration: "https://youtu.be/LXQTkeYPki8",
    inDepthYouTubeExplanation: "https://youtu.be/gQbe4jcqfEA",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted ",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Inverted Hanging Oblique Crunch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted ",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Double Kettlebell Front Rack Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/-p1l0vXTtAU?si=ebEJZJZkoWYTDFbC",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Supine Alternating Single Leg Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/IUCoqgdvDxU?si=8xtgp1M-mJqke2mR",
    inDepthYouTubeExplanation: "https://youtu.be/TJITvui4Wwo",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Supine Leg Raise",
    shortYouTubeDemonstration: "https://youtu.be/q0JVBRHoLz4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Miniband Bicycle Crunch",
    shortYouTubeDemonstration: "https://youtu.be/q_c5MFYuza4",
    inDepthYouTubeExplanation: "https://youtu.be/i5hJzH1AhRw",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Alternating",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Side Plank Reach Through",
    shortYouTubeDemonstration: "https://youtu.be/7lfNb_zydvQ",
    inDepthYouTubeExplanation: "https://youtu.be/-ruAdV34H54",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Lateral Flexion",
    MovementPatternCount2: "Spinal Rotational",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Sit Up",
    shortYouTubeDemonstration:
      "https://youtu.be/bT8NVeDvuQg?si=paUR-bam-jwd-xPx",
    inDepthYouTubeExplanation: "https://youtu.be/-WSon5E798w",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Butterfly Sit Up",
    shortYouTubeDemonstration: "https://youtu.be/ZLyOWSPnVrM",
    inDepthYouTubeExplanation: "https://youtu.be/hdXsuDt2PKE",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Mountain Climber",
    shortYouTubeDemonstration: "https://youtu.be/fjHQIVIPLHY",
    inDepthYouTubeExplanation:
      "https://youtu.be/jNoFTnT6QEg?si=Ifucn1FF5b_Hxnq5&utm_source=MTQxZ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Pike ",
    shortYouTubeDemonstration:
      "https://youtu.be/vB803WCcQDk?si=hXUn4t23jP7Bn6R8",
    inDepthYouTubeExplanation: "https://youtu.be/dIhjNYsITbc",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Pike",
    shortYouTubeDemonstration:
      "https://youtu.be/-ciDJCuTu3A?si=zpBNDJ0Pbp7YfJOm",
    inDepthYouTubeExplanation: "https://youtu.be/eFcjeQ9tuEQ",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Wide Mountain Climber",
    shortYouTubeDemonstration: "https://youtu.be/d64d_6PE9fY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Crunch",
    shortYouTubeDemonstration:
      "https://youtu.be/O4d3kd1ZLyc?si=xAr_I7jNLwrDm7lL",
    inDepthYouTubeExplanation: "https://youtu.be/sUMW-xhzI84",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Feet Elevated Oblique Crunch",
    shortYouTubeDemonstration:
      "https://youtu.be/fZZK29dMla0?si=BQpGveG4S8WqLjzv",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Kneeling Rollout",
    shortYouTubeDemonstration:
      "https://youtu.be/gi38qGKDzXY?si=XCqiGVtu482eeeTP",
    inDepthYouTubeExplanation: "https://youtu.be/2UQx-1dxyY8",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Single Leg Knee Tuck",
    shortYouTubeDemonstration:
      "https://youtu.be/fv6mxdkTT60?si=1AhvmIbGHoW_9tm9",
    inDepthYouTubeExplanation: "https://youtu.be/xnOF_sTSppw",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Single Leg Pike",
    shortYouTubeDemonstration: "https://youtu.be/7skasCMLRL8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Z Press",
    shortYouTubeDemonstration: "https://youtu.be/k_kXBEjURUA",
    inDepthYouTubeExplanation: "https://youtu.be/wce-elEhBHw",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Kettlebell Overhead Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Romanian Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/Cf3CaHui43A?si=dFPcP6jQEQECmXmY",
    inDepthYouTubeExplanation: "https://youtu.be/hQgFixeXdZo",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Side Plank",
    shortYouTubeDemonstration: "https://youtu.be/2WxwO9E93wI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Lateral Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Single Leg Glute Bridge",
    shortYouTubeDemonstration: "https://youtu.be/z4J188sFD4g",
    inDepthYouTubeExplanation: "https://youtu.be/_K_di6h2-Wg",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Glute Bridge",
    shortYouTubeDemonstration: "https://youtu.be/JpDDoINkrog",
    inDepthYouTubeExplanation: "https://youtu.be/FSiUH5jn3Cs",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Glute Bridge Isometric with Alternating Single Leg Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/cRCXEFhpBEI?si=6A2YpBsXM9WqT6rW",
    inDepthYouTubeExplanation:
      "https://youtu.be/ubuobFi9GH8?si=aysa84_fukw-vhZm",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: "Hip Extension",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Side Lying Clamshell",
    shortYouTubeDemonstration:
      "https://youtu.be/vSpyJR3dA7s?si=voo83Swm5kMbYEwl",
    inDepthYouTubeExplanation: "https://youtu.be/m_ZPapmqeNM",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Lying",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Ankle Side Lying Hip Abduction",
    shortYouTubeDemonstration: "https://youtu.be/bDvFd4EZt8M",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Lying",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Bench Seated Hip Abduction",
    shortYouTubeDemonstration:
      "https://youtu.be/NeO0w4Jv4rs?si=zFKHnPvts0-arQgk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Glute Bridge Hip Abduction",
    shortYouTubeDemonstration: "https://youtu.be/oS3cYfl6Bns",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: null,
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: "Hip Abduction",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Transverse Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Hip Thrust",
    shortYouTubeDemonstration:
      "https://youtu.be/4azLK_5vOqY?si=bceKCFzhvhSW5jXe",
    inDepthYouTubeExplanation: "https://youtu.be/awrONjSvtNU",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Dumbbell Hip Thrust",
    shortYouTubeDemonstration: "https://youtu.be/x4lc8HocO1c",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Frog Pump",
    shortYouTubeDemonstration: "https://youtu.be/7IVoH7E4rWo",
    inDepthYouTubeExplanation: "https://youtu.be/jbJBXErKD-U",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Dumbbell Frog Pump",
    shortYouTubeDemonstration: "https://youtu.be/N6t2Fv0SKGc",
    inDepthYouTubeExplanation: "https://youtu.be/MQ62r2V7Lw8",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Glute Kickback",
    shortYouTubeDemonstration:
      "https://youtu.be/qJxwJ1e1HxI?si=5y999i_uPybFFDol",
    inDepthYouTubeExplanation: "https://youtu.be/dJa_Nf4zdik",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Single Leg Foot Elevated Glute Bridge",
    shortYouTubeDemonstration: "https://youtu.be/I7Zwyzr8COk",
    inDepthYouTubeExplanation: "https://youtu.be/-sDqY1KTpPE",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Feet Elevated Glute Bridge",
    shortYouTubeDemonstration:
      "https://youtu.be/bZUGEwxZVks?si=GXDy3dTxYcWMuQpw",
    inDepthYouTubeExplanation: "https://youtu.be/KlgaxSAfaDA",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Thigh Lateral Walk",
    shortYouTubeDemonstration: "https://youtu.be/34fVGXqWWs8",
    inDepthYouTubeExplanation: "https://youtu.be/7C8mL0v976o",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Ankle Lateral Walk",
    shortYouTubeDemonstration: "https://youtu.be/N4tkpDMlqCQ",
    inDepthYouTubeExplanation: "https://youtu.be/mKCe63bpPxA",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Feet Lateral Walk",
    shortYouTubeDemonstration: "https://youtu.be/GxqfnFHLH6c",
    inDepthYouTubeExplanation: "https://youtu.be/5wUk8wQNUT8",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Standing Glute Kickback",
    shortYouTubeDemonstration:
      "https://youtu.be/pdP0uJXvc44?si=lpmJ6krZopavsZrJ",
    inDepthYouTubeExplanation:
      "https://youtu.be/kK5RKh_abCE?si=_1yTmWZij9OG5rwA",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Hip Thrust",
    shortYouTubeDemonstration: "https://youtu.be/5S8SApGU_Lk",
    inDepthYouTubeExplanation: "https://youtu.be/LM8XHLYJoYs",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Single Leg Hip Thrust",
    shortYouTubeDemonstration:
      "https://youtu.be/BMIy2gtjsTI?si=JnJL8ZiliAOk_Ac1",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Single Leg Foot Elevated Glute Bridge",
    shortYouTubeDemonstration: "https://youtu.be/LSUPiOJOA6M",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Standing Hip Abduction",
    shortYouTubeDemonstration: "https://youtu.be/dZNkjqKNUUs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband 3 Way Cha Cha",
    shortYouTubeDemonstration: "https://youtu.be/3SOcMYQWbDU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: "Hip Extension",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Suitcase Contralateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/5D-hSAvpFls?si=2EfexeMUADw51Wu2",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Hip Abduction",
    shortYouTubeDemonstration:
      "https://youtu.be/saVSMtIttZE?si=qgSuj5ww8uiz2Wkd",
    inDepthYouTubeExplanation: "https://youtu.be/pvnR8CDb4BU",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Miniband Wall Sit Hip Abduction",
    shortYouTubeDemonstration: "https://youtu.be/w5nYnnT1E9s",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: null,
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Wall Sit",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Barbell Overhead Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Barbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Half Kneeling Contralateral Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/4DUIY95jX6Y",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Shrug",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/pqYr_lb04O4",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Face Pull",
    shortYouTubeDemonstration:
      "https://youtu.be/l3prcz-3FbI?si=qvb-6gLh-aavLGWK",
    inDepthYouTubeExplanation: "https://youtu.be/1dzR5IW0cL8",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Seated Face Pull",
    shortYouTubeDemonstration: "https://youtu.be/4UhV4cCkugM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Guillotine Curl",
    shortYouTubeDemonstration: "https://youtu.be/KLM1hUecXbY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Supine Bicep Curl",
    shortYouTubeDemonstration: "https://youtu.be/hBC7lPyEkVM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Straight Bar High Bicep Curl",
    shortYouTubeDemonstration: "https://youtu.be/xaMJYDzqTZg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Spider Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/9Dd8iiEUs_Q?si=juy6zuf-MVn-W8j8",
    inDepthYouTubeExplanation: "https://youtu.be/nvufDW-MSQk",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Spider Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/wtbHEt6Qi8g?si=wca7IhWcGWNDg2QX",
    inDepthYouTubeExplanation: "https://youtu.be/BsE9zhhTU1A",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Cable Preacher Curl",
    shortYouTubeDemonstration: "https://youtu.be/uEjtuyC6-bc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "Cable",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Standing Concentration Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/fOV-z1wARvs?si=pxr3u-XyVhL6BlD3",
    inDepthYouTubeExplanation: "https://youtu.be/bbFFdxcAYiw",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Wide Grip Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/xUdw3EtnTLM?si=6zj86RhHEsTUIlf4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Cable Standing High Bicep Curl",
    shortYouTubeDemonstration: "https://youtu.be/shIYFhPQVSo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Seated Overhead Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/QGK3RQ_Eexc?si=2Go8XA5nbKIfwUBr",
    inDepthYouTubeExplanation: "https://youtu.be/priRWVpDV8c",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Overhead Tricep Extension",
    shortYouTubeDemonstration: "https://youtu.be/99qXUnFuQdM",
    inDepthYouTubeExplanation: "https://youtu.be/xvvN9HZvaBE",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Thruster",
    shortYouTubeDemonstration: "https://youtu.be/aea5BGj9a8Y",
    inDepthYouTubeExplanation: "https://youtu.be/Zvt5-mugUco",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Diamond Push Up",
    shortYouTubeDemonstration: "https://youtu.be/XtU2VQVuLYs",
    inDepthYouTubeExplanation: "https://youtu.be/J0DnG1_S92I",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "EZ Bar Lying Tricep Extension ",
    shortYouTubeDemonstration:
      "https://youtu.be/fUW3C1lVWkk?si=uxeyIMMcnTpM46fm",
    inDepthYouTubeExplanation: "https://youtu.be/FrutSwqK5fQ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Rope Overhead Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/KvrP8c6eVBc?si=1EP-aMrXRtcbPO6b",
    inDepthYouTubeExplanation: "https://youtu.be/XTerYx0kwQ8",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Cable Reverse Grip Tricep Pushdown",
    shortYouTubeDemonstration:
      "https://youtu.be/pXd8vm-ZSOA?si=8_iZ3618RVjOmu3S",
    inDepthYouTubeExplanation: "https://youtu.be/ebtopenullQ4",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Reverse Grip Bicep Curl",
    shortYouTubeDemonstration: "https://youtu.be/aIrvcBlNHBA",
    inDepthYouTubeExplanation: "https://youtu.be/nRgxYX2Ve9w",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Single Arm Dumbbell Chest Press",
    shortYouTubeDemonstration: "https://youtu.be/EQlfrWvaU6w",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Face Pull",
    shortYouTubeDemonstration: "https://youtu.be/3FVZDVJnvIA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Landmine V Grip Row",
    shortYouTubeDemonstration: "https://youtu.be/gnikveF7dgI",
    inDepthYouTubeExplanation:
      "https://youtu.be/9hSQVBHLOX0?si=7vUXasQb6975_SHL",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Thruster",
    shortYouTubeDemonstration: "https://youtu.be/u3wKkZjE8QM",
    inDepthYouTubeExplanation: "https://youtu.be/cPzfRo_jti0",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Thruster",
    shortYouTubeDemonstration: "https://youtu.be/03aX4h5-EkA",
    inDepthYouTubeExplanation: "https://youtu.be/o1wfP7nTCqg",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Landmine Row",
    shortYouTubeDemonstration: "https://youtu.be/tiETx7VNDf0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Superband Assisted Bar Pull Up",
    shortYouTubeDemonstration:
      "https://youtu.be/__TzXC-Hc_4?si=Z59SDF6EfXOY4pa_",
    inDepthYouTubeExplanation:
      "https://youtu.be/4yE-XGDWJPg?si=3XGTgo0KrcE1Rl3M",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "Pull Up Bar",
    CountSecondaryItems: 1,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Stability Ball Prone Cobra",
    shortYouTubeDemonstration:
      "https://youtu.be/qt1WWg8QDg8?si=Go7eAWcyWu13yBIi",
    inDepthYouTubeExplanation: "https://youtu.be/tJNfWBGDVSI",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Erector Spinae ",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Postural",
  },
  {
    name: "Single Arm Dumbbell Overhead Carry",
    shortYouTubeDemonstration: "https://youtu.be/Pvs-dT7KPh4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Pendlay Row",
    shortYouTubeDemonstration: "https://youtu.be/4-Jz3c_u1dw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Straight Bar Pullover",
    shortYouTubeDemonstration:
      "https://youtu.be/SgzJGLlAtok?si=p2bo--kETp2ajVVX",
    inDepthYouTubeExplanation: "https://youtu.be/Lf6pcq7zy28",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Cable Half Kneeling Lat Pulldown",
    shortYouTubeDemonstration: "https://youtu.be/4QDCC2gU5_E",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Cable Half Kneeling Low Row",
    shortYouTubeDemonstration: "https://youtu.be/redrpTwkplw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Suspension Low Row",
    shortYouTubeDemonstration:
      "https://youtu.be/wH4TXGV8UyA?si=N8Y8Uk0A9glEeeuQ",
    inDepthYouTubeExplanation: "https://youtu.be/aN2TnxS_ekQ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Anti-Rotational",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Incline Bench Prone Row",
    shortYouTubeDemonstration: "https://youtu.be/93ZAdx24QVQ",
    inDepthYouTubeExplanation: "https://youtu.be/2LxN3_3atps",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Pendlay Row",
    shortYouTubeDemonstration: "https://youtu.be/ezrZnmjZTR4",
    inDepthYouTubeExplanation: "https://youtu.be/ZlRrIsoDpKg",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Bench Press",
    shortYouTubeDemonstration: "https://youtu.be/SCVCLChPQFY",
    inDepthYouTubeExplanation: "https://youtu.be/rxD321l2svE",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Powerlifting",
  },
  {
    name: "Cable Single Leg Standing Bent Knee Hip External Rotation",
    shortYouTubeDemonstration: "https://youtu.be/1OnBBhiaQjY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Hip Rotation",
    shortYouTubeDemonstration: "https://youtu.be/ApvO0XTFjRc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/BVrlItPBX8M?si=4NJpARumV7sAFCki",
    inDepthYouTubeExplanation: "https://youtu.be/bAWLx7PPK10",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/43GSKivZnw4?si=OIfasYK8gG4sUDBW",
    inDepthYouTubeExplanation: "https://youtu.be/8dacy5hjaE8",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Push Press",
    shortYouTubeDemonstration: "https://youtu.be/iaBVSJm78ko",
    inDepthYouTubeExplanation: "https://youtu.be/a8HQo8z20Uo",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/9Gf-Ourup_k?si=qt-DlqHLDICtOmju",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Landmine Meadows Row",
    shortYouTubeDemonstration: "https://youtu.be/e-c4gMcqdyw",
    inDepthYouTubeExplanation: "https://youtu.be/EsmIWi_0lio",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Straight Bar Seated Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/iWyvxI5A1cA?si=aBSi-dGZ6CxySnnU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Rope Skull Crusher",
    shortYouTubeDemonstration: "https://youtu.be/NfOLyLpoGII",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Seated Cuban Press",
    shortYouTubeDemonstration:
      "https://youtu.be/KxPNCVXkvAg?si=pDMoju9bpHN_T9_7",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Wall Facing Handstand",
    shortYouTubeDemonstration: "https://youtu.be/yHuLx1J9orw",
    inDepthYouTubeExplanation: "https://youtu.be/FZFkX5of5Vg",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Close Grip Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/hDH5pliNKoM?si=NTV941Sjf3NsUGDj",
    inDepthYouTubeExplanation:
      "https://youtu.be/mFrDht6JkIs?si=DTh4N2l9pfjJET2z",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Wide Push Up",
    shortYouTubeDemonstration: "https://youtu.be/UEZy-OmXdZs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Front Raise",
    shortYouTubeDemonstration: "https://youtu.be/DL-HN35sxdg",
    inDepthYouTubeExplanation: "https://youtu.be/Ofo2DQdT7DA",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Cable Front Raise",
    shortYouTubeDemonstration: "https://youtu.be/acozHQv1JLk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Parallette Side Plank",
    shortYouTubeDemonstration: "https://youtu.be/d7PGNbhmQVM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Lateral Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Cable Straight Bar Front Raise",
    shortYouTubeDemonstration: "https://youtu.be/PgSZlX32WTo",
    inDepthYouTubeExplanation: "https://youtu.be/wxzEul89zR0",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Close Grip Bench Press",
    shortYouTubeDemonstration: "https://youtu.be/XEFDMwmrLAM",
    inDepthYouTubeExplanation: "https://youtu.be/cXbSJHtjrQQ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Cable Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/Pu5p6uZGTZM?si=MoB-YCpKDesQD9Nn",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Cable Shotgun Row",
    shortYouTubeDemonstration:
      "https://youtu.be/91nVZ7FLPyA?si=_khiKXF3khjyeuSP",
    inDepthYouTubeExplanation: "https://youtu.be/AuiREVMldIw",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Half Kneeling Face Pull",
    shortYouTubeDemonstration:
      "https://youtu.be/_1ATOXmanEw?si=7DN0OJcZ8jGgOQxp",
    inDepthYouTubeExplanation: "https://youtu.be/tfUo4ebRcpk",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Double Dumbbell W Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/BnLUcAR6bpE",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 2,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Bent Over Row",
    shortYouTubeDemonstration: "https://youtu.be/9Q9gwoXHn1o",
    inDepthYouTubeExplanation: "https://youtu.be/bZ4h1Bqw-to",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Anti-Rotational ",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Gorilla Row",
    shortYouTubeDemonstration: "https://youtu.be/Ln1j7lm6SrE",
    inDepthYouTubeExplanation: "https://youtu.be/6nyznu2WKbc",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Alternating Halo",
    shortYouTubeDemonstration: "https://youtu.be/wJcmanVh5EE",
    inDepthYouTubeExplanation: "https://youtu.be/PJTIftBgGVk",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Medial Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up Horn Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Single Arm Kettlebell Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/CwhbuoGqyug?si=Q9nkDUY4NvpGPqak",
    inDepthYouTubeExplanation: "https://youtu.be/IlMFcqpg1T8",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Bicep Curl",
    shortYouTubeDemonstration: "https://youtu.be/YzTfq9VaQKs",
    inDepthYouTubeExplanation: "https://youtu.be/KLvGXRo56iQ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Prone Row",
    shortYouTubeDemonstration: "https://youtu.be/scf3uLuAATg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Z Press",
    shortYouTubeDemonstration: "https://youtu.be/6GbGvGvedOc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Push Press",
    shortYouTubeDemonstration: "https://youtu.be/ekNrVv6G5v8",
    inDepthYouTubeExplanation: "https://youtu.be/4DAzffDFYzc",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Prone Row",
    shortYouTubeDemonstration: "https://youtu.be/pJzThQgKKxw",
    inDepthYouTubeExplanation: "https://youtu.be/CL-lV9E94Fs",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Cuban Press",
    shortYouTubeDemonstration: "https://youtu.be/XsV_KH5Xrng",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Push Jerk",
    shortYouTubeDemonstration: "https://youtu.be/pRfJwVHLp6c",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/2jFFCy8JBU8?si=BCYplSL2-ewJ8kiB",
    inDepthYouTubeExplanation: "https://youtu.be/SrqOu55lrYU",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Tall Kneeling Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/2nJsZIScaVk",
    inDepthYouTubeExplanation:
      "https://youtu.be/YxhDufCVPCE?si=J1eGoIkEExg-7WbL",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Incline Bench Prone Y Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/x4PRrxvYtwk?si=arNJc-zXL0vatJmL",
    inDepthYouTubeExplanation: "https://youtu.be/CNRRurCQJK8",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Pull",
    laterality: "Bilateral",
    primaryExerciseClassification: "Postural",
  },
  {
    name: "Suspension Face Pull to Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/a33rvhoBWYM",
    inDepthYouTubeExplanation: "https://youtu.be/XS3rSeTHpUs",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Reverse Grip Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Cb5ZNB7Vf-0?si=_wFvEZ4u-wYsUhzm",
    inDepthYouTubeExplanation: "https://youtu.be/g8OD0teBMb8",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Cable Seated Floor Lat Pulldown",
    shortYouTubeDemonstration: "https://youtu.be/N7FcfA7UFZk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Carry",
    shortYouTubeDemonstration: "https://youtu.be/p5MNNosenJc",
    inDepthYouTubeExplanation: "https://youtu.be/rt17lmnaLSM",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Resistance Band Half Kneeling Cuban Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/JO0zKzQSCIE",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Upper Trapezius",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Cuban Press",
    shortYouTubeDemonstration:
      "https://youtu.be/XpcOM9Np9LQ?si=p-JIsZ-J0LYgrnEO",
    inDepthYouTubeExplanation: "https://youtu.be/oQJoK0a3h44",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Upper Trapezius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Pendlay Row",
    shortYouTubeDemonstration: "https://youtu.be/KoOmLu7ms1s",
    inDepthYouTubeExplanation:
      "https://youtu.be/RBo0_6-W8d0?si=ZfmECTbG0tTw3W4a",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Half Kneeling Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/ZcUxxxNl1PA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Push Press",
    shortYouTubeDemonstration: "https://youtu.be/KUsZAGWd0VQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Push Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/U2w1H0oXhhg?si=OkR2U3VpYiRe81Eo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Glute Bridge Isometric Floor Press",
    shortYouTubeDemonstration: "https://youtu.be/195-8CoZDgo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Seesaw Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/55-ngw6hplo",
    inDepthYouTubeExplanation: "https://youtu.be/7Pnein1QoCk",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Double Kettlebell Z Press",
    shortYouTubeDemonstration:
      "https://youtu.be/DmC9vPYvU0g?si=mIpOJCXLUo_un5rT",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Burpee",
    shortYouTubeDemonstration: "https://youtu.be/auBLPXO8Fww",
    inDepthYouTubeExplanation: "https://youtu.be/wS4OsJ4yzx4",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Devil Press",
    shortYouTubeDemonstration:
      "https://youtu.be/SCOxIkPDqxM?si=JHtcK8O5k4voNCP2",
    inDepthYouTubeExplanation: "https://youtu.be/Cwxmji-3k40",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Single Arm Dumbbell Devil Press",
    shortYouTubeDemonstration: "https://youtu.be/l6_aD2IWEEA",
    inDepthYouTubeExplanation: "https://youtu.be/yJU2Iip-RZ8",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Seesaw Z Press",
    shortYouTubeDemonstration: "https://youtu.be/n54YmZS9uM4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Plate Lu Raise",
    shortYouTubeDemonstration: "https://youtu.be/IeGDlglTK9M",
    inDepthYouTubeExplanation: "https://youtu.be/FfDy-4HN_PU",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Infraspinatus",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Other",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Plate Steering Wheel",
    shortYouTubeDemonstration:
      "https://youtu.be/ToHy85wT3KE?si=z9VmwQGWt8A86_Mc",
    inDepthYouTubeExplanation: "https://youtu.be/ZIKA1pdTkKM",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: "Rotational",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Cuban Press",
    shortYouTubeDemonstration:
      "https://youtu.be/ybVFLdr1_Vk?si=NGTNOkq-xBRDhbIF",
    inDepthYouTubeExplanation: "https://youtu.be/3roHcWpe8Lc",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Horizontal Pull",
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Decline Bench Press",
    shortYouTubeDemonstration: "https://youtu.be/6yGZ0KCaiWM",
    inDepthYouTubeExplanation: "https://youtu.be/LfyQBUKR8SE",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Half Kneeling Alternating Halo",
    shortYouTubeDemonstration: "https://youtu.be/A2jT86tgnII",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Medial Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up Horn Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Kettlebell Tall Kneeling Alternating Halo",
    shortYouTubeDemonstration:
      "https://youtu.be/9n3nSrJiuFE?si=oGT50V2Fg6jzr5X2",
    inDepthYouTubeExplanation: "https://youtu.be/FfDy-4HN_PU",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Medial Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up Horn Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Bodyweight Rolling Squat Burpee",
    shortYouTubeDemonstration: "https://youtu.be/phmcox-C8iA",
    inDepthYouTubeExplanation: "https://youtu.be/_q7JUuOVKS4",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Kettlebell Tall Kneeling Alternating Hip to Halo",
    shortYouTubeDemonstration: "https://youtu.be/4frRMFUlaFs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Medial Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up Horn Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Barbell Seated Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/Mdx1V3v7E5g",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Z Press",
    shortYouTubeDemonstration: "https://youtu.be/_othSKjqF30",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Half Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/HdsS7MO_KFs?si=6N85JwB13t24ha7T",
    inDepthYouTubeExplanation:
      "https://youtu.be/7uR7EFXk3Fk?si=EB7RkKIUXgoKeFik",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Tall Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/j2slieruHx0?si=qsnkz69oUwDeE0hp",
    inDepthYouTubeExplanation:
      "https://youtu.be/XTerH-QeCSg?si=Zp_4mKUx_ILMyqu1",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Inverted Row",
    shortYouTubeDemonstration: "https://youtu.be/bHO0A4ZF_Zg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Row",
    shortYouTubeDemonstration: "https://youtu.be/xhlReCpAE9k",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Slider Single Arm Kettlebell Suitcase Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/DS-pvuh8VEo?si=KEDC31EUxCubFjGj",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Front Rack Contralateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/iRHrBseKm0k?si=X-TqbB38SGkCSqnE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Bulgarian Row",
    shortYouTubeDemonstration: "https://youtu.be/5CxPrNkhm2k",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Alternating Double Kettlebell Rotational Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/VQKcF1HfsYk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Push Press",
    shortYouTubeDemonstration: "https://youtu.be/kUgzuCAvO3A",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Tall Kneeling Face Pull",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/VGOZVVlarfg",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Macebell Ballistic Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/e8aZdfRK4FE?si=VtO52sSIMj0T-KCF",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Mixed Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Indian Club Outer Heart Shaped Swing",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Indian Club",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: null,
    laterality: "Unilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Single Arm Clubbell Pullover",
    shortYouTubeDemonstration:
      "https://youtu.be/JJgOmmqZneM?si=v93qv5Poy03NJqj_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: "Triceps Brachii",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Clubbell Pullover",
    shortYouTubeDemonstration:
      "https://youtu.be/2ZYphWzJedw?si=f5GGOhThihsKqIds",
    inDepthYouTubeExplanation:
      "https://youtu.be/d6x6YACiUx8?si=KOdxdmqhKdBF07lE",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: "Triceps Brachii",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Pullover",
    shortYouTubeDemonstration:
      "https://youtu.be/0sRFLvzcqxw?si=cqK8W0uEQdEUfDAy",
    inDepthYouTubeExplanation:
      "https://youtu.be/jpIn1Sumg78?si=l1eFqwf4PiMMc7cV",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: "Triceps Brachii",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Front Flag Press",
    shortYouTubeDemonstration:
      "https://youtu.be/3_F4oUpYY7Q?si=qgoqjkcK33CSqmX4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Indian Club Inner Heart Shaped Swing",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Indian Club",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: null,
    laterality: "Unilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Single Arm Ring Dead Hang",
    shortYouTubeDemonstration:
      "https://youtu.be/7J_x9uMtr-o?si=2tga8qG4urWcSCMT",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Teres Major",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Dumbbell Suitcase Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/yMRbcOd51pA?si=7Hc1xBgOqKKuKw3C",
    inDepthYouTubeExplanation:
      "https://youtu.be/9ksPiTU64tI?si=UWk89dqzB8OjLE0A",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Front Rack Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/7wCLqLLyHh0?si=hFc7L_yPlG-KnZVg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Torch Press",
    shortYouTubeDemonstration:
      "https://youtu.be/REUDhFnYMYc?si=13Shwx4VKvuvNLZh",
    inDepthYouTubeExplanation:
      "https://youtu.be/ZLwgEO6J89U?si=L6zaRYpDOG7rBE6z",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Clubbell Torch Press",
    shortYouTubeDemonstration:
      "https://youtu.be/UU4WhE25JfI?si=6sinMuju_2nUhgZK",
    inDepthYouTubeExplanation:
      "https://youtu.be/KFluTacbjKU?si=8mY0r8-MlBTvBADs",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Clubbell Torch Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Conventional Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/op9kVnSso6Q",
    inDepthYouTubeExplanation: "https://youtu.be/p2OPUi4xGrM",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Powerlifting",
  },
  {
    name: "Barbell Sumo Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/wQHSYDSgDn8",
    inDepthYouTubeExplanation: "https://youtu.be/cDlOSfu-zHY",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Powerlifting",
  },
  {
    name: "Barbell Rack Pull",
    shortYouTubeDemonstration: "https://youtu.be/zdaEWO0S5HU",
    inDepthYouTubeExplanation: "https://youtu.be/cxVrqTqD_J4",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Snatch Grip Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/0Ah-ol5EGlo",
    inDepthYouTubeExplanation: "https://youtu.be/GP6VNoIZyF4",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Clubbell Torch Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Hyperextension",
    shortYouTubeDemonstration: "https://youtu.be/bmRTtzOOiVM",
    inDepthYouTubeExplanation: "https://youtu.be/QpIyEK1C8Ig",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Erector Spinae ",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Seated Good Morning ",
    shortYouTubeDemonstration: "https://youtu.be/ZPeJ0s8X6Gs",
    inDepthYouTubeExplanation: "https://youtu.be/cJWYiUkiWrE",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Erector Spinae ",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Good Morning",
    shortYouTubeDemonstration: "https://youtu.be/F8dCjzbed-4",
    inDepthYouTubeExplanation: "https://youtu.be/f23vXjoG2e8",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Erector Spinae ",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Wall Sit ",
    shortYouTubeDemonstration: "https://youtu.be/SszDMOZvFuw",
    inDepthYouTubeExplanation: "https://youtu.be/y-wV4Venusw",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Wall Sit",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Wall Slide Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/3J99J5NxNSQ?si=Xv_W-o9GzT-nvtVQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Wall Slide Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/lWJ6BujsDYY?si=Hl4kTZutf9b6tDUi",
    inDepthYouTubeExplanation: "https://youtu.be/NFpVxugZ1E0",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/MafftY-3lC0?si=bGTlr29qg0ZvBtT_",
    inDepthYouTubeExplanation:
      "https://youtu.be/ViV9wM5aGPg?si=d4iDv53YNJSLeN5e",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Alternating Reverse Lunge",
    shortYouTubeDemonstration: "https://youtu.be/oRO4ailwZb4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Squat to Bench",
    shortYouTubeDemonstration: "https://youtu.be/93l0NGCosAE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Squat",
    shortYouTubeDemonstration: "https://youtu.be/C_VtOYc6j5c",
    inDepthYouTubeExplanation:
      "https://youtu.be/X8DnpBl7Hwk?si=-pUtkTHlnl_1sYvs",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Hand Assisted Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/WRCsxtCfrEE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Walking Lunge",
    shortYouTubeDemonstration: "https://youtu.be/tlbTz6IamaE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Squat ",
    shortYouTubeDemonstration: "https://youtu.be/a-dqF4NL2K4",
    inDepthYouTubeExplanation: "https://youtu.be/9W5KAqHfDe8",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Romanian Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/N5lBa2zMAPI?si=Eth4HWtKMOXBXNx6",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Superband Resisted Skater Jump",
    shortYouTubeDemonstration: "https://youtu.be/VHBOyCCupJ4?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/H1TXiC15RjY?si=n58yKnjoyFajJhvm",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Cable Prone Single Leg Hamstring Curl",
    shortYouTubeDemonstration: "https://youtu.be/k6Vo8hBLypQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Candlestick Roll Up Tuck Jump",
    shortYouTubeDemonstration: "https://youtu.be/BpwGQP8k7aY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Single Arm Clubbell Front Flag Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Clubbell Front Flag Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Block Pull Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/iVpVk8x-VDQ",
    inDepthYouTubeExplanation: "https://youtu.be/jfSxbT-65ow",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Box Back Squat",
    shortYouTubeDemonstration: "https://youtu.be/dLG78_Z9rjM",
    inDepthYouTubeExplanation: "https://youtu.be/Ua4OMLUJoOk",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Deficit Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/PzoxegwRlOw",
    inDepthYouTubeExplanation: "https://youtu.be/hnuPZZfeRzs",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Squat",
    shortYouTubeDemonstration: "https://youtu.be/uYumuL_G_V0",
    inDepthYouTubeExplanation: "https://youtu.be/e8zyw3fXZes",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Glute Bridge",
    shortYouTubeDemonstration: "https://youtu.be/6EhYj5eSngY",
    inDepthYouTubeExplanation: "https://youtu.be/rTqhhHfooxg",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Halting Deadlift",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/0LrH7uHRGxI",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell High Bar Back Squat",
    shortYouTubeDemonstration: "https://youtu.be/ultWZbUMPL8",
    inDepthYouTubeExplanation: "https://youtu.be/SW_C1A-rejs",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Low Bar Back Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/nhoikoUEI8U",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Powerlifting",
  },
  {
    name: "Alternating Double Clubbell Front Flag Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Power Clean",
    shortYouTubeDemonstration: "https://youtu.be/KwYJTpQ_x5A",
    inDepthYouTubeExplanation: "https://youtu.be/5vVSGITznQk",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Power Snatch",
    shortYouTubeDemonstration: "https://youtu.be/TL8SMp7RdXQ",
    inDepthYouTubeExplanation: "https://youtu.be/Aq8Tp5r-DZo",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Double Indian Club Lateral Internal and External Rotations",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Indian Club",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Lateral",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: null,
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Barbell Romanian Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/LURGDIX3adY?si=fHh3AAX-mZB09HXi",
    inDepthYouTubeExplanation: "https://youtu.be/XowKMitOVNc",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Indian Club Lateral Internal and External Rotation",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Indian Club",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Lateral",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: null,
    laterality: "Unilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Barbell Back Rack Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/KXUJxb8hO8U",
    inDepthYouTubeExplanation:
      "https://youtu.be/8nW4ZwKi4gk?si=ArwV6SL5pdH_cg-v",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Stiff Legged Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/5_t0SsovgW8?si=5Zg1x855TTmrp1cL",
    inDepthYouTubeExplanation: "https://youtu.be/3bCEilt6FqU",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Sumo Back Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/qiQAsB0x-7k?si=OlWu0ou6Vr0NnuvE",
    inDepthYouTubeExplanation: "https://youtu.be/E_VDwURp8as",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Pistol Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/qDcniqddTeE?si=G4KPahZUmlQQChZ_",
    inDepthYouTubeExplanation: "https://youtu.be/hHxm3VbuS-w",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Skater Squat",
    shortYouTubeDemonstration: "https://youtu.be/kRnLZadW5Q0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Cable Pull Through",
    shortYouTubeDemonstration:
      "https://youtu.be/NEDrQPoITMc?si=ZeJ1LOUbzrjgk-_8",
    inDepthYouTubeExplanation: "https://youtu.be/DbSF7ipBh5Y",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Bulgarian Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/G0Mo2LF8uLU",
    inDepthYouTubeExplanation: "https://youtu.be/JLEyaXRMv8o",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Step Up",
    shortYouTubeDemonstration: "https://youtu.be/37tVohr7LcE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Deficit Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/jqWAqPQvqAk",
    inDepthYouTubeExplanation: "https://youtu.be/YoCOCWeWzaI",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Alternating Forward Lunge",
    shortYouTubeDemonstration: "https://youtu.be/t7DBjlOTwAk",
    inDepthYouTubeExplanation: "https://youtu.be/D7KaRcUTQeE",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Alternating Reverse Lunge",
    shortYouTubeDemonstration: "https://youtu.be/Lsen4vH1nm8",
    inDepthYouTubeExplanation: "https://youtu.be/sjlsISvHyZs",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Indian Club Overhead Arm Circles",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Lateral Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Indian Club",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: null,
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Double Dumbbell Suitcase Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/yqH8u037IjM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Alternating Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/anHX8Zp67C8?si=qbb7ETCqekLaflB_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Face the Wall Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/pktIjwNiuYE?si=fWFt85clM0T2gopP",
    inDepthYouTubeExplanation: "https://youtu.be/qoL6FUSrZNY",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Feet Elevated Glute Bridge",
    shortYouTubeDemonstration: "https://youtu.be/kFvF6ZHv-KI",
    inDepthYouTubeExplanation: "https://youtu.be/eSSloIyhHUw",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Bottoms Up Front Rack Contralateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Bottoms Up Front Rack Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Overhead Contralateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Overhead Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Bottoms Up Overhead Contralateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Bottoms Up Overhead Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Kettlebell Goblet Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/8k08cvYq-n8?si=bbPqV1XKB99kPfpP",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Thigh Monster Walk",
    shortYouTubeDemonstration:
      "https://youtu.be/po3I8qoRC2c?si=XeJ7Tq5PXt3WLJfl",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Quadruped Hip Extension",
    shortYouTubeDemonstration: "https://youtu.be/1UwyzWjFx5k",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Quadruped",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Pistol Squat",
    shortYouTubeDemonstration: "https://youtu.be/K7qfUjKf9rU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Suspension Skater Squat",
    shortYouTubeDemonstration: "https://youtu.be/YyBeT4WWBk4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bodyweight Tuck Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/vgB_eWuvGW8?si=anQ4gfG2ik-Y_uU9",
    inDepthYouTubeExplanation: "https://youtu.be/r7oBejx1PHM",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Bodyweight Alternating Single Leg Wall Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/eYGszeFcI7Y?si=jFOFuzza1JQMYuVE",
    inDepthYouTubeExplanation: "https://youtu.be/baj5XhEEblU",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Single Leg Romanian Deadlift Jump",
    shortYouTubeDemonstration: "https://youtu.be/EmmP-jsvVJE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Double Dumbbell Overhead Walking Lunge",
    shortYouTubeDemonstration: "https://youtu.be/TBw3mPrKAIs",
    inDepthYouTubeExplanation: "https://youtu.be/iVbJda5rvUI",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Double Dumbbell Suitcase Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 2,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Reverse Nordic",
    shortYouTubeDemonstration:
      "https://youtu.be/GbpDfXXKuk0?si=IsPMd_J3d72xrMcZ",
    inDepthYouTubeExplanation: "https://youtu.be/01-EDOql4zI",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Alternating Lateral Bench Jump",
    shortYouTubeDemonstration: "https://youtu.be/pVoOtkGBN6s",
    inDepthYouTubeExplanation: "https://youtu.be/KJ1WSHe6cTQ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Single Arm Dumbbell Front Rack Squat",
    shortYouTubeDemonstration: "https://youtu.be/1VzKnqCcUJ4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Skater Jump",
    shortYouTubeDemonstration: "https://youtu.be/CaN4zfIPyXU",
    inDepthYouTubeExplanation: "https://youtu.be/9_jLW6VkU8A",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Slider Single Arm Dumbbell Front Rack Contralateral Reverse Lunge",
    shortYouTubeDemonstration: "https://youtu.be/t8OkcdLjRFQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Prone Bench Hamstring Curl",
    shortYouTubeDemonstration: "https://youtu.be/IalP0lgYPnc",
    inDepthYouTubeExplanation: "https://youtu.be/Atl5qhOfJpQ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Bulgarian Split Squat Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/CWTu90BUTIY?si=9JSuKmfFRaalZ6er",
    inDepthYouTubeExplanation:
      "https://youtu.be/z_0Uf9HPvtk?si=nhG8RWSjcCmhVgMW",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Cable Standing Single Leg Hamstring Curl",
    shortYouTubeDemonstration: "https://youtu.be/tkh43Yc0tEs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Nordic Hamstring Curl",
    shortYouTubeDemonstration: "https://youtu.be/kjv4WQXWl_A",
    inDepthYouTubeExplanation: "https://youtu.be/yfBOocr2fHA",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Assisted Pistol Squat",
    shortYouTubeDemonstration: "https://youtu.be/szRINrcALyI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Slider Double Kettlebell Bottoms Up Front Rack Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Squat",
    shortYouTubeDemonstration: "https://youtu.be/B86Zj72LwzA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Walking Lunge",
    shortYouTubeDemonstration: "https://youtu.be/KdE6b_r7wxA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Walking Lunge",
    shortYouTubeDemonstration: "https://youtu.be/ZPoMxOrIeO4",
    inDepthYouTubeExplanation: "https://youtu.be/X9QswJmhBQI",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Box Pistol Squat",
    shortYouTubeDemonstration: "https://youtu.be/Ly71LeprFKQ",
    inDepthYouTubeExplanation: "https://youtu.be/3gzzuPJzrUE",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Overhead Squat",
    shortYouTubeDemonstration: "https://youtu.be/pn8mqlG0nkE",
    inDepthYouTubeExplanation: "https://youtu.be/Ow58yHEl_Ls",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Double Kettlebell Bottoms Up Overhead Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Goblet Squat",
    shortYouTubeDemonstration: "https://youtu.be/oTRl7p13XtY",
    inDepthYouTubeExplanation: "https://youtu.be/qigKC-U81Z4",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Hamstring Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/d-FBclT8W0g?si=wl1sJCzk2Z5PCnwx",
    inDepthYouTubeExplanation: "https://youtu.be/WNB90xXLEOg",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Hamstring Curl",
    shortYouTubeDemonstration: "https://youtu.be/UaecXxAgsKA",
    inDepthYouTubeExplanation: "https://youtu.be/TKSOQvvYW00",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Hamstring Walkout ",
    shortYouTubeDemonstration:
      "https://youtu.be/GcV2LB0qqnY?si=PoIiYCAOL0uaDuPR",
    inDepthYouTubeExplanation: "https://youtu.be/EbOE-ATUND4",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Dumbbell Goblet Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/tWmzgpoOUls?si=Fmrp6-y_e5qk2SNJ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Dragon Squat",
    shortYouTubeDemonstration: "https://youtu.be/bQY7fLEkZqU",
    inDepthYouTubeExplanation: "https://youtu.be/Pic8epzj1N4",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Stability Ball Single Leg Hamstring Curl",
    shortYouTubeDemonstration: "https://youtu.be/cuM7OBHSVow",
    inDepthYouTubeExplanation: "https://youtu.be/e3EeeA6L3YQ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Single Leg Romanian Deadlift",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/-IaQkgdQgfM",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Lateral Lunge",
    shortYouTubeDemonstration: "https://youtu.be/HLDhxSqMQyE",
    inDepthYouTubeExplanation: "https://youtu.be/qCA8E-dF8cI",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Zombie Walking Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/SQYG5QRpYDQ",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Walking Lunge",
    shortYouTubeDemonstration: "https://youtu.be/m6MczOv_Ayg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Squat Clean",
    shortYouTubeDemonstration: "https://youtu.be/EKRiW9Yt3Ps",
    inDepthYouTubeExplanation: "https://youtu.be/FXd9p5bryPU",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Single Arm Landmine Split Clean to Split Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/BjIh4n3UI9Y?si=dbrubdXZ7d9MRYDw",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Landmine Hack Squat",
    shortYouTubeDemonstration: "https://youtu.be/hwd_6Y9YKvI",
    inDepthYouTubeExplanation: "https://youtu.be/4pC9DKPGklo",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Indian Club Lateral Arm Circles",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Lateral Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Indian Club",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Lateral",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: null,
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Resistance Band Shoulder Dislocates",
    shortYouTubeDemonstration:
      "https://youtu.be/5yPvjJOqbg4?si=1OYvLb1R7Zq_hl94",
    inDepthYouTubeExplanation:
      "https://youtu.be/2Yvkc77evN0?si=VEM5C0oL2fIS5eiY",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Supraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Lateral",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Suspension Reverse Grip Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/yewf3adybcc?si=-PZ9RsGl7FC8vp7J",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Straight Bar Reverse Grip Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/RLlT3qbVS3Q?si=SYASKBhplBkTNYee",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Cable Reverse Grip Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/SIuDkLLlL6E?si=_Y_P-I5PU4GP5LRy",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bar Eccentric Chin Up ",
    shortYouTubeDemonstration:
      "https://youtu.be/B1nRr__KiNk?si=5PGKtxdEbPpVW1Ds",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Eccentric Pull Up",
    shortYouTubeDemonstration:
      "https://youtu.be/T4Jv__fWjZ8?si=sbUarOu5VD7qBK4s",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Landmine Half Kneeling Oblique Twist ",
    shortYouTubeDemonstration: "https://youtu.be/HGzu8tvh79U",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Bar Dead Hang",
    shortYouTubeDemonstration:
      "https://youtu.be/uyNR71ZCrho?si=blbw-wn6NHBGbR9y",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Teres Major",
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Tall Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/UF_oINIojVQ?si=nyrZ0y91pz4IIfOs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Tall Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/2kWWWRpk6Co?si=gy0bI1KIAsGs2hhI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Half Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/V3wxOSo53mQ?si=cM14QdTRQfd_FXUt",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Single Arm Forearm Plank",
    shortYouTubeDemonstration: "https://youtu.be/J3JZR2SFknM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: "Anti-Extension",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Feet Elevated Single Arm Forearm Plank",
    shortYouTubeDemonstration: "https://youtu.be/PAFvOAPjKwk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: "Anti-Extension",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Landmine Zercher Skater Squat",
    shortYouTubeDemonstration: "https://youtu.be/avCA3xXb9hg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Landmine Front Rack Contralateral Reverse Lunge to Shoulder Press",
    shortYouTubeDemonstration: "https://youtu.be/h2bPSv9ka_o",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Landmine Thruster",
    shortYouTubeDemonstration: "https://youtu.be/jLvQenjeus8",
    inDepthYouTubeExplanation: "https://youtu.be/9f0TrDK9hFY",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Romanian Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/x5wWyQ-2k2E?feature=shared",
    inDepthYouTubeExplanation: "https://youtu.be/Xv2rjss2fns",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Landmine Single Leg Romanian Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/rzJse5Ds98k",
    inDepthYouTubeExplanation: "https://youtu.be/DikpefBtnUU",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Tall Kneeling Oblique Twist",
    shortYouTubeDemonstration: "https://youtu.be/OCMcVEdK5vw",
    inDepthYouTubeExplanation: "https://youtu.be/KBfH1pPou6o",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Landmine Feet Elevated Russian Twist",
    shortYouTubeDemonstration: "https://youtu.be/Zb-l68-4KFM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Landmine Thruster",
    shortYouTubeDemonstration: "https://youtu.be/EcUficjayCY",
    inDepthYouTubeExplanation: "https://youtu.be/uEdt5g1Slfg",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Tall Kneeling Seesaw Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Ke5Erzd3NjE?si=fOzgTGBaC6CMWfE6",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Arm Bar",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/I8gW4L9tP7Y?si=APnoKbFCOjNOOot5",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Infraspinatus",
    secondaryMuscle: "Subscapularis",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Barbell Power Clean to Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/NwQVfcvesOs",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Single Arm Suspension Mid Row",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Zercher Curtsy Lunge",
    shortYouTubeDemonstration: "https://youtu.be/e7jkuKuWcZ0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Alternating Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/YZQP6D9LP4E",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Alternating Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/_AEuTTkYzjg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Kettlebell Overhead Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Alternating Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/glbP_VzHNkw?si=1k1fGSYRRORQv7W8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Alternating Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/dhDjKmTX8tU",
    inDepthYouTubeExplanation: "https://youtu.be/iyKPbKf2jik",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Knee Over Toe Split Squat ",
    shortYouTubeDemonstration: "https://youtu.be/ufsoFnFCqA4",
    inDepthYouTubeExplanation: "https://youtu.be/g6KrlrOq4mw",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Knee Over Toe Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/RBcrPYSWQb8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Knee Over Toe Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/q7zJZAexRmc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Incline Bench Lying Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/vJuyPyyEdTs?si=_MMem5dVaaarfRRu",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/eiCMrII3j9k?si=J2G1ZmeiFQDhnfxT",
    inDepthYouTubeExplanation: "https://youtu.be/jR7Y5YcugYc?feature=shared",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Knee Tuck",
    shortYouTubeDemonstration:
      "https://youtu.be/vx9j9l18pyE?si=U7boXKing8U74cQZ",
    inDepthYouTubeExplanation: "https://youtu.be/ViOihbu9BAA",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "EZ Bar Incline Bench Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/9VtEoirFmT8?si=B904_aTFyPDoEqMp",
    inDepthYouTubeExplanation:
      "https://youtu.be/kcvdV0LkhUk?si=98a25GEiRSrIoAlZ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Decline Bench Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/XFBsHDastRI?si=rP6H63ZVPOndCThK",
    inDepthYouTubeExplanation:
      "https://youtu.be/OpRLGph7El8?si=TrvfwVCRT_bFWs6t",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Front Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/N4HLFIr5H4A?si=l2WKwgNX9fExG7xF",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Pike",
    shortYouTubeDemonstration: "https://youtu.be/MkmpHj0T3OQ",
    inDepthYouTubeExplanation: "https://youtu.be/COXMyJ5WQwk",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Side Plank Reach Through",
    shortYouTubeDemonstration: "https://youtu.be/9PiqAsdkh6Q",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Lateral Flexion",
    MovementPatternCount2: "Spinal Rotational",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Cocoon Crunch",
    shortYouTubeDemonstration:
      "https://youtu.be/BZWoijzyF_4?si=2gKtoX0oa_Lef7o8",
    inDepthYouTubeExplanation: "https://youtu.be/hONrtSx_eiM",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ab Wheel Standing Rollout",
    shortYouTubeDemonstration: "https://youtu.be/SFTn_VON9qw",
    inDepthYouTubeExplanation: "https://youtu.be/2zVNyi5Uk44",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Ab Wheel",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Fire Hydrant",
    shortYouTubeDemonstration: "https://youtu.be/P4cP-juNM1Q",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Quadruped",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Tall Kneeling Pull Through",
    shortYouTubeDemonstration: "https://youtu.be/5mkpuBI-2Ls",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Bent Knee Reverse Hyperextension",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/UOtzPdmg2Ow",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Bent Knee Reverse Hyperextension",
    shortYouTubeDemonstration: "https://youtu.be/RbkVHCMU3xU",
    inDepthYouTubeExplanation: "https://youtu.be/g07fnrRy3mo",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Parallette Tuck L Sit",
    shortYouTubeDemonstration: "https://youtu.be/VhqEdeeAyvg",
    inDepthYouTubeExplanation: "https://youtu.be/KCEMgCjW3iU",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tuck L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "EZ Bar Close Grip Bicep Curl",
    shortYouTubeDemonstration: "https://youtu.be/o1c9wFYt6FA?feature=shared",
    inDepthYouTubeExplanation: "https://youtu.be/zG2xJ0Q5QtI",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/_5VJKCjn8YE?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Parallette Single Leg L Sit",
    shortYouTubeDemonstration: "https://youtu.be/V3hnphPbiAg",
    inDepthYouTubeExplanation: "https://youtu.be/49pZak4cQ_0",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Stability Ball Bottoms Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/FK7FbHmvVfo?si=eonHUTXVko7S7g0w",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Windshield Wiper",
    shortYouTubeDemonstration: "https://youtu.be/tVfP2_HkXEc",
    inDepthYouTubeExplanation: "https://youtu.be/n133Ymrl_as",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Transverse Abdominis",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Tall Kneeling Balance",
    shortYouTubeDemonstration:
      "https://youtu.be/wIkwr6LV9E8?si=WttWmNStYjInstEN",
    inDepthYouTubeExplanation: "https://youtu.be/KtJHKnzoWc0",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Stability Ball Oblique Crunch ",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/1gC-nI0XuZU",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Forearm Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/4xODTD0UL-o?si=TSlUT4Fa309FslEb",
    inDepthYouTubeExplanation: "https://youtu.be/kKVwsBI3CbE",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Double Kettlebell Suitcase Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/bAaaXP2xb8E?si=AOaxE4RzaGKjiq0h",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Kettlebell Horn Grip Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/OsP6_mqxBDI?si=Kdp1ECOmqjUFcNM9",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Turkish Sit Up",
    shortYouTubeDemonstration: "https://youtu.be/h9OYpweuJEc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Landmine Turkish Sit Up",
    shortYouTubeDemonstration: "https://youtu.be/EhYVfy1KUUA",
    inDepthYouTubeExplanation: "https://youtu.be/zxul-J_H0WE",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Front Rack Cyclist Squat",
    shortYouTubeDemonstration: "https://youtu.be/xkL1f4yewf0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Turkish Sit Up",
    shortYouTubeDemonstration: "https://youtu.be/SreLOxzaIX4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Front Rack Cyclist Squat",
    shortYouTubeDemonstration: "https://youtu.be/_FjMUe0AhTY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Cyclist Squat",
    shortYouTubeDemonstration: "https://youtu.be/PSRoSLw3GME",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Alternating Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/JFeG8YiLYmk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Cyclist Squat",
    shortYouTubeDemonstration: "https://youtu.be/TysYZ7rKhpM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Bottoms Up Horn Grip Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Cyclist Squat",
    shortYouTubeDemonstration: "https://youtu.be/x8bLCSXTChA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Seated Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/-MwL_9KOv7U?si=z-KgUayvNC37N78i",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Tall Kneeling Overhead Tricep Extension",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Reverse Grip Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Knee Over Toe Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/2U58iHm7oSM",
    inDepthYouTubeExplanation: "https://youtu.be/4qPJUSczLcM",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Reverse Grip Seated Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Close Grip Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/yoS-cVxq28Q?si=hPjefaZ8jY6Ugoh_",
    inDepthYouTubeExplanation:
      "https://youtu.be/3U94_ZiAwfM?si=owQuwz8PUei66Z27",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Close Grip Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/PEH5Ncie81g?si=F2eXxzjoehGGc9Bb",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Close Grip Decline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/K40CGYdAysc?si=AY-3wTXsp03-uRQ_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Half Kneeling Pallof Press",
    shortYouTubeDemonstration: "https://youtu.be/7JBR6JGE1hY",
    inDepthYouTubeExplanation: "https://youtu.be/DWwI61I1KAM",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Cyclist Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Cyclist Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Cyclist Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Cyclist Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Cyclist Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Bottoms Up Cyclist Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Kneeling Rollout",
    shortYouTubeDemonstration: "https://youtu.be/AEfj6Lnn0Ao",
    inDepthYouTubeExplanation: "https://youtu.be/yBg4UoOXxLo",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Reverse Grip Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/ZO_ALQcMaq4?si=Sv5NmxfQj3aIKU84",
    inDepthYouTubeExplanation:
      "https://youtu.be/IRcBuxf9nz0?si=1k15JKgoNg00FTnQ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Seated Reverse Grip Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Tall Kneeling Pallof Press",
    shortYouTubeDemonstration: "https://youtu.be/EtEPKajf0PE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Tire Sledge Hammer Staggered Stance Slam",
    shortYouTubeDemonstration:
      "https://youtu.be/ykhGpORlJ4Y?si=6hFSwmMbG1lGLXki",
    inDepthYouTubeExplanation:
      "https://youtu.be/wbl7j9LVH7o?si=OWJW5iPxg-e6M6Wh",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "Sledge Hammer",
    CountSecondaryItems: 1,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Tire Macebell Staggered Stance Slam",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "Macebell",
    CountSecondaryItems: 1,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Barbell Hang Power Clean",
    shortYouTubeDemonstration: "https://youtu.be/0aP3tgKZcHQ",
    inDepthYouTubeExplanation:
      "https://youtu.be/qQ8InArxi-Y?si=-assd3pTkI_Px7CJ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting",
  },
  {
    name: "Landmine Goblet Alternating Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/N549md2Wu2A",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Low Hold Alternating Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/PnBI0wLBZIg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/_l3ySVKYVJ8?si=PZh3DAAcRNF9txaZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/IODxDxX7oi4?si=WwbQkUnT1DXcYujC",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Close Grip Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/wbI4qof1454?si=WRjRCDTcll5n5uKu",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Close Grip Decline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/t5TxzynRREU?feature=shared",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Push Press",
    shortYouTubeDemonstration:
      "https://youtu.be/JqztIwOb4Hs?si=89lHhxGXew7SEPqj",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Push Press",
    shortYouTubeDemonstration:
      "https://youtu.be/-TVuoR8URxg?si=RsWhCdjyNahveL9y",
    inDepthYouTubeExplanation:
      "https://youtu.be/hU9cNWJK9L8?si=qOra3Dd7lOnkYz-j",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Double Dumbbell Push Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Kn3oZ9MNAhg?si=j1DYyyohu1ImlWt4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Push Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Rope Tall Kneeling Overhead Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/cDMXXH7Y9AM?si=pObK3p_2FqS0HqbC",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Push Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/4wXnxXq4hX4?si=21E2nrYJROeQgBUm",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Push Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/oWfLP7JFwTg?si=UbP4KHHXrg5hVRnc",
    inDepthYouTubeExplanation:
      "https://youtu.be/RXxbQX1ihj0?si=Ra4nKF2KMetSwmCl",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Double Kettlebell Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/KMKqAY-T3wE?si=DccwyejeKVDgXRV-",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Push Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/r-yDtVg8Yf0?si=XQ5L1OU_VTCHZWRf",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Double Dumbbell Push Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/ZQ653_FImKw?si=O2ttj0r4a_Nbkwq1",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Plate Seated Lu Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Infraspinatus",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Other",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Double Kettlebell Bottoms Up Floor Press",
    shortYouTubeDemonstration:
      "https://youtu.be/BDCAkIEOPvE?si=ouPFKCSuMS-REkBT",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Bottoms Up Floor Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Floor Press",
    shortYouTubeDemonstration:
      "https://youtu.be/uk39UR9K25Y?si=s6ejJf9GtQ4llbjw",
    inDepthYouTubeExplanation:
      "https://youtu.be/nkj1g66OUmU?si=tgMKon5lGlqNBvDB",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/aNllFax4shk?si=J0w79P4ud8wpm67U",
    inDepthYouTubeExplanation:
      "https://youtu.be/nK6CkO2jcB4?si=pwONlFrWB5RqE76C",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Pendlay Row",
    shortYouTubeDemonstration:
      "https://youtu.be/d5rLWfIN9fo?si=iiKqMHW4Xr9OMyaR",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Shrug",
    shortYouTubeDemonstration:
      "https://youtu.be/DjFdFkeXSDM?si=RIA3ok7NhzuAj8LK",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Tuck L Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/U9Z7WWNm1d4?si=pWSS4MOr8iZXWiNj",
    inDepthYouTubeExplanation: "https://youtu.be/K-c1xXiUWJE",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tuck L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Straddle L Sit",
    shortYouTubeDemonstration: "https://youtu.be/F6o417SxU1g",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Turned Out L Sit",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Battle Rope Power Slam",
    shortYouTubeDemonstration:
      "https://youtu.be/7wDx6mZDxA8?si=rDE21yzc81AXz5sw",
    inDepthYouTubeExplanation:
      "https://youtu.be/aZojja9em0I?si=GXfnvmm9KJhQjtqu",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Manna ",
    shortYouTubeDemonstration: "https://youtu.be/L7reIo5f6uo",
    inDepthYouTubeExplanation: "https://youtu.be/5TUXFB7k19w",
    difficultyLevel: "Grand Master",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Other",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Tuck Back Lever",
    shortYouTubeDemonstration: "https://youtu.be/SZV1-ts76CM",
    inDepthYouTubeExplanation: "https://youtu.be/-hdW6N3sEXA",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Advanced Tuck Back Lever",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/7lceZm3XEcM",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Straddle Back Lever",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/5GJB37pP6z8",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Half Lay Back Lever",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Single Leg Out Back Lever",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Full Back Lever",
    shortYouTubeDemonstration: "https://youtu.be/ZFEy1s_N820",
    inDepthYouTubeExplanation: "https://youtu.be/HXaG8mJmSnU",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Trap Bar Floor Press",
    shortYouTubeDemonstration:
      "https://youtu.be/4C4LDf-eZ5A?si=Uh-L_Lu-0xta0H-S",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Vorw1hVd_Dc?si=CRIVCwpCzzeBwN26",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Handstand Lower to Back Lever",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Tuck Front Lever",
    shortYouTubeDemonstration: "https://youtu.be/JxlKAuD9gkA",
    inDepthYouTubeExplanation: "https://youtu.be/eicU_5iBP5U",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Advanced Tuck Front Lever",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/Purt97a2pqE",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Straddle Front Lever",
    shortYouTubeDemonstration: "https://youtu.be/eI-15uPc0yE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Half Lay Front Lever",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Single Leg Out Front Lever",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Full Front Lever",
    shortYouTubeDemonstration: "https://youtu.be/rB9EcLohiVs",
    inDepthYouTubeExplanation: "https://youtu.be/_qNRNyI3qxM",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Front Lever Pull to Inverted Hang",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Inverted Hang",
    shortYouTubeDemonstration: "https://youtu.be/txtXtF2-4S0",
    inDepthYouTubeExplanation: "https://youtu.be/qKjdH5Lan5o",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Barbell Kneeling Rollout",
    shortYouTubeDemonstration: "https://youtu.be/i-JO6pBsKWk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Barbell Standing Rollout",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Circle Front Lever",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Trap Bar Tall Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/ILFSDv6TaiY?si=0iUQUtwUMsGFbVuI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Bench Press",
    shortYouTubeDemonstration: "https://youtu.be/8TIFsF_HU_8?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Z Press",
    shortYouTubeDemonstration:
      "https://youtu.be/dsTU2qm4ef0?si=sT2aw7NxeFtfYYNV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Half Kneeling Ipsilateral Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/xwNijn3wK7I?si=h_QgGtuzq4TYPztT",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Half Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/HZM84steEyw?si=wN3l2SpjKBFPTIbD",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Tall Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/y0t2PFFwSe4?si=VjtJz1Dg61jGQIZ9",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Tall Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/UhOs_Wvckvs?si=FqNmpb8ECh_Y-9rl",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Half Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/12MxAGiIgK8?si=pO89QghXz2Ykj1lb",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Tall Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/QVFklRHtJxY?si=D_kiEaZg-5pSrfHL",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Plate Incline Bench Prone Y Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/VHeZJHEj6ic?si=DTfOrwFveTP-memt",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Pull",
    laterality: "Bilateral",
    primaryExerciseClassification: "Postural",
  },
  {
    name: "Single Arm Kettlebell Pendlay Row",
    shortYouTubeDemonstration: "https://youtu.be/VOmnhGvccZ0?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/4s4dmYTwOok?si=hW7jE6WANr2Iv0QN",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Floor Press",
    shortYouTubeDemonstration:
      "https://youtu.be/YdiVxhxufG8?si=pMAxf531BcAPvatO",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Plank",
    shortYouTubeDemonstration: "https://youtu.be/p3zS2AMqGlg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Ring Plank",
    shortYouTubeDemonstration: "https://youtu.be/_Iev7PLP6QY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: "Anti-Extension",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Battle Rope Alternating Outward Circle",
    shortYouTubeDemonstration:
      "https://youtu.be/O2HVcPD3wKQ?si=CFVI8GpHxTsirv6u",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Battle Rope Alternating Inward Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Support Hold",
    shortYouTubeDemonstration: "https://youtu.be/kONbxg4kzkE",
    inDepthYouTubeExplanation: "https://youtu.be/9PKChU9Ozs8",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Side Plank",
    shortYouTubeDemonstration: "https://youtu.be/PQ3Vz8fp73k",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Lateral Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Reverse Grip Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/cZvQNvTUUu0?si=SqA3lYAZBc0jOnvn",
    inDepthYouTubeExplanation:
      "https://youtu.be/3gdGSSgDby8?si=OyYmh7nuJE7MOd18",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Offset Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/OXl94TQd_vw?si=AMXpvOM-H382GJoz",
    inDepthYouTubeExplanation:
      "https://youtu.be/B5HzEBCUYTA?si=qThbbgj9xsDEnoRy",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Reverse Grip Offset Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/igNnqZZ69JM?si=xaqrnAFrW4r7NuVR",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Single Arm Kettlebell Pendlay Row",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Hollow Body Rock ",
    shortYouTubeDemonstration: "https://youtu.be/p7j02V1fIzU",
    inDepthYouTubeExplanation: "https://youtu.be/hbsljZvfp6E",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Dumbbell Power Snatch",
    shortYouTubeDemonstration: "https://youtu.be/3mlhF3dptAo",
    inDepthYouTubeExplanation: "https://youtu.be/Dc8XQpyly3g",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Single Arm Dumbbell Power Snatch",
    shortYouTubeDemonstration: "https://youtu.be/OktkfRlGcns",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Dumbbell Squat Snatch",
    shortYouTubeDemonstration: "https://youtu.be/etK3OPjM3S4",
    inDepthYouTubeExplanation: "https://youtu.be/PlTCUyVcY0E",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Single Arm Dumbbell Squat Snatch",
    shortYouTubeDemonstration: "https://youtu.be/T0_a2xijJBE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Cable Single Leg Romanian Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/OC_7QIo0uk4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Suitcase Cyclist Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/6caQpfXMvyw?si=WY0XcdcIUuE20g-o",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Cyclist Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/AlxuA22ymwg?si=-tgz7djxN0QKxXfA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Step Up",
    shortYouTubeDemonstration: "https://youtu.be/wcnuhd6RHwE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Incline Bench Prone Row",
    shortYouTubeDemonstration:
      "https://youtu.be/jHpBzpxK16c?si=3sB9wGkke_B632ad",
    inDepthYouTubeExplanation:
      "https://youtu.be/awJJqNd0-9s?si=OSIE0z3se9Z4vj_4",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Incline Bench Prone Row",
    shortYouTubeDemonstration:
      "https://youtu.be/4Bv94e_ufjo?si=8V5SPIIuNai7zUm3",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Spider Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/Ew2ZzKqICfA?si=Irq2jLSDxKiagY3F",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Spider Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/L6XHpSFmVjA?si=BYKjvx0FJ8AIiQ7W",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/STeIzkHm6tE?si=BxEJOKh_KtwNSMK_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Seated Good Morning",
    shortYouTubeDemonstration: "https://youtu.be/x5nnk8hUBo4",
    inDepthYouTubeExplanation: "https://youtu.be/7NMbAV4KPpo",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Erector Spinae",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Hip Thrust",
    shortYouTubeDemonstration: "https://youtu.be/OAhvIWLC0rc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Box Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/mnQtaFcGtv4",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Alternating Double Kettlebell Bottoms Up Incline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/SoVCwno_9z8?si=BCvfBOVPW_aHbvZ_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Incline Bench Prone Row",
    shortYouTubeDemonstration:
      "https://youtu.be/rAoi4_AI7VA?si=b6KXmXEYoxIPmTt2",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Incline Bench Prone Row",
    shortYouTubeDemonstration:
      "https://youtu.be/gPX8OmnYmQY?si=UgQnJkh9n3OobTcZ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Side Plank Reach Through",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Lateral Flexion",
    MovementPatternCount2: "Spinal Rotational",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Dumbbell Overhead Contralateral Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/z7rygloAW30?si=p4kPPZcAKammq1Vv",
    inDepthYouTubeExplanation:
      "https://youtu.be/pEOli_ZdcBs?si=qgD2rL4Mv8km66VS",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Suitcase Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/3HUEab31fks?si=B2OmGKfwSuXhts1z",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Contralateral Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/lMADALbx1eM?si=wJjWrYeLHPKqVgHh",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Ipsilateral Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Contralateral Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Ipsilateral Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/eKUmMljLcKw?si=ocsvBon7ivrRziM6",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Contralateral Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Ipsilateral Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Contralateral Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Ipsilateral Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Contralateral Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Ipsilateral Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Half Kneeling Low to High Chop",
    shortYouTubeDemonstration: "https://youtu.be/wPXdGwc0NTs",
    inDepthYouTubeExplanation: "https://youtu.be/exMSeCF3DJg",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Windmill",
    shortYouTubeDemonstration: "https://youtu.be/3rtUK_jUv4s",
    inDepthYouTubeExplanation: "https://youtu.be/VFHj4FehsfM",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Kettlebell Russian Twist",
    shortYouTubeDemonstration: "https://youtu.be/59_aq7COfts",
    inDepthYouTubeExplanation: "https://youtu.be/SigTyTv0TQQ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Single Arm Kettlebell Plank Pull Through",
    shortYouTubeDemonstration: "https://youtu.be/fKbu_2L94x8",
    inDepthYouTubeExplanation: "https://youtu.be/setqoQC3HAU",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Anti-Rotational ",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Single Leg Standing Bent Knee Around The World ",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/ve60gzLLyzA",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Swing",
    shortYouTubeDemonstration: "https://youtu.be/kneGICiz30g",
    inDepthYouTubeExplanation: "https://youtu.be/BXrXhyudA80",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Suitcase Feet Elevated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/qkK_V6hpQ80?si=HkiTuj2F0YsYYRFZ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Spider Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Bench Press",
    shortYouTubeDemonstration: "https://youtu.be/bIzD1Z_C0cA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/1hcAoywwuRI",
    inDepthYouTubeExplanation:
      "https://youtu.be/d6i6MwVOmk0?si=ecPMnAcU-eh4ENBj",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Clean",
    shortYouTubeDemonstration: "https://youtu.be/TQT7hBXVcOo",
    inDepthYouTubeExplanation: "https://youtu.be/lYh7Kf_lEMY",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Clean to Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/JtlYyc5MaAc",
    inDepthYouTubeExplanation: "https://youtu.be/48qvCvJJr8Y",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Dumbbell Pendlay Row",
    shortYouTubeDemonstration: "https://youtu.be/7zKQ79awAvY?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Bottoms Up Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Snatch",
    shortYouTubeDemonstration: "https://youtu.be/VdNC_xicfyg",
    inDepthYouTubeExplanation: "https://youtu.be/OO7y9cIz0lU",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Kettlebell Sumo Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/odS65TnXgU0?si=l3QM9Nb4wHNt_JgK",
    inDepthYouTubeExplanation:
      "https://youtu.be/yWqIE3v7Rq0?si=4_0xj-bhEgm8WUtF",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Turkish Get Up",
    shortYouTubeDemonstration: "https://youtu.be/sgd8n917Zv0",
    inDepthYouTubeExplanation: "https://youtu.be/Gvc3_o9R6hc",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Kettlebell Goblet Squat",
    shortYouTubeDemonstration: "https://youtu.be/f-Vf2yRRqOg",
    inDepthYouTubeExplanation: "https://youtu.be/fnuHKfySEsU",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Overhead Squat",
    shortYouTubeDemonstration: "https://youtu.be/nrfDq0DUhrE",
    inDepthYouTubeExplanation: "https://youtu.be/pUo1r5kCkhU",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Front Rack Alternating Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/vcMZNgn5G9c",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/NIytPzrQ460?si=hBsVxzSTE6ddOTCD",
    inDepthYouTubeExplanation:
      "https://youtu.be/XqVjldCjnXM?si=TrEPboJXiVhVKoXL",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Turkish Sit Up",
    shortYouTubeDemonstration: "https://youtu.be/KpufjJRtyPc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Turkish Sit Up",
    shortYouTubeDemonstration: "https://youtu.be/RttCwCerCiM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Turkish Sit Up to Z Press",
    shortYouTubeDemonstration: "https://youtu.be/UcLpNnWX8vE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Alternating Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/aJGPHYsiyTM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Swing",
    shortYouTubeDemonstration: "https://youtu.be/fOPqk1FA4HU",
    inDepthYouTubeExplanation:
      "https://youtu.be/P5IFTJySA_s?si=KoI-ApDuiE4q4OJQ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Front Rack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/JoT4bHnzTMw?si=i8z5wbuObKGVIl4_",
    inDepthYouTubeExplanation: "https://youtu.be/wRmiqpizfNM",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Squat",
    shortYouTubeDemonstration: "https://youtu.be/Wqg4NY5XAkU",
    inDepthYouTubeExplanation:
      "https://youtu.be/qZdY8HtHFsc?si=RiJaG2F9J7CzKtcu",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Contralateral Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/-Z8NXAi59SE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Carry",
    shortYouTubeDemonstration: "https://youtu.be/M39871Puz6c",
    inDepthYouTubeExplanation: "https://youtu.be/QFF8xD4BVZw",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Squat Clean",
    shortYouTubeDemonstration: "https://youtu.be/FZ8mMUwnCQs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Prone Row",
    shortYouTubeDemonstration:
      "https://youtu.be/hUG_dolsaPE?si=_fw03cFT8VfLVtzo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/0i2Aa8gV-VY?si=Z7AGqRY1Hod9Fwti",
    inDepthYouTubeExplanation: "https://youtu.be/ruS-NNxgvCU",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Carry",
    shortYouTubeDemonstration: "https://youtu.be/F19T2zGlPGA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Walking Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Walking Lunge",
    shortYouTubeDemonstration: "https://youtu.be/FvSL8slKKHY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Prone Row",
    shortYouTubeDemonstration:
      "https://youtu.be/OD7URB1yHAo?si=UX_3VmEfO_WpeiuT",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Single Leg Romanian Deadlift ",
    shortYouTubeDemonstration: "https://youtu.be/JkKxFADvLvk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Romanian Deadlift ",
    shortYouTubeDemonstration: "https://youtu.be/Xa8hHIwOHe4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Contralateral Single Leg Romanian Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/9u_Fccgk9Ys",
    inDepthYouTubeExplanation: "https://youtu.be/Zfr6wizR8rs",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Squat",
    shortYouTubeDemonstration: "https://youtu.be/j0aAMnMp0yU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Prone Row",
    shortYouTubeDemonstration:
      "https://youtu.be/QSbH7gNkBtc?si=ngxTS90XoTuvQDxs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Parallette Tuck Planche",
    shortYouTubeDemonstration: "https://youtu.be/3WVToPNWjVk",
    inDepthYouTubeExplanation: "https://youtu.be/xw31tXau_4Q",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Other",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Macebell Offset Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/xkyQtEH8fxM?si=Zh1mTKcYEFs382Sk",
    inDepthYouTubeExplanation:
      "https://youtu.be/gdxekHuSe_A?si=TGhgI374D-OSzyyz",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Decline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Parallette L Sit to Tuck Planche",
    shortYouTubeDemonstration: "https://youtu.be/NUvTsZxo5nk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Alternating Double Kettlebell Bottoms Up Decline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Standing Oblique Twist",
    shortYouTubeDemonstration: "https://youtu.be/4dGj7rES9pY",
    inDepthYouTubeExplanation: "https://youtu.be/TynRdGZTtE0",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Rope Tall Kneeling High to Low Chop",
    shortYouTubeDemonstration: "https://youtu.be/h-af-afj-Xg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Parallette Plank",
    shortYouTubeDemonstration: "https://youtu.be/NrkFLTzLuSM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Suspension Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/hetklTC7y4M?si=gHU6ufU8oAcg21Jv",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Battle Rope Russian Twist",
    shortYouTubeDemonstration: "https://youtu.be/_-kclLM0Mak",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Bird Dog Knee to Elbow",
    shortYouTubeDemonstration: "https://youtu.be/1v4_Vsvk3gc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Quadruped",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: "Spinal Rotational",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Transverse Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slam Ball Feet Elevated Russian Twist",
    shortYouTubeDemonstration: "https://youtu.be/W1FXse115qs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Slam Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Medicine Ball Feet Elevated Russian Twist",
    shortYouTubeDemonstration: "https://youtu.be/IdEocZzdUNY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Medicine Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Double Dumbbell Prone Row",
    shortYouTubeDemonstration:
      "https://youtu.be/Ry9HwpfUbd8?si=oY89SBibCyKMJ7CT",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Forearm Plank Alternating Knee to Elbow",
    shortYouTubeDemonstration: "https://youtu.be/A_JgZzr6o-k",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Loaded Beast to Alternating Kick Through",
    shortYouTubeDemonstration: "https://youtu.be/lhh2tGD_47g",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Hover Quadruped",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Animal Flow",
  },
  {
    name: "Single Arm Dumbbell Prone Row",
    shortYouTubeDemonstration:
      "https://youtu.be/-fuxiCQvMxQ?si=lCRmzsfrTeNaP0Gk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Clean",
    shortYouTubeDemonstration: "https://youtu.be/8tFmEJ9ElaM",
    inDepthYouTubeExplanation: "https://youtu.be/26GZTfSdz-s",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Snatch",
    shortYouTubeDemonstration: "https://youtu.be/5WNcWPHXRZ0",
    inDepthYouTubeExplanation: "https://youtu.be/73koR_IuoDE",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Battle Rope Feet Elevated Russian Twist",
    shortYouTubeDemonstration: "https://youtu.be/XdKaa2lHuic",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Dead Bug",
    shortYouTubeDemonstration: "https://youtu.be/wCwn7-Z-XjE",
    inDepthYouTubeExplanation: "https://youtu.be/X0s5xY8JZVA",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Rectus Femoris",
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Postural",
  },
  {
    name: "Parallette V Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/oBmFzeay6Z8?si=dliVO8cgoAWNKwT3",
    inDepthYouTubeExplanation: "https://youtu.be/x-kdghat2Fk",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "V Sit Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Dumbbell Pendlay Row",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Decline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Split Jerk",
    shortYouTubeDemonstration: "https://youtu.be/6sbNXcg-R0Y",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell High Pull",
    shortYouTubeDemonstration:
      "https://youtu.be/zfWpy9oMOqc?si=8gZawgsKgTeeGHck&utm_source=MTQxZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/HG1HnSeeSdI?si=d2nqUbvNltb8xPPo&utm_source=MTQxZ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Superband Pallof Press",
    shortYouTubeDemonstration: "https://youtu.be/TvPRtxN8uoA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Half Kneeling Pallof Press",
    shortYouTubeDemonstration: "https://youtu.be/V-SoYj9uQV8",
    inDepthYouTubeExplanation: "https://youtu.be/CRHHSmoakC8",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Single Leg Standing Bent Knee Hip External Rotation",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/z97Mxord2Po",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Macebell Reverse Grip Offset Bicep Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Archer Row",
    shortYouTubeDemonstration:
      "https://youtu.be/s1Cuq185q6Y?si=TNXwSjV_mkE_2ty0",
    inDepthYouTubeExplanation:
      "https://youtu.be/Ws9_paHK0so?si=Kvjudlnfl3VJzrNo",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Landmine Row to Rotational Shoulder Press",
    shortYouTubeDemonstration: "https://youtu.be/f-sh_ImlQUo",
    inDepthYouTubeExplanation: "https://youtu.be/8g61ghscJ1E",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Hand Assisted Skater Squat",
    shortYouTubeDemonstration: "https://youtu.be/DExb7UaAlbg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Superband Pull Through",
    shortYouTubeDemonstration: "https://youtu.be/ZuKowDpVVXM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Quadruped Hip Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/k30hN0vhlsY?si=ycYwNbMrFEnA94pG",
    inDepthYouTubeExplanation: "https://youtu.be/E-Df1V-UP7g",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Quadruped",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Hip Adduction",
    shortYouTubeDemonstration:
      "https://youtu.be/UyXncDziNGo?si=W4GuZaUvoWtiIOxj",
    inDepthYouTubeExplanation: "https://youtu.be/FUEq2RqJrbU",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Tall Kneeling Pallof Press",
    shortYouTubeDemonstration:
      "https://youtu.be/yUzjX1LdySo?si=2LpxjTl8N8OHsKqd",
    inDepthYouTubeExplanation: "https://youtu.be/y30uEJhBTwQ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Eccentric Hamstring Curl",
    shortYouTubeDemonstration: "https://youtu.be/vcCVej7p_vc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Landmine Low Hold Lateral Lunge",
    shortYouTubeDemonstration: "https://youtu.be/VTtLrBvHoJ8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Sumo Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/4m288BpgfcQ",
    inDepthYouTubeExplanation:
      "https://youtu.be/gdutIla6nMw?si=Gq1r56mRXADNUek8",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Kneeling Reach Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/-RTSF7qbrhs?si=hznPEKw9aLONjGpz",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Parallette Knee Tuck",
    shortYouTubeDemonstration:
      "https://youtu.be/Kj89v76f-l8?si=_B0Uc1Xs1x1S0G_M",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "Parallette Bars",
    CountSecondaryItems: 2,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Shoulder Dislocates",
    shortYouTubeDemonstration:
      "https://youtu.be/MPtMYQH9vvg?si=eEJrNr3oqGzcma8_",
    inDepthYouTubeExplanation:
      "https://youtu.be/7p-Ma0eksaY?si=rh6O8a5TM3cyJUZs",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Supraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Lateral",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Superband Alternating Shoulder Dislocates",
    shortYouTubeDemonstration:
      "https://youtu.be/AJmPEWu4FiM?si=0h2x72A-kGfK3a_0",
    inDepthYouTubeExplanation:
      "https://youtu.be/hpJMDIEvASE?si=V8jVpmYmJTwle2iV",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Supraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Lateral",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Superband Prone Shoulder Dislocates",
    shortYouTubeDemonstration:
      "https://youtu.be/3WOAWkEKZGA?si=lSddj94elx-N7ZKJ",
    inDepthYouTubeExplanation:
      "https://youtu.be/i5F56-jByo8?si=9agL2UoRzpWwVu-u",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Supraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Lateral",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Ring L Sit",
    shortYouTubeDemonstration: "https://youtu.be/lwcHmXvw-T4",
    inDepthYouTubeExplanation: "https://youtu.be/2kMkNFRbLJQ",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Resistance Band Prone Shoulder Dislocates",
    shortYouTubeDemonstration:
      "https://youtu.be/YwELfevh5vs?si=tmPYSbe-vfbiD0vx",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Supraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Lateral",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Resistance Band Alternating Shoulder Dislocates",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Supraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Lateral",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Cable Straight Bar Spider Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/zGyaLrwHJjs?si=sg4m9llWui7pmOT_",
    inDepthYouTubeExplanation:
      "https://youtu.be/djsZsACOtLY?si=uZjb73qcrYm7jmCs",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Squat",
    shortYouTubeDemonstration: "https://youtu.be/IvN-CSDnvoc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Cyclist Squat",
    shortYouTubeDemonstration: "https://youtu.be/TT7Ra3TnlZY",
    inDepthYouTubeExplanation: "https://youtu.be/aoNyKjQvegs",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Gravity Boots Inverted Sit Up",
    shortYouTubeDemonstration: "https://youtu.be/AN4MBtCsJqo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Gravity Boots",
    CountSecondaryItems: 1,
    posture: "Inverted",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Front Rack Knee Over Toe Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/G7e7EenICzQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Step Up",
    shortYouTubeDemonstration: "https://youtu.be/uQGRzdjxHes",
    inDepthYouTubeExplanation: "https://youtu.be/bH8c6ladt1M",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Step Up",
    shortYouTubeDemonstration: "https://youtu.be/YR_7r6EzJdA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Standing Rollout",
    shortYouTubeDemonstration: "https://youtu.be/_lI_GB0DI3o",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Cable Russian Twist",
    shortYouTubeDemonstration: "https://youtu.be/4ESBjh2BcdE",
    inDepthYouTubeExplanation: "https://youtu.be/yckjJqPMyaY",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "Cable",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Miniband Frog Pump",
    shortYouTubeDemonstration: "https://youtu.be/rzjQ8XpXt1Q",
    inDepthYouTubeExplanation: "https://youtu.be/GLF9UVx0nPw",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Knee Hover Quadruped Fire Hydrant",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Hover Quadruped",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip External Rotation",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Fire Hydrant",
    shortYouTubeDemonstration: "https://youtu.be/IFrN8GELc-k?feature=shared",
    inDepthYouTubeExplanation: "https://youtu.be/La3xYT8MGks",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Quadruped",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Knee Hover Quadruped Fire Hydrant",
    shortYouTubeDemonstration:
      "https://youtu.be/8nmBvZ1DkKQ?si=RUcdU_JPDGU_yIWv",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Hover Quadruped",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip External Rotation",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Dumbbell Crush Grip Spider Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Spider Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/KznrM_RhXDc?si=Qxgmd-eTnFuZ5rpo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Bent Knee Copenhagen Plank Side Raise",
    shortYouTubeDemonstration: "https://youtu.be/xkcOhvzzta0",
    inDepthYouTubeExplanation: "https://youtu.be/kD1t1hWzIDE",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Side)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Kneeling Side Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/PAHxwhBVsYY?si=pym-tzPNwmH8zNeP",
    inDepthYouTubeExplanation: "https://youtu.be/3FhVhuvZgjc",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Lateral Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Wall Assisted Hip Airplane",
    shortYouTubeDemonstration:
      "https://youtu.be/20R2FqNUBsA?si=3Nuvhsgux27gQFjW",
    inDepthYouTubeExplanation: "https://youtu.be/1N2DSsVG2Ww",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Hip External Rotation",
    MovementPatternCount3: "Hip Internal Rotation",
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Single Leg Tibialis Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/fAf6Z7wu7fM?si=6K5_014ZCoGfknf8",
    inDepthYouTubeExplanation: "https://youtu.be/SBrHvR0BomM",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shins",
    primeMoverMuscle: "Tibialis Anterior",
    secondaryMuscle: "Extensor Digitorum Longus",
    tertiaryMuscle: "Extensor Hallucis Longus",
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Dorsiflexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Zercher Squat",
    shortYouTubeDemonstration: "https://youtu.be/nwx6Ip7hd3I",
    inDepthYouTubeExplanation: "https://youtu.be/eIMAXB7xy58",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Squat Snatch",
    shortYouTubeDemonstration: "https://youtu.be/9xQp2sldyts",
    inDepthYouTubeExplanation: "https://youtu.be/VMaBfcRprAU",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Alternating Double Kettlebell Spider Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Squat Clean to Split Jerk",
    shortYouTubeDemonstration: "https://youtu.be/PjY1rH4_MOA",
    inDepthYouTubeExplanation: "https://youtu.be/gsadb9nH2BY",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Slider Kneeling Alternating Reach Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/1UD0dTGE04w?si=q2odI18mbdJTtPDF",
    inDepthYouTubeExplanation:
      "https://youtu.be/oYUVkU3sTlU?si=BucGpPP9NcSfH6Sn",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Hang Squat Clean to Thruster",
    shortYouTubeDemonstration: "https://youtu.be/8DApihgXzGk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Squat Clean to Thruster",
    shortYouTubeDemonstration: "https://youtu.be/4qZWqKDAhkQ",
    inDepthYouTubeExplanation: "https://youtu.be/QC9_VE75gEg",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Copenhagen Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/tKb76R21AfM?si=zsuYyzMMfjZleCpc",
    inDepthYouTubeExplanation:
      "https://youtu.be/VfjAmomtVa0?si=I2iiPw_V8fZbgJ9j",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Side)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Bent Knee Copenhagen Plank",
    shortYouTubeDemonstration: "https://youtu.be/obtdLUWZi-Y",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Side)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Clubbell Inside Pullover",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/DQg80eX08hg?si=LmF-paCX4u8uFLO7",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: "Triceps Brachii",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Miniband Single Leg Hip Thrust",
    shortYouTubeDemonstration: "https://youtu.be/tPWyj85zsmg",
    inDepthYouTubeExplanation: "https://youtu.be/jemVr8d_LPc",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Deficit Snatch Grip Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/s_Cx_ElOuQs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Outside Pullover",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/sJ5XCgdCMx8?si=VIRgX4J73IavMF93",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: "Triceps Brachii",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Hand Assisted Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/hTBEkHf8GmA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/Gu4qA5TevLU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Thruster",
    shortYouTubeDemonstration: "https://youtu.be/5-mxMxigTfw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Cossack Squat Thruster",
    shortYouTubeDemonstration: "https://youtu.be/DbKGRbkQ80E",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Alternating Cossack Squat Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Landmine Shrug",
    shortYouTubeDemonstration:
      "https://youtu.be/I_qhTOdNkHo?si=7wY3icLNd-TkFk5i",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Walking Lunge",
    shortYouTubeDemonstration: "https://youtu.be/Xmfx1eZMKmY",
    inDepthYouTubeExplanation: "https://youtu.be/ARBkmwST4Nc",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Walking Lunge",
    shortYouTubeDemonstration: "https://youtu.be/hcQJcKxc240",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Seated Steering Wheel",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: "Rotational",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Parallette L Sit to Handstand",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/iCR95j-MbjY",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Straddle L Sit",
    shortYouTubeDemonstration: "https://youtu.be/pjk0vGe9YRU",
    inDepthYouTubeExplanation: "https://youtu.be/_XDh5e-fXSg",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Seesaw Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/VWnVBfRkLXE?si=AeN6Q9aAnShqxuIb",
    inDepthYouTubeExplanation:
      "https://youtu.be/EzIk1bCZuSA?si=DZpWtAFem_lmtn7n",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Half Kneeling Seesaw Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/UiY-JIpmt24?si=ox4YNd9xIIVapyeB",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Seesaw Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Seesaw Incline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Seesaw Decline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Seesaw Floor Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Tall Kneeling Seesaw Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Lk0xszw7Tf8?si=GHtFcn5OVifRVyDQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Half Kneeling Seesaw Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/NP4p_SWAgnA?si=VoTKPhBbaaWrrYZH",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Seesaw Z Press",
    shortYouTubeDemonstration:
      "https://youtu.be/L_Y8osw78lA?si=3eK1QuOTlQjCzAxO",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Sit Up",
    shortYouTubeDemonstration:
      "https://youtu.be/7L90imlW0es?si=gY7k7XVC43IRrv-N",
    inDepthYouTubeExplanation: "https://youtu.be/3aQXaB4PU_A",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: "Other",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: null,
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "EZ Bar Wide Grip Strict Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/j83lzC2E4Ss?si=PcoF092JVJRpg8T4",
    inDepthYouTubeExplanation:
      "https://youtu.be/woGKGe7SmDo?si=GyL0qA4fJDmEfsf6",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Squat Clean",
    shortYouTubeDemonstration: "https://youtu.be/6wyxpVY8PQ0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Hollow Body Hold",
    shortYouTubeDemonstration: "https://youtu.be/do1yf3NMXdg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Double Dumbbell Incline Bench Prone Row",
    shortYouTubeDemonstration:
      "https://youtu.be/xkCR2CkkL1g?si=Qy0YPAcCasZF6kNk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Side Lying Hip Adduction",
    shortYouTubeDemonstration:
      "https://youtu.be/UW52u8OaWhw?si=WdEOpAR_PSB9x9bR",
    inDepthYouTubeExplanation: "https://youtu.be/y4BmebZvZRE",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Lying",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Hollow Body Hold",
    shortYouTubeDemonstration: "https://youtu.be/8QRsSJ-Ny8M",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Parallette Freestanding Handstand Push Up",
    shortYouTubeDemonstration: "https://youtu.be/3FYYo6lP-dw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Slider Single Leg Eccentric Hamstring Curl ",
    shortYouTubeDemonstration: "https://youtu.be/yAOulKW0al4",
    inDepthYouTubeExplanation: "https://youtu.be/dE5d39sErBU",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Freestanding Handstand Push Up",
    shortYouTubeDemonstration: "https://youtu.be/aAErmRDDJKY",
    inDepthYouTubeExplanation: "https://youtu.be/3I_vcrmE0a0",
    difficultyLevel: "Master",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Ring Grip Push Up",
    shortYouTubeDemonstration: "https://youtu.be/CXVqHGLmb3Q",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Superband Side Plank Hanging Hip Adduction",
    shortYouTubeDemonstration: "https://youtu.be/JG0Ay2QDVbI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Strap Bulgarian Handstand Push Up",
    shortYouTubeDemonstration: "https://youtu.be/ZNCupJIYP6M",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Freestanding Handstand Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Stability Ball Feet Elevated Frog Pump",
    shortYouTubeDemonstration: "https://youtu.be/Rc5e-DsD--M",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Hollow Body Flutter Kicks",
    shortYouTubeDemonstration: "https://youtu.be/HOQeoz3zQeo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Overhead Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Cyclist Squat",
    shortYouTubeDemonstration: "https://youtu.be/IU_0IBe4G9w",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Dead Clean to Push Press",
    shortYouTubeDemonstration: "https://youtu.be/NAZ9uF9S_wk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Bodyweight Bent Arm Press Handstand",
    shortYouTubeDemonstration: "https://youtu.be/Gzz3ku70W3I",
    inDepthYouTubeExplanation: "https://youtu.be/5E_yYi0OsPw",
    difficultyLevel: "Master",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Cyclist Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Parallette L Sit to Bent Arm Press Handstand",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/6wfu8QHBYZU",
    difficultyLevel: "Master",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Alternating Single Arm Landmine Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/woG921FLD3E",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Cyclist Thruster",
    shortYouTubeDemonstration: "https://youtu.be/2Tt0XZ2pZyE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Single Arm Landmine Cyclist Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Low Bar Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/ExJCssj4YV0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Bulgarian Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/Q3yDIeMfdNg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Squat",
    shortYouTubeDemonstration: "https://youtu.be/2Pk8jmse6vY",
    inDepthYouTubeExplanation: "https://youtu.be/nGXtan2AQ8Q",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Chest Roll to Straight Body Press Handstand",
    shortYouTubeDemonstration:
      "https://youtu.be/mYQAYnr2hlg?si=gqlNGvKWytXXQP1H",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Overhead Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Bent Arm Bent Body Press Handstand",
    shortYouTubeDemonstration: "https://youtu.be/TxkC9nrvOho",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Sumo Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/1XyV5eNL1z0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Dip to Handstand",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Handstand to Elbow Lever to Handstand",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Dip Straight Body Press to Handstand",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Kettlebell Swing",
    shortYouTubeDemonstration: "https://youtu.be/1cVT3ee9mgU",
    inDepthYouTubeExplanation: "https://youtu.be/Buz6gaVzVZs",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Swing",
    shortYouTubeDemonstration:
      "https://youtu.be/WK4ughYoUEI?si=2mvQ9x0jZEF2zzRA",
    inDepthYouTubeExplanation: "https://youtu.be/FCcKJ78k7mQ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Clean",
    shortYouTubeDemonstration: "https://youtu.be/dPN2mj5R2S8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Snatch",
    shortYouTubeDemonstration: "https://youtu.be/0aq5EW0euvA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Ring Straight Arm L Sit Straddle Press Handstand",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Staggered Stance Swing",
    shortYouTubeDemonstration: "https://youtu.be/L2WY5gYUb1U",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Alternating Staggered Stance Swing",
    shortYouTubeDemonstration: "https://youtu.be/Ss7KjOjCpVU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Half Kneeling Swing",
    shortYouTubeDemonstration: "https://youtu.be/QVvrdVbq9qs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Outside Swing",
    shortYouTubeDemonstration: "https://youtu.be/zrvtXpwVTOI",
    inDepthYouTubeExplanation: "https://youtu.be/_Uy18LZ5sI0",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Outside Half Snatch",
    shortYouTubeDemonstration: "https://youtu.be/Fx-qV1dHGi4?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Outside Clean",
    shortYouTubeDemonstration: "https://youtu.be/QtlvLhVFR40",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Side Swing",
    shortYouTubeDemonstration: "https://youtu.be/YBJnavxcbUA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Kettlebell Feet Elevated Russian Twist",
    shortYouTubeDemonstration: "https://youtu.be/59_aq7COfts",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Half Kneeling Windmill",
    shortYouTubeDemonstration: "https://youtu.be/wjYNzITBDqg",
    inDepthYouTubeExplanation: "https://youtu.be/J-o8tNSX9c0",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Double Kettlebell Front Rack Skater Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/9uTU2zneGOE",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Kettlebell Horn Grip Skater Squat",
    shortYouTubeDemonstration: "https://youtu.be/q1TuasYdM2M",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Front Rack Pistol Squat",
    shortYouTubeDemonstration: "https://youtu.be/-A7yvmUv8Cw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Ring Straight Arm Pike Press Handstand",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Hollow Body Flutter Kicks",
    shortYouTubeDemonstration:
      "https://youtu.be/JGY8VuvaEHc?si=LVWYZO5Qt-3WONJf",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Back Lever Pullout",
    shortYouTubeDemonstration:
      "https://youtu.be/FRBr2pomeOM?si=15TQvL3xIskTVzVA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Clean to Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/5Fx69TRWARc",
    inDepthYouTubeExplanation: "https://youtu.be/3OaK-lDtCY4",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Kettlebell Alternating Halo to Horn Grip Bottoms Up Squat",
    shortYouTubeDemonstration: "https://youtu.be/-0FIWmBbo9U",
    inDepthYouTubeExplanation: "https://youtu.be/tOAZDLFzdLE",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring German Hang Pullout",
    shortYouTubeDemonstration: "https://youtu.be/J34xkKOc9GI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Dead Hang to Front Lever Pull Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Side to Side Swing",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/yQUYjqDvvfM",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Turkish Get Up",
    shortYouTubeDemonstration: "https://youtu.be/jpgvV6wdXVw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Other",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Single Arm Kettlebell Thruster",
    shortYouTubeDemonstration: "https://youtu.be/vBkzGpZSEF4",
    inDepthYouTubeExplanation: "https://youtu.be/Ze3wxz5T640",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Thruster",
    shortYouTubeDemonstration: "https://youtu.be/AeK6i-5gvJ0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Dead Clean to Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/EF4ep3h5Olk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Tactical Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/lWVxdK_AT2s?si=lgWC5CSMGVpQHo9t",
    inDepthYouTubeExplanation:
      "https://youtu.be/naeEChhh35k?si=gh_bPVUaHXDIi46R",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Snatch to Overhead Contralateral Reverse Lunge",
    shortYouTubeDemonstration: "https://youtu.be/oReUJtUlMGU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Snatch to Overhead Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/VpURrAKPhcE?si=gSYbC8kpIa5xMxr8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Clean to Front Rack Contralateral Reverse Lunge",
    shortYouTubeDemonstration: "https://youtu.be/oqjLx5Injps",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Clean to Front Rack Alternating Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/GcELFmMN8Aw?si=W3EMe0pdjq0WSGKA",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Ring Full Front Lever Pull Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/DoB6uv4u_ZI",
    difficultyLevel: "Master",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Split Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/DeoexkyNuns?si=WrruI69jETw4SBe-",
    inDepthYouTubeExplanation: "https://youtu.be/boJdXRtiEAQ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Parallette Stalder Press to Handstand",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/629s2UN88ic",
    difficultyLevel: "Master",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Bottoms Up Clean to Front Rack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Ring Chin Up",
    shortYouTubeDemonstration:
      "https://youtu.be/S22n8oqcDSY?si=GFs-J_IAwjttVe0y",
    inDepthYouTubeExplanation: "https://youtu.be/_iZhxgcwSNA",
    difficultyLevel: "Master",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Squat",
    shortYouTubeDemonstration: "https://youtu.be/kSlZIksA8XQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Thruster",
    shortYouTubeDemonstration: "https://youtu.be/ZjNbjnGz1Cg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Iron Cross",
    shortYouTubeDemonstration: "https://youtu.be/HZbee93OIdo",
    inDepthYouTubeExplanation: "https://youtu.be/8nbFV-BOEL8",
    difficultyLevel: "Master",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Full Planche Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Straddle Planche Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Dead Hang to Front Lever Pull Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Full Front Lever Pull Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Overhead Bulgarian Split Squat ",
    shortYouTubeDemonstration:
      "https://youtu.be/F_t7_XRdLbs?si=moBf8_s1adbBBwRY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Bulgarian Split Squat Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Barbell Overhead Bulgarian Split Squat ",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Full Planche Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Straddle Planche Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/qgNYrUdn1Oo?si=66l491gj5kmLLjA0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Grip Full Planche Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Legendary",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Two Finger Full Planche Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/CGeBvG5XP7U?si=nGM9dXX2v8dyqJA_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Legendary",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Fingertip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Grip Straddle Planche Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Legendary",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Push Up to Alternating Kick Through",
    shortYouTubeDemonstration: "https://youtu.be/wcBXDGhqnBU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Animal Flow",
  },
  {
    name: "Bodyweight Standing Walkout Push Up ",
    shortYouTubeDemonstration: "https://youtu.be/zR7oQp1Ucq8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Pull Up",
    shortYouTubeDemonstration: "https://youtu.be/cLqkGqiva1M",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Plate Windmill",
    shortYouTubeDemonstration: "https://youtu.be/P-dqLz-r5po",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Single Arm Plate Turkish Get Up",
    shortYouTubeDemonstration: "https://youtu.be/4_RrnWT847k",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Bodyweight Pike Push Up",
    shortYouTubeDemonstration: "https://youtu.be/QIZ6RXq72ZI",
    inDepthYouTubeExplanation: "https://youtu.be/2avz4xI25vQ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Feet Elevated Pike Push Up ",
    shortYouTubeDemonstration: "https://youtu.be/EqXFl_YxF8k",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Sots Press",
    shortYouTubeDemonstration: "https://youtu.be/eJ9MLnNV6FY",
    inDepthYouTubeExplanation: "https://youtu.be/TUTFBXqEgBs",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Other",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Snatch",
    shortYouTubeDemonstration: "https://youtu.be/jcC9NyGLGyg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Bottoms Up Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Around the World High Catch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/FjXW-C3D5oQ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Single Arm Kettlebell Tall Kneeling Around the World High Catch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Around the World",
    shortYouTubeDemonstration:
      "https://youtu.be/6AzrdFj3Qfc?si=52vAx7-XXfvkSz_l",
    inDepthYouTubeExplanation: "https://youtu.be/91citDXgmoE",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Dumbbell Z Press",
    shortYouTubeDemonstration: "https://youtu.be/Ib-8BOyAgTQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Parallette Feet Elevated Push Up",
    shortYouTubeDemonstration: "https://youtu.be/JtBPG6VeJ9Q",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Stability Ball Feet Elevated Diamond Push Up",
    shortYouTubeDemonstration: "https://youtu.be/-2fkjhJfcP8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/O8WGl4_aYTQ?si=eq7Ylf5fkEliBcxD",
    inDepthYouTubeExplanation:
      "https://youtu.be/4UXZtR-rIoY?si=ggITiNWq8ljjXKSJ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Alternating Single Arm Kettlebell Around the World",
    shortYouTubeDemonstration: "https://youtu.be/ekR7MDSWwEQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Tall Kneeling Around the World",
    shortYouTubeDemonstration: "https://youtu.be/9vZ0CU0dHcE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Single Arm Tall Kneeling Around the World",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Waiter Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/fLXYRpxW4FI?si=AjNKRKLLVjzA8Uow",
    inDepthYouTubeExplanation: "https://youtu.be/F86s3FSXoPA",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Waiter Hold",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Waiter Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/eH7w5psLPpk?si=XnO0PygbF5fzKCsm",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Waiter Hold",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Waiter Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/K8atAt0LaTU?si=9XbtgY4Ntm5G8h7v",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Waiter Hold",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Waiter Clean to Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/6yF_kl-76jw?si=rsxf0dRezcQc83ke",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Waiter Hold",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Tactical Waiter Clean",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Waiter Hold",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Waiter Clean to Alternating Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/0WjMjA_4SoE?si=J46etYGhA2sshEat",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Waiter Hold",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Waiter Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Waiter Hold",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Waiter Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Waiter Hold",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Barbell Overhead Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Seated Wrist Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/k6F6ugHyTcA?si=XfnVnbcVgnDkbrFv",
    inDepthYouTubeExplanation: "https://youtu.be/qMtmHwaCmYI",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Wrist Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Dumbbell Hollow Body Chest Press",
    shortYouTubeDemonstration: "https://youtu.be/D82M_YDEGJ8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Tactical Waiter Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Waiter Hold",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Barbell Overhead Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Barbell Knee Over Toe Split Squat Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Knee Over Toe Split Squat Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Waiter Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Waiter Hold",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Waiter Clean to Thruster",
    shortYouTubeDemonstration:
      "https://youtu.be/PX80lILLVhw?si=vmOhrWhU-xCpO4kr",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Waiter Hold",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Kettlebell Start Stop Swing",
    shortYouTubeDemonstration: "https://youtu.be/cZSh_cYNXTw",
    inDepthYouTubeExplanation: "https://youtu.be/37Dw9RQgh3U",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Dead Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/qdMDbLUg9_w?si=9t5V4loMJW5VI5mV",
    inDepthYouTubeExplanation: "https://youtu.be/bET3BJkaYKQ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Barbell Bulgarian Split Squat Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Barbell Windmill",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Bodyweight Windmill",
    shortYouTubeDemonstration:
      "https://youtu.be/87I2gbRgtUI?si=4hUJ0N3X8wu8MMKC",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Superband Isometric Split Squat Pallof Press",
    shortYouTubeDemonstration:
      "https://youtu.be/a4ctQ6GYixo?si=WP2e4CVK5KsFEluY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Barbell Turkish Get Up",
    shortYouTubeDemonstration:
      "https://youtu.be/VAFM8kbz8uA?si=UAPSMjiSnRLN3jl3",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Bodyweight Plate Plyometric Push Up",
    shortYouTubeDemonstration: "https://youtu.be/jmzZ2wQdXao",
    inDepthYouTubeExplanation: "https://youtu.be/zjEHDw569b0",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Single Arm Dumbbell Single Leg Contralateral Bent Over Row",
    shortYouTubeDemonstration: "https://youtu.be/KsEBTYuqemI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Single Leg Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/LrbAy459jkg?si=UDFXUQgUuwN4hkBz",
    inDepthYouTubeExplanation: "https://youtu.be/_ZEIwijWYUA",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Thruster",
    shortYouTubeDemonstration: "https://youtu.be/lbnYFCHrjvk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Bottoms Up Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Dead Clean",
    shortYouTubeDemonstration: "https://youtu.be/Lcm7DcXbm-U",
    inDepthYouTubeExplanation: "https://youtu.be/9OBl-jEPWo4",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Dead Clean",
    shortYouTubeDemonstration: "https://youtu.be/FAtcUX6VxWo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Dumbbell Bird Dog Row",
    shortYouTubeDemonstration: "https://youtu.be/O1mck-Oil5Y",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Quadruped",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Half Kneeling Windmill",
    shortYouTubeDemonstration: "https://youtu.be/U6kn-AypL7c",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Alternating Single Arm Kettlebell Half Kneeling Around the World High Catch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Renegade Row ",
    shortYouTubeDemonstration:
      "https://youtu.be/U_kv9LRu6_I?si=o6wONfSHOO4nrgpy",
    inDepthYouTubeExplanation: "https://youtu.be/4qEIChzM4ZA",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Anti-Extension",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Barbell Overhead Toe Balance Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Toe Balance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Overhead Toe Balance Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Toe Balance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Ring Kneeling Rollout",
    shortYouTubeDemonstration: "https://youtu.be/LMQIG45Wwd8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Ring Kneeling Rollout",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Standing Rollout",
    shortYouTubeDemonstration:
      "https://youtu.be/or7xH0BirKw?si=5oL6x2NsxvCfWaBo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Landmine Shoulder Press",
    shortYouTubeDemonstration: "https://youtu.be/5Cs27w8WVz4",
    inDepthYouTubeExplanation: "https://youtu.be/x071zV-Bo2E",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Single Arm Landmine Shoulder Press",
    shortYouTubeDemonstration: "https://youtu.be/owbzzfb-0PQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Bent Press",
    shortYouTubeDemonstration: "https://youtu.be/xO7fmvTpy3M",
    inDepthYouTubeExplanation: "https://youtu.be/cFmSd61PPTI",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Alternating Single Arm Kettlebell Around the World High Catch to Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Overhead Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/sBuAJggOIxE?si=CST2KlC-8f_fnogp",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Low Switch Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/j9sFzOeMmxY?si=i2yJV3WJb2pBCf0X",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Single Arm Kettlebell Bottoms Up Clean to Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Bottoms Up Clean to Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Landmine Half Kneeling Contralateral Shoulder Press",
    shortYouTubeDemonstration: "https://youtu.be/ORoOn93dnh4",
    inDepthYouTubeExplanation: "https://youtu.be/PY9HorHANhc",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Bulgarian Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/kBQ1krvKFBU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Otis Up",
    shortYouTubeDemonstration: "https://youtu.be/vjAjAERSkIk",
    inDepthYouTubeExplanation: "https://youtu.be/BhtnaHGJa8w",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Overhead Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Pistol Squat",
    shortYouTubeDemonstration: "https://youtu.be/WPIrFREyNaw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Clean to Sots Press",
    shortYouTubeDemonstration: "https://youtu.be/NqZPSUqSJlA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Bottoms Up Clean to Sots Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Landmine Tall Kneeling Shoulder Press",
    shortYouTubeDemonstration: "https://youtu.be/TVTHezj2ZLg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Landmine Z Press",
    shortYouTubeDemonstration: "https://youtu.be/app94pzXOuU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Z Press",
    shortYouTubeDemonstration: "https://youtu.be/D73Oy2m-Uoc",
    inDepthYouTubeExplanation: "https://youtu.be/DkI_hV92ZKg",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Suspension Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/gn5Uy0z5DyY?si=cNwcH7q0lucOSGDX",
    inDepthYouTubeExplanation: "https://youtu.be/fGPVOUKW0-M",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Atomic Push Up",
    shortYouTubeDemonstration: "https://youtu.be/qTD9lWjff84",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Parallette Feet Elevated Close Grip Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Clean to Thruster",
    shortYouTubeDemonstration: "https://youtu.be/J6xUudO95Gc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Archer Push Up",
    shortYouTubeDemonstration: "https://youtu.be/_Qbz_54_9Sw",
    inDepthYouTubeExplanation: "https://youtu.be/A0r8ploEnZY",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Archer Push Up",
    shortYouTubeDemonstration: "https://youtu.be/Wg2mF-GjD10",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Suspension Push Up",
    shortYouTubeDemonstration: "https://youtu.be/PenQnEuayM4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Skin the Cat",
    shortYouTubeDemonstration: "https://youtu.be/ABSpTs17ObA",
    inDepthYouTubeExplanation: "https://youtu.be/2T_wIiM8x8I",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Teres Major",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Contralateral Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Contralateral Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/DGzBcpLm8T4?si=VFc6IG7H7vAlBgxV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Ipsilateral Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/qw7zDXZkB4Q?si=0bcAuexHhPrcw4og",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Suitcase Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/2mDqNOd-Pco?si=MiZ8nJsVAje_rZfb",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bulgarian Split Squat Thruster ",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Bulgarian Split Squat Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Contralateral Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/EMW0urVItYg",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Contralateral Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/3znkWpiyk9c",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Feet Elevated Row",
    shortYouTubeDemonstration: "https://youtu.be/u3XIZSv2Npw",
    inDepthYouTubeExplanation: "https://youtu.be/Re3peup7iSg",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Ipsilateral Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/05ShbqGk2QU",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Feet Elevated Bulgarian Row",
    shortYouTubeDemonstration: "https://youtu.be/k84lpDtf5kQ",
    inDepthYouTubeExplanation: "https://youtu.be/xYQtsjos2Iw",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Feet Elevated Archer Row",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Push Up",
    shortYouTubeDemonstration: "https://youtu.be/u8tOhNwiL70",
    inDepthYouTubeExplanation: "https://youtu.be/QD8yeUtH-QM",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Chest Fly",
    shortYouTubeDemonstration: "https://youtu.be/ytAxGbZ7g80",
    inDepthYouTubeExplanation: "https://youtu.be/1eqKau93EPw",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Feet Elevated Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/kw3ht7nZbXs?si=9ZaHvZoUYJK9H_2w",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Half Kneeling Contralateral Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/DrpIWrG7rl8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Parallette Alternating Shoulder Tap Push Up",
    shortYouTubeDemonstration: "https://youtu.be/NENoxvoyaTw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Dive Bomber Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/tpCOg3ZKn3w?si=e_92TbjIAIy3thZh",
    inDepthYouTubeExplanation: "https://youtu.be/Uvn1s5d0F6g",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Front Rack Bulgarian Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/kz5dpeSigAI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Bulgarian Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/CeNiZ52DzU0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Suspension Contralateral Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Front Rack Alternating Curtsy Lunge",
    shortYouTubeDemonstration: "https://youtu.be/QB9bEZQl6Mg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Dragon Flag",
    shortYouTubeDemonstration:
      "https://youtu.be/LXmJg15hurY?si=kuUaXsoiL3fnTOE7",
    inDepthYouTubeExplanation: "https://youtu.be/3FuwY3Z4ux8",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Front Rack Ipsilateral Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/oeGgMKpKA0w",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Dive Bomber Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/y94uWhVJ3D4?si=TIKacdZm8d8i5e6M",
    inDepthYouTubeExplanation: "https://youtu.be/Uvn1s5d0F6g",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Staggered Stance Push Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Parallette Full Planche",
    shortYouTubeDemonstration:
      "https://youtu.be/v6oj7ImoVP4?si=F3GtqX0vk8YHIyZm",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Dumbbell Renegade Row to Push Up",
    shortYouTubeDemonstration: "https://youtu.be/731lQp2shpY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Horizontal Push",
    MovementPatternCount3: "Anti-Extension",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Inverted Iron Cross",
    shortYouTubeDemonstration: "https://youtu.be/qO5ZqLJD_ZQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Grand Master",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Reverse Grip Front Raise",
    shortYouTubeDemonstration: "https://youtu.be/b2ELsjM9KQQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Tuck Planche",
    shortYouTubeDemonstration: "https://youtu.be/ch0kaD--kIA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Other",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Seated Reverse Grip Wrist Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/FW7URAaC-vE",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Wrist Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Full Planche",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Alternating Single Arm Parallette Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Scapular Pull Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Grip Full Planche",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Grand Master",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Full Planche",
    shortYouTubeDemonstration:
      "https://youtu.be/hTpQCPjYZ3w?si=jlVsTRhe4TDGXMhx",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Cable Quadruped Hip Abduction",
    shortYouTubeDemonstration: "https://youtu.be/MZi0M3OJEVw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Quadruped",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Reverse Grip Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/a9IZD74jAfw?si=-nGBSNLL5nllir0b",
    inDepthYouTubeExplanation: "https://youtu.be/clBGsv573K4",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Turkish Get Up",
    shortYouTubeDemonstration: "https://youtu.be/q4JSQU9lyfs",
    inDepthYouTubeExplanation: "https://youtu.be/ZKUID4S7Hrk",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Single Arm Kettlebell Rotational Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/jtOoPLn8OEQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Spinal Rotational",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Z Press",
    shortYouTubeDemonstration: "https://youtu.be/ygiRarZWXHw",
    inDepthYouTubeExplanation: "https://youtu.be/iDLwdQJreYQ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Parallette Straddle Planche",
    shortYouTubeDemonstration:
      "https://youtu.be/2qWMe_2rlFk?si=MrPXRqDAKW9xxM_5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Sots Press",
    shortYouTubeDemonstration: "https://youtu.be/1znq_EvBvCg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Straddle Planche",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Renegade Row ",
    shortYouTubeDemonstration: "https://youtu.be/SUqsBTSldyk",
    inDepthYouTubeExplanation: "https://youtu.be/KG_JGuhjBeY",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Anti-Extension",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Turkish Sit Up",
    shortYouTubeDemonstration: "https://youtu.be/zCBlmAdxfI0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Plate Turkish Sit Up",
    shortYouTubeDemonstration: "https://youtu.be/A7sXEmRwTQQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Renegade Row to Push Up",
    shortYouTubeDemonstration: "https://youtu.be/i8VL6OjVlCY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Horizontal Push",
    MovementPatternCount3: "Anti-Extension",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Barbell Turkish Sit Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Dumbbell Crush Grip Romanian Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/SozT7TcG-p0?si=8DX3-uViiOfh2BvX",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Half Kneeling Contralateral Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/wlAJN3GzJWA",
    inDepthYouTubeExplanation: "https://youtu.be/xAwVy089Lgg",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Knee Over Toe Split Squat Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Knee Over Toe Split Squat Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Z Press",
    shortYouTubeDemonstration: "https://youtu.be/XFxoHtiGZtw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Z Press",
    shortYouTubeDemonstration: "https://youtu.be/s2hAm9S-6fY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Sots Press",
    shortYouTubeDemonstration: "https://youtu.be/D6UYO_ZbLJ8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Sots Press",
    shortYouTubeDemonstration:
      "https://youtu.be/_Q2mHbn6ggA?si=QGGePHfV1X7MFEdF",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Seesaw Sots Press",
    shortYouTubeDemonstration: "https://youtu.be/L0DwNTS4psM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Hollow Body Flutter Kicks",
    shortYouTubeDemonstration: "https://youtu.be/Btp-pKPfvEU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Seesaw Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/HDzbviKeH8A",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Parallette Crow Pose",
    shortYouTubeDemonstration: "https://youtu.be/JHYVvhWqNzE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Bottoms Up Seesaw Z Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Single Leg Standing Bent Knee Reverse Fly",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Kettlebell Bottoms Up Horn Grip Goblet Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Snatch to Overhead Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Suspension Single Leg Standing Bent Knee Y Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Suspension Single Leg Standing Bent Knee Face Pull",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Half Kneeling Dead Clean",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Barbell Overhead March",
    shortYouTubeDemonstration: "https://youtu.be/NJ4t_HAgJ0M",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Barbell Overhead March",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Half Kneeling Clean",
    shortYouTubeDemonstration: "https://youtu.be/2LM9Y67n6Aw",
    inDepthYouTubeExplanation: "https://youtu.be/e-mFHJIVwYE",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Half Kneeling Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/Ak5wI3oLbjA?si=ZcxpayHQ4EbHkxWD",
    inDepthYouTubeExplanation: "https://youtu.be/guwI1RWTiag",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Front Rack Alternating Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/UnevKvSIDLo?si=Y2g3UwUxqNMlZHdo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/Gj12f62lLeM?si=VhTsZJu7DxtPvx73",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Bottoms Up Horn Grip Toe Balance Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Toe Balance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Dead Clean to Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/8xYUgNA1Hi0?si=B1HQJvZslYYHAgLt",
    inDepthYouTubeExplanation: "https://youtu.be/kIf_x_1uRqs",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Dead Clean to Thruster",
    shortYouTubeDemonstration: "https://youtu.be/3p8swLoH5no",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Suspension Single Leg Standing Bent Knee Face Pull to Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Suspension Single Leg Standing Bent Knee Cuban Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Single Leg Standing Bent Knee Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Dead Snatch",
    shortYouTubeDemonstration: "https://youtu.be/VfKFRnS5FDY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Dead Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/z0tHucwkYgM?si=VThu2f_wRIcFlNP3",
    inDepthYouTubeExplanation: "https://youtu.be/sAzvmUi53qo",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Dead Half Snatch",
    shortYouTubeDemonstration: "https://youtu.be/t8Z9LTj5b6Y",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Slider Barbell Overhead Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Barbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Single Leg Standing Bent Knee Contralateral Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Suspension Single Leg Standing Bent Knee Bicep Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Otis Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Otis Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Kettlebell Horn Grip Otis Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Otis Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Otis Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Staggered Stance Romanian Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/RFuCfiMfJ1w",
    inDepthYouTubeExplanation: "https://youtu.be/Th4QdA2BOyg",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Staggered Stance Romanian Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/UDKuhQqMIBs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Turkish Sit Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Hanging Knees to Elbows",
    shortYouTubeDemonstration: "https://youtu.be/SxLuhaSaPM4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Rectus Femoris",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Plate Teacup",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/7M7IjlFp2IM?si=idag9VrRKqgqJ7UH",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Double Kettlebell Bottoms Up Turkish Sit Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Assisted Nordic Hamstring Curl",
    shortYouTubeDemonstration: "https://youtu.be/4u74sLMSObs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Turkish Sit Up to Z Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Alternating Shin Box Hip Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/UZLEwSROzyQ?si=Pk3NabO_4gvYWivn",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Shin Box Seated",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Single Arm Kettlebell Turkish Sit Up to Z Press",
    shortYouTubeDemonstration:
      "https://youtu.be/FOdI5tm_JZs?si=-JnXwtZzA1jDzCcB",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Turkish Sit Up to Z Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Chin Up",
    shortYouTubeDemonstration: "https://youtu.be/rJiYA9jn3YI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Rotational Thruster",
    shortYouTubeDemonstration: "https://youtu.be/jkbJFWzllH4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: "Vertical Push",
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Dead Clean",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Dumbbell Suitcase Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/mKfCI8ADAjQ?si=ZGUBS2ZPrlbJQKmA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Glute Bridge Isometric Bench Press",
    shortYouTubeDemonstration: "https://youtu.be/CyHxva5XYYY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Dead Clean to Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Dead Clean to Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: "Hip Hinge",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/DgJtQJxYVTk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Isometric Split Squat Oblique Twist",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Back Rack Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Feet Elevated Inverted Row",
    shortYouTubeDemonstration: "https://youtu.be/6AptmglPQ30",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Overhead Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Windmill",
    shortYouTubeDemonstration:
      "https://youtu.be/t9S2E15cyTg?si=pUmpNP-D71uC7XAL",
    inDepthYouTubeExplanation: "https://youtu.be/E6gpvI1pFnY",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Double Kettlebell Dragon Flag",
    shortYouTubeDemonstration: "https://youtu.be/8i1-ngFRLLs",
    inDepthYouTubeExplanation: "https://youtu.be/HYMY8NWRQ4s",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Staggered Stance Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/dnLBRh6bQJQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Front Rack 90/90 Hip Shift to Alternating Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "90/90 Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Kettlebell Dead Bug",
    shortYouTubeDemonstration: "https://youtu.be/pXcG0IH2Nkg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Rectus Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Postural",
  },
  {
    name: "Battle Rope Isometric Split Squat Alternating Side Slam",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Superband Standing Hip Adduction",
    shortYouTubeDemonstration: "https://youtu.be/O2fzFpGvDWI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Lateral Step Hip Adduction",
    shortYouTubeDemonstration: "https://youtu.be/9Ryl38GZHiI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Walking Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Dead Clean to Horn Grip Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/Xo9kEM4A6ao?si=RzutoHlEo0zoz1LZ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack March",
    shortYouTubeDemonstration:
      "https://youtu.be/mLc2zI4rkMQ?si=bYMHmbsvqyX3__ZV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead March",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Suspension Alternating Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/ThQT_AIqcNU?si=Y06NKpeBBOkHRplH",
    inDepthYouTubeExplanation: "https://youtu.be/_qJdwjBx-Wk",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Battle Rope Single Leg Standing Alternating Wave",
    shortYouTubeDemonstration:
      "https://youtu.be/ynczWiOjUqE?si=TWU55ZzVAfcrcb5B",
    inDepthYouTubeExplanation:
      "https://youtu.be/0nLraFkWqsU?si=WC8o5BRxz2YC7X5x",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Superband Assisted Dips",
    shortYouTubeDemonstration:
      "https://youtu.be/QjzY6vf495U?si=dG_1Ixlx0Man-AIC",
    inDepthYouTubeExplanation: "https://youtu.be/a2zGgwyVv38",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Other",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Battle Rope Isometric Split Squat Alternating Wave",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Alternating Single Arm Kettlebell Ballistic Row",
    shortYouTubeDemonstration: "https://youtu.be/ey7YgyPONOk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Pt-6EI8mcEU?si=Lxresx17SBitLvtO",
    inDepthYouTubeExplanation: "https://youtu.be/wfyvigcUtBw?feature=shared",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/sng5EOSZSSo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Tactical Clean",
    shortYouTubeDemonstration: "https://youtu.be/dLyfCN_7JHw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Suspension Cyclist Squat",
    shortYouTubeDemonstration: "https://youtu.be/dzbJzUQjDYA?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/DVSstFJ0D4E?si=WaCS8KtdhuksBcCh",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell 360",
    shortYouTubeDemonstration:
      "https://youtu.be/WMog8YuuVaM?si=WsH2sh1FFH3SBamT",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Suspension Contralateral Skater Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/8pe73RwDAzY?si=ASSfIEGoxhWjeAi_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Macebell 360",
    shortYouTubeDemonstration:
      "https://youtu.be/ITUpuwk3odY?si=KGOrc3k9Flt-oF1v",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Front Rack Pivot Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Pivot Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Pivot Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Cyclist Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/BAlXJ5lLMAA?si=H1cfMWF52YWOMraL",
    inDepthYouTubeExplanation:
      "https://youtu.be/i7THl7npupE?si=HfmpXxeeggFxvNy7",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Half Kneeling Rotational Swing",
    shortYouTubeDemonstration: "https://youtu.be/_ChDukjxUag",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Clean to Push Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/_A6K7V6FHSM?si=uMrzYlHgGYbenNf1",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Clean to Push Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Kettlebell Isometric Split Squat Low to High Chop",
    shortYouTubeDemonstration:
      "https://youtu.be/ECAIMMQDUC4?si=WgJIciK_Kd14WYVj",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up Horn Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Kettlebell Isometric Split Squat Alternating Halo",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Medial Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up Horn Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Front Rack March",
    shortYouTubeDemonstration: "https://youtu.be/aAbVFCqY4Ac",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Suitcase March",
    shortYouTubeDemonstration: "https://youtu.be/i-q8SKGy--Q",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Rotational Half Snatch",
    shortYouTubeDemonstration: "https://youtu.be/KpDxyxOCjCE",
    inDepthYouTubeExplanation:
      "https://youtu.be/PgAfycuKJyg?si=KlE9vGi_ZyvTd543",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Dead Clean to Front Rack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Front Rack Alternating Shin Box Hip Extension",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Shin Box Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Double Kettlebell Overhead Alternating Shin Box Hip Extension",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Shin Box Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Double Kettlebell Bottoms Up Turkish Get Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Slider Single Leg Hamstring Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/MBoaZQwukmw?si=uMFzO0l7TuqVArPp",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Staggered Stance Rotational Swing",
    shortYouTubeDemonstration: "https://youtu.be/4SXAEL7ZdSk?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Suspension Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/wkgihbMp6BY?si=uztwb4emdctDZXbe",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Alternating Curtsy Lunge Pass Through",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Low Bar Pause Back Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/nknf16JJTZo?si=h2lVyRQ8npFOB0v4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Powerlifting",
  },
  {
    name: "Barbell Front Rack Pause Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/mN5Z5GH7ofM?si=5wK63ZJAw0Zc5Wti",
    inDepthYouTubeExplanation:
      "https://youtu.be/nf9qHeNxEhY?si=z84jl_HDWRo7_5wD",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell High Bar Pause Back Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Overhead Pause Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/HoT_4eitb8U?si=dHvB6ZQgWXCqNV86",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Suitcase Walking Lunge Pass Through",
    shortYouTubeDemonstration:
      "https://youtu.be/yXwmVzRHPPw?si=K_LXsBOKmt9dza3B",
    inDepthYouTubeExplanation:
      "https://youtu.be/tpJ09mGWZos?si=5J4AlnDrNYluauyX",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Hanging Knees to Wrists",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Rectus Femoris",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Slider Suspension Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Suspension Trainer",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell 10 to 2 ",
    shortYouTubeDemonstration:
      "https://youtu.be/6FjCQJRBNlo?si=RBXNRNqOkwVOMCGq",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Dumbbell Goblet Cyclist Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/2WxpkosHXLg?si=kPBJD_6N8w568qJ-",
    inDepthYouTubeExplanation:
      "https://youtu.be/TVM-zgy2eCo?si=cKrTYSxMj2TVwFj5",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Barbell Front Rack Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Barbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Barbell Back Rack Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Barbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Alternating Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/ulzoZOHicyU?si=OfrqYrKBRnV6RCrc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/eqaz6nCxF8k?si=OEXiCUefeX011B_I",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Single Leg Standing Bent Knee Ballistic Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Mixed Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Suitcase Carry",
    shortYouTubeDemonstration: "https://youtu.be/kaQWccrfY40",
    inDepthYouTubeExplanation:
      "https://youtu.be/fxwrTkKUkTo?si=wWkdk6J_ZPbF6Ir3",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Suitcase Carry",
    shortYouTubeDemonstration: "https://youtu.be/HNgMpdUEpgw",
    inDepthYouTubeExplanation: "https://youtu.be/T9A607GaR2w",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/hTNWWqL9oc8?si=cTXB5vGf2EIHhx3r",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Single Arm Kettlebell Knee Hover Quadruped Pull Through",
    shortYouTubeDemonstration: "https://youtu.be/WQyNCzqNqso",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Hover Quadruped",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Anti-Rotational ",
    MovementPatternCount3: "Isometric Hold",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell High Pull",
    shortYouTubeDemonstration: "https://youtu.be/mP1BHxBeAEM",
    inDepthYouTubeExplanation: "https://youtu.be/KxWTo2LavJU",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Indian Club Outer Heart Shaped Swing",
    shortYouTubeDemonstration:
      "https://youtu.be/52D7xnpFFGY?si=UBcZ3G1BNtRbk97O",
    inDepthYouTubeExplanation:
      "https://youtu.be/JB6fUPZENjk?si=9PxJ_yGmGMK_BCjA",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Indian Club",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: null,
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Alternating Single Arm Kettlebell Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Suitcase Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/IJXzXAy4T24?si=DdfzxAdOIPYNJSOh",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Sumo Deadlift to Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Pectoralis Major",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Horizontal Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Single Arm Kettlebell Clean to Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Alternating Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/jNjDO9lEenw?si=Ci4DITj3193GY1tI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Single Leg Balance Transfer",
    shortYouTubeDemonstration: "https://youtu.be/_uJQvQG57Y8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Front Rack Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/whSju0ip_78?si=emNV0JUVUhF8Qrf1",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/dpBy5qAG2Hs?si=x6xfYJbZr1Bols2r",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/9eDpB8LJLgQ?si=CKsCerZuXFHay_Dr",
    inDepthYouTubeExplanation: "https://youtu.be/KQTA7bNWAK0?feature=shared",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Alternating 360",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Shield Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/oBdXsknqSEM?si=ZXY5RzE8pchalVjS",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Clubbell Shield Cast",
    shortYouTubeDemonstration:
      "https://youtu.be/W2slZ8Mmyvs?si=CDhf0Oi-nPW136Jx",
    inDepthYouTubeExplanation:
      "https://youtu.be/LKNgPDX2wRk?si=1Rwdpndok-LHSvp4",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Macebell Barbarian Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/Gj3ancpDFKU?si=TKfk3RmqTwztmb1j",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Macebell Barbarian Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Double Clubbell Shield Cast",
    shortYouTubeDemonstration:
      "https://youtu.be/L1pxDgvsT9s?si=ajAmx9ThwNQY_hj2",
    inDepthYouTubeExplanation:
      "https://youtu.be/Iv2zqpFZieg?si=IodKi39vzBzQ2zQ3",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Side Shoulder Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/cYKB43q_eok?si=6RbJxeIM3Ep5ZCpY",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Macebell Isometric Split Squat Low to High Chop",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Mixed Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Clubbell Side Shoulder Cast to Side Flag Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/7gN3HVEX32Y?si=uhbq8EnPTL1lhAMh",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Mill",
    shortYouTubeDemonstration:
      "https://youtu.be/uIqkGCpjsx8?si=_GzAaZAVU4-bAgla",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Half Kneeling Shield Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Iron Cross",
    shortYouTubeDemonstration:
      "https://youtu.be/ekVV4qI2q9A?si=E3yTJpSwWDur0p82",
    inDepthYouTubeExplanation:
      "https://youtu.be/RwinMV55N5I?si=ZJLkwa3eVFYaxRCq",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Clubbell Half Kneeling Iron Cross",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Gamma Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/5g0iOf5NxXs?si=UG7cC9vvYQB0L2oU",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Half Kneeling Gamma Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Clubbell Side Flag Press",
    shortYouTubeDemonstration:
      "https://youtu.be/_bnWJymK0tU?si=vYh91PF76xgOyPll",
    inDepthYouTubeExplanation:
      "https://youtu.be/6p7mbHsX9rA?si=ePxWd06sMmnFRNLu",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Lateral Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Suitcase Foot Elevated Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/eGYP6B7LKtY?si=OkQLiBCrooH2qA67",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Indian Club Inner Heart Shaped Swing",
    shortYouTubeDemonstration:
      "https://youtu.be/If9fXNTF4wI?si=Lk9xqqbULe2D5Xbs",
    inDepthYouTubeExplanation:
      "https://youtu.be/W_o86GY2RYU?si=townxxYdN6ZgymIV",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Indian Club",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: null,
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Alternating Double Indian Club Inner Heart Shaped Swing",
    shortYouTubeDemonstration:
      "https://youtu.be/M_uslqzI28g?si=0zmBqTp2C8IMe5gJ",
    inDepthYouTubeExplanation:
      "https://youtu.be/B_HPnZEW5no?si=HpyhdneEbF3xO6jT",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Indian Club",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: null,
    laterality: "Unilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Alternating Double Clubbell Side Flag Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Lateral Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Clubbell Side Flag Press",
    shortYouTubeDemonstration:
      "https://youtu.be/uuLZZUozsdM?si=IcPMq75KQuzVIQM5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Lateral Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Clubbell Inside Circle",
    shortYouTubeDemonstration:
      "https://youtu.be/n8S_z0p25jA?si=fak8MwjeEUMtDoZ2",
    inDepthYouTubeExplanation:
      "https://youtu.be/0ZzoCasyoAM?si=2Sqz_R6WjuI_UyAD",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Double Clubbell Inside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/5NkPS-jUzs4?si=mwhdAG5MmUqgjIDS",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Clubbell Side Shoulder Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Reverse Grip Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/TUX58GM5fRQ?si=D4ei3VOcTd3GzGQn",
    inDepthYouTubeExplanation:
      "https://youtu.be/SQOsKWSHTMo?si=3SN_Hd0DI4UJoG65",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Reverse Mill",
    shortYouTubeDemonstration:
      "https://youtu.be/sdICKS1Hsl8?si=TQcKHRoyYYB_DXgZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/B8YWWwRB8fo?si=le4jfzg8-aRIxeLH",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Clean to Barbarian Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: null,
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Tall Kneeling Gamma Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Inside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/Exuf3a7RhYs?si=wY_qsUZI87eKFyhX",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Tall Kneeling Shield Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "#ERROR!",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Isometric Split Squat Shield Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Clubbell Single Leg Standing Bent Knee Shield Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Clubbell Tall Kneeling Shield Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Clubbell Mill",
    shortYouTubeDemonstration:
      "https://youtu.be/JL7-80LGmmU?si=wgcrQiv7L3ETryrv",
    inDepthYouTubeExplanation:
      "https://youtu.be/xRF2mbZzSdo?si=rxxBNrIyL2Vhwv7M",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Isometric Split Squat Iron Cross",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Clubbell Single Leg Standing Bent Knee Iron Cross",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Suitcase Deadlift",
    shortYouTubeDemonstration: "https://youtu.be/aXwilZfmDyo",
    inDepthYouTubeExplanation:
      "https://youtu.be/4PSOSrDcGfc?si=v47fMYchEqkzm40V",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/iPSx3HFBDJQ?si=yE7krt1ftsmuaend",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Mill",
    shortYouTubeDemonstration:
      "https://youtu.be/vwRppLKenzw?si=lWbUFOXUJgHzwIVl",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Clubbell Mill",
    shortYouTubeDemonstration:
      "https://youtu.be/p8aWK-U6uVQ?si=uIoHZ9IRigICcYkI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Isometric Split Squat Gamma Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Clubbell Single Leg Standing Bent Knee Gamma Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Macebell Alternating 360 to Ballistic Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/dAeNDa33dCg?si=DOdJKyHWeDTnUFjC",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Bar Chin Up",
    shortYouTubeDemonstration:
      "https://youtu.be/8mryJ3w2S78?si=feHRqrceUl_6Xatw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Pull Up",
    shortYouTubeDemonstration:
      "https://youtu.be/HRV5YKKaeVw?si=2FwPXMnKZC4QXyAO",
    inDepthYouTubeExplanation:
      "https://youtu.be/sIvJTfGxdFo?si=EayZv3-AEz3Y3pBa",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Clubbell Side Swing",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Clubbell Inside Pendulum",
    shortYouTubeDemonstration:
      "https://youtu.be/9JrqgpJfxFs?si=ltubZdnwDPFzi-8r",
    inDepthYouTubeExplanation:
      "https://youtu.be/4LqqrNosRiI?si=qH109kha9__Hvhfb",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Swipe",
    shortYouTubeDemonstration:
      "https://youtu.be/IABFtVxvqdo?si=Krk5vT1xDU9YcRb2",
    inDepthYouTubeExplanation:
      "https://youtu.be/Ec7n3S5G3Ko?si=Xbf10Qg6yfyLzV5w",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Latissimus Dorsi",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Clubbell Swipe",
    shortYouTubeDemonstration:
      "https://youtu.be/EZNev-kvl6A?si=GsKx6-ERsaOYXjDd",
    inDepthYouTubeExplanation:
      "https://youtu.be/4nt-vtNLLo4?si=0zCcsMCYUIoZtp5b",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Latissimus Dorsi",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Clubbell Cross Body Swipe",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/ASZw05sMCxw?si=FN1QEpEENaC46NuX",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Latissimus Dorsi",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Bar Scapular Pull Up",
    shortYouTubeDemonstration:
      "https://youtu.be/pE8PJsWEV7k?si=sXWG_h39gmTbgsNw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Clubbell Inside Circle to Shield Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/nz_28BY272M?si=nVEPcDEL6vGdESAz",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Barbarian Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/SnRUNmL46So?si=LiGATOKJlrhb676E",
    inDepthYouTubeExplanation:
      "https://youtu.be/JQ1UxkSqROQ?si=qs0lvcB3j2EsoQOa",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Clubbell Inside Circle to Outside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/V1noG21BO8Q?si=wQHrkhWFJHF0ak8e",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Inside Circle to Outside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Barbarian Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/rkB05p8JKDc?si=pJNkF5RP4J1kn_LL",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Clubbell Side to Side Swing",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/OmY95XgEy00?si=3-4hWbjWMn1lM8Fz",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Clubbell Side to Side Swing",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/OIS3xeBhwp0?si=XQoMSwCpgaBf7wdw",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Alternating Inside Pendulum to Gamma Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Clubbell Single Leg Standing Bent Knee Contralateral Shield Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bar Skin the Cat",
    shortYouTubeDemonstration:
      "https://youtu.be/mqZDdpFh1gA?si=5Sz7M4RZJh4kpYFa",
    inDepthYouTubeExplanation:
      "https://youtu.be/0g6tVBdfsUw?si=Xww93bTXbMAcyLUz",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Teres Major",
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Tall Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/fyC2FBk2vho?si=9A4Unc4H-ndiHFMC",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Inside Circle to Front Flag Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Clubbell Order Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/aHIntdF9TlI?si=PlDrrrvPa1NahU-k",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Hang Squat Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/DaKC_BEN5bk?si=-Q3RkXcSiRxscR4n",
    inDepthYouTubeExplanation:
      "https://youtu.be/YZUdVyVV3uI?si=gWL2sofp3-9XG4uU",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Alternating Single Arm Kettlebell Feet Elevated Plank Pull Through",
    shortYouTubeDemonstration:
      "https://youtu.be/178a2eYjaow?si=5BIFyTIH_gQo8ef1",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Anti-Rotational ",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Miniband Supine Alternating Hip Flexion",
    shortYouTubeDemonstration:
      "https://youtu.be/hcB3BdFBk9o?si=NCYoHHaTofHXzx2y",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Tall Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/zlosFkTwleE?si=kPNf5P_AJZd7Sqrn",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Bottoms Up Tall Kneeling Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Half Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/IoGfLT_8cPA?si=0w2tJHQG6XulCr7c",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Bottoms Up Half Kneeling Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Barbarian Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/g1NRUDyqlH8?si=D2hTo9Ntck6F1dcx",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Clubbell Single Leg Standing Bent Knee Ipsilateral Shield Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Clubbell Order Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/_ckOSXnMuXo?si=ljb43FTe1n7YBdl8",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Contralateral Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/FCsM9fm0xPY?si=8FFkfLmFOgxlcsFY",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Single Arm Macebell 10 to 2",
    shortYouTubeDemonstration:
      "https://youtu.be/7DW72Ft1LEo?si=kejdZkBMg1CFxl99",
    inDepthYouTubeExplanation:
      "https://youtu.be/eYAnYQw8yJI?si=afXpUxsTWnNFG7NW",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Bottoms Up Tall Kneeling Seesaw Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Inside Pendulum to Inside Pullover",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Order Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Clubbell Order Ipsilateral Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/hj6VJzYrkY0?si=fsHR5hg8cUmEtRGK",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Clubbell Order Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Alternating Inside Pendulum to Inside Pullover",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Arm Bar",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/Ya0DCt11wGI?si=dkBvQls6KHvRIS6y",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Infraspinatus",
    secondaryMuscle: "Subscapularis",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Arm Bar Rotation",
    shortYouTubeDemonstration:
      "https://youtu.be/dlqDSzgxNwM?si=_l4eia6JX0ovy0ss",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Infraspinatus",
    secondaryMuscle: "Subscapularis",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Double Kettlebell Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/80WFnCM9Kbo?si=kxvBbrzAla92I6YM",
    inDepthYouTubeExplanation:
      "https://youtu.be/KaBuOQuKz9k?si=bd3bRFMCPMLx_0e1",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Pseudo Planche Lean",
    shortYouTubeDemonstration:
      "https://youtu.be/KMCZ6Pjg9_k?si=qLUPw94vxQVVs7nw",
    inDepthYouTubeExplanation:
      "https://youtu.be/wKV5zVJTYBo?si=Ody40S0RCgcAfrGv",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Pectoralis Major",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Macebell 360 to Single Arm 360",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Tire Feet Elevated Decline Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/-S5Zz3Hl6a4?si=8XSysf7jjGJx2X07",
    inDepthYouTubeExplanation:
      "https://youtu.be/QV59kjnQUSA?si=PsO5R5p6EdgooNNw",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Bench Feet Elevated Decline Push Up",
    shortYouTubeDemonstration: "https://youtu.be/1ZTYpiJJDZ8?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/O7dVvwEK9J4?si=2GvTHxgOdnXM5BDT",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Box Feet Elevated Decline Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/5DTn4Euw6To?si=Qt5r8kEOx3ZW_AO9",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Feet Elevated Pike Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/s5VyQrNhEYY?si=9tSA6c3bjeje5MfX",
    inDepthYouTubeExplanation:
      "https://youtu.be/_FfCWr4B6z8?si=IEXKukMqp8ATfMdh",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Tire Feet Elevated Pike Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Bottoms Up Push Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Double Kettlebell Bottoms Up Push Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/J5LEpIZSDS0?si=SukDsqWl5cS7XyF-",
    inDepthYouTubeExplanation:
      "https://youtu.be/zIiqn5HVq1w?si=VyLaWgCr5pDY5QTj",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Push Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/4dDZeldSuVs?si=D0_bRJn7gwY2jMoP",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bulgarian Bag Side to Side Swing",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/BtQXVVu86Ug?si=yr6zjamvI2-gV-Wl",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Half Kneeling Ipsilateral Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/VDJcpMX5iDg?si=c4_vtlto4cmV6-r_",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Ring Rotational Row",
    shortYouTubeDemonstration:
      "https://youtu.be/1PiO_woAgDc?si=-nYhvQs3zKrAR7im",
    inDepthYouTubeExplanation:
      "https://youtu.be/J7-YqP2qYlk?si=HtXHfMfWEaD67VdL",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Horizontal Pull",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Trap Bar Bottoms Up Tall Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/yQToM9xx5Y4?si=AAnvcezbT07hvy8I",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Clean",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Brachioradialis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Clean",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/XRyFEfRbHYY?si=9uHqeQJHtoWY-upd",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Brachioradialis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Clubbell Clean",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Brachioradialis",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Trap Bar Z Press",
    shortYouTubeDemonstration: "https://youtu.be/nz99ncuEEt4?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/jHx9-WED7OU?si=zlXUqydv0_cCArqf",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Bottoms Up Floor Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Bottoms Up Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/I8WCjE1hTPM?si=riNSekDaoROPTCoF",
    inDepthYouTubeExplanation:
      "https://youtu.be/M98mRj1cJM8?si=lrWk0x11qTglrTmA",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Alternating Spin to Side Swing Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/2UpONYbzL7c?si=C2NbwmasH7LSljdz",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bulgarian Bag Swipe",
    shortYouTubeDemonstration:
      "https://youtu.be/qFNcznHSBo8?si=5hfD700tGnPBWD3l",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bulgarian Bag Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/9-gxBjR4OyE?si=Z1RZknDb7e1_9QmD",
    inDepthYouTubeExplanation:
      "https://youtu.be/LZNJdtSUG2g?si=VL3fegXQBKZIbUCg",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Bulgarian Bag Alternating Rotational Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Bulgarian Bag Alternating Side Swing Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/KCyWRqPHOCQ?si=bsZ5UbqpPjccsnEp",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Bulgarian Bag Dead Clean",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/o4PZBvlbkAk?si=fdFl2ErxtWiwCSWW",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Bulgarian Bag Swing",
    shortYouTubeDemonstration:
      "https://youtu.be/Q7rAfqN-NH0?si=zEMPL2_L-ZEUhtLj",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Bulgarian Bag Front Rack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/jAo338cgsmU?si=1dPZPEL1g1HDUuIC",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bulgarian Bag Back Rack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/ctrXJi1QgEQ?si=O95czG8N3RjyL-Y-",
    inDepthYouTubeExplanation:
      "https://youtu.be/77bp2Vf5KOY?si=qgFXxKXj-bodeUVk",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bulgarian Bag Swing Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/gVYqz0SXsXE?si=WX6MR6-rxwXauydO",
    inDepthYouTubeExplanation:
      "https://youtu.be/pKkO375ukiM?si=hViaWAmn-trGHUuI",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bulgarian Bag Alternating Forward Lunge with Rotation",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/jI5o5O6ADpU?si=9f_wK-1jSFrrTJ9v",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Rotational",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Battle Rope Single Leg Standing Double Wave",
    shortYouTubeDemonstration:
      "https://youtu.be/6d6b8cx0pO0?si=NKi1a2se39GGFRx3",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Battle Rope Single Leg Standing Power Slam",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/40IXomjo5XM?si=qvjMBRQEACW_0aHM",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Landmine V Grip Tall Kneeling Chest Press",
    shortYouTubeDemonstration:
      "https://youtu.be/FFWOG7Xk5RE?si=JwIHWZtHK6_oDHhQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Swipe to Alternating Shield Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: "Sagittal Plane",
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Order Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Bottoms Up Z Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Battle Rope Single Leg Standing Clap",
    shortYouTubeDemonstration:
      "https://youtu.be/bB3WGOVrqAg?si=Pby2lcyL_Cq98LT9",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Lateral Deltoids",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Macebell Mill",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/xtuW0e-6q5U?si=nDviJdyl4esinr7I",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Dumbbell Goblet Low Switch Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/ggVuR079WHM?si=QWRGadB6a4zrJrLz",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Clean to Alternating Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Clean to Alternating Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Clean to Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Clean to Alternating Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Clean to Alternating Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Clean to Split Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Bottoms Up Clean to Split Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Dumbbell Front Rack Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/ZxjMX7k3Zp0?si=pZtrI1oUYV-FsjgX",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Low Hold Alternating Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/k6L3kWztcNs?si=GiG4ZJIK5HCWo7Rm",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Low Hold Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Clean to Split Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Clean to Split Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Suspension Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/kZdZsw22lU4?si=Y2-3ATlU1R18Acir",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Suspension Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Suspension Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Suspension Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Suspension Foot Elevated Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/pOSa7abtPaQ?si=RtB71Qujc9eZBx-J",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Goblet Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/DYVAGWST-E8?si=NbgYbTD-kINhnv6a",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Goblet Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Goblet Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Low Hold Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Low Hold Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Low Hold Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/qxb36LOiBsc?si=9n0Wr7YfIHCom-_w",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Contralateral Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/cmB4dq8MgVk?si=s0qFLxm2MDbbX3dw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Foot Elevated Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/d0gACX9heHk?si=U0snvFOFoR0LH9Ne",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Low Hold Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/k4p89WEkl58?si=S4JsgnfzWmFK3l4G",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Low Hold Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Low Hold Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Low Hold Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Low Hold Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Low Hold Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Clean to Split Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Bottoms Up Clean to Split Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Bottoms Up Split Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Order Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Foot Elevated Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Bear Hug Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/jb9Ge6SP8IA?si=FgQecwjAUfv-teLv",
    inDepthYouTubeExplanation:
      "https://youtu.be/zTvjvkK2cI0?si=qjPGwzZvPJVNY18J",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Dumbbell Hip Thrust",
    shortYouTubeDemonstration:
      "https://youtu.be/LxdfGyNBuRU?si=x25Sk4tkkLiyY4t2",
    inDepthYouTubeExplanation:
      "https://youtu.be/29OfN4ztW_g?si=heAR-KpPnMTMhSpL",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/dpVFicHv1PY?si=vQiTWZmKGTiqkHiH",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Split Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Single Arm Kettlebell Bottoms Up Clean",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/kMTZwJnCyjw?si=i72hlbqfO-UgCiPw",
    inDepthYouTubeExplanation:
      "https://youtu.be/82R1H0Vt3u4?si=o04-97n1Ozurkwtt",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Bottoms Up Clean to Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Bottoms Up Clean to Front Rack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/35IarWLcV0s?si=4lqKX0sntuR1xdEa",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Front Rack Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/dDq_T_H8h5E?si=g4wZK9kvKsPxqI3d",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Dumbbell Front Rack Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/5rsJK_z8nkY?si=CD5k3-b0r_JJpfHM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Clubbell Order Carry",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Clubbell Order Carry",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Overhead Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/ULpnqrFng5I?si=fKiyqdRwBpIeRaEx",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Barbell Overhead Carry",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Front Rack Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/ofwpNdE8yZU?si=T8V1vgUvY8g4tAZ9",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Suitcase Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/FKrUoffD_W4?si=d07P0wkoguJqTTRV",
    inDepthYouTubeExplanation:
      "https://youtu.be/Mu8x3Cg4caw?si=sSLEp9C-yfgVNgmF",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Single Arm Kettlebell Sumo Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/BoihxFxtsyY?si=kZuvg9gJ179nJ1Xh",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase March",
    shortYouTubeDemonstration:
      "https://youtu.be/Pjxd7M8bNU0?si=OeEny9WikOBA8B3P",
    inDepthYouTubeExplanation:
      "https://youtu.be/hWHC_1BHAB8?si=tO3p7iVwPL7skcDZ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead March",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack March",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Half Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/5NV0b_RCWKk?si=LoNm1gGN8i-9QLGP",
    inDepthYouTubeExplanation:
      "https://youtu.be/kjrshKD75Jw?si=vf3ArXJXe8TIPtIi",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: null,
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Half Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Half Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/iVaFwCBP1GM?si=9YPJCkbg5ckTydxm",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Half Snatch to Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Overhead Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Bear Hug Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/ymSWvrARnCo?si=wSCDvQEQ8xPtVqbn",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/VhCVdzYN820?si=07qvbVC4lpqJVZxR",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Turkish Get Up",
    shortYouTubeDemonstration:
      "https://youtu.be/nUjB7PY_ch8?si=qTE38YBxSMytqVEV",
    inDepthYouTubeExplanation:
      "https://youtu.be/wLhVOlc13qg?si=qVYMFJtu7KjQCOQy",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Heavy Sandbag Bear Hug Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/68d5tiCgUy8?si=QZZ5qWDdvMU5WTQ_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Bear Hug Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/dd8M3MLhfjc?si=C40Jnp1OsYedBuT1",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Shoulder Alternating Forward Lunge",
    shortYouTubeDemonstration: "https://youtu.be/2EkAq9e24EY?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Alternating Reverse Lunge",
    shortYouTubeDemonstration: "https://youtu.be/T4jp-7X-ai8?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Shoulder Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/YSd_xma0esE?si=1LEK7NMY3heh6sof",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/cB7KJj-wqA4?si=_9jU8-LRtzGAT3e7",
    inDepthYouTubeExplanation:
      "https://youtu.be/kmWYKPMI6uQ?si=PSnbWtFaOVT5jWTY",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Over the Shoulder",
    shortYouTubeDemonstration:
      "https://youtu.be/fqzGFACRFWU?si=AdAu_hY9NYrlY8DS",
    inDepthYouTubeExplanation:
      "https://youtu.be/2pnxTZKlYoU?si=f5T7xqtqOMSeZz08",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Alternating Shoulder Clean",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Alternating Over the Shoulder",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Bear Hug Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/X5s18gG7cJc?si=P3v8_2nsYkNdk5D7",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Turkish Get Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Single Arm Macebell Reverse Mill",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Bodyweight Hand Assisted Sissy Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/nNAssQ-4HjA?si=wsCriUBiz-jLsGEk",
    inDepthYouTubeExplanation:
      "https://youtu.be/A0Vt-TcdwF8?si=Rg0aoGihOOY9RmnO",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Sissy Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/GHvRU4-Guuw?si=NJtNhZAAV3mKCcG-",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Hand Assisted Knee Over Toe Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/gBSQOdjjKcc?si=oEXgjHk6m5c-o7MS",
    inDepthYouTubeExplanation:
      "https://youtu.be/gx-CSuRFcDQ?si=G9h39jrXLFldESBC",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Superband Sissy Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/T2caG3uW8sA?si=AD_PdOw0tzZSfl3p",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/i3qlK1vA0z4?si=LCNdYUF9IbCDWnYm",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/QR1CViFqmmc?si=4Lxq-QIIZ55jvMdx",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/lcCEvbAGHC8?si=Ri750XsY--4dDnB_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/GGjKBYEkZ-A?si=faI8XOKTHMInvAqG",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/ntGrVrVVNU0?si=3gtiQIlGPGnTePEX",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Horse Stance Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/ZZ1piVHgy_8?si=I9HrW8xbkLx_UyJS",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Horse Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Alternating Forward Lunge Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Clubbell Reverse Mill",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Macebell Mill",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Order Walking Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Walking Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Walking Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Box Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/-IzhFO7lOEU?si=Aftwsw6k2KY2-jf0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Bodyweight Lateral Box Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/GFdBbtdUfIU?si=GoMi96WWph2nlJpr",
    inDepthYouTubeExplanation:
      "https://youtu.be/bNHwR90FO0I?si=QZlMLdh6UGORYnRa",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Bodyweight Alternating Lateral Box Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/kJqEVtWkYHo?si=aVVrhRraXLtyjPfg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Bodyweight Straddle Planche",
    shortYouTubeDemonstration:
      "https://youtu.be/-huk0Idtr6M?si=mLwa_8pXggDXuFgO",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Macebell Single Leg Offset Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/xpa6f9sJmiQ?si=gJH8lq53_OwgQY8F",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bird Dog Row",
    shortYouTubeDemonstration: "https://youtu.be/TBtjuZR8Dvo",
    inDepthYouTubeExplanation:
      "https://youtu.be/IrMVMZoQum4?si=OXQ7A8Yon9a3gESZ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Quadruped",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Half Snatch to Front Rack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Suspension Ipsilateral Pistol Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/5G-vWzfeTy4?si=J9YetG0ZnmrQ6H76",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Kettlebell Single Leg Standing Hip Flexion",
    shortYouTubeDemonstration:
      "https://youtu.be/djxTlEIJdqc?si=IDadWzv3enNpiltr",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Single Arm Macebell 360",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/1eXnGGPLhGg?si=8nuTtTomEMCOCgJr",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Low Hold Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Low Hold Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Alternating Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/wrYqfSLWqdE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/yqtWcL9-1_k?si=q_p_4kAujNiWzCVq",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Seated Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/7uS_6AgHk28?si=jXJ8ZwIqz_-aAInK",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Bottoms Up Seated Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Seated Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/f8Mgse4j3uc?si=GV-Q36irrQm7tYhE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Offset Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/aOIjzeK24fY?si=HuhPoFZBScLorUuf",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Dumbbell Sots Press",
    shortYouTubeDemonstration:
      "https://youtu.be/cc1TZmreJWE?si=aBzThLfX3rm5V3c1",
    inDepthYouTubeExplanation:
      "https://youtu.be/iClMsJ8D0Uc?si=EmYuINOia7NzheKH",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Sots Press",
    shortYouTubeDemonstration:
      "https://youtu.be/IjmQgS0bDao?si=wKCRqF1MeVyvhSwR",
    inDepthYouTubeExplanation:
      "https://youtu.be/LwBAozDZ5Ng?si=5jWgaQEDVR5FuI0D",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Alternating Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/JqoC2gQ1MRE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Ipsilateral Cossack Squat Thruster",
    shortYouTubeDemonstration: "https://youtu.be/_D87kNsSdv0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/fhkFo0BxF5k",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Alternating Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/bYd08tHBi3c?si=jxsjM2VGsZK9-fBt",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Contralateral Step Up",
    shortYouTubeDemonstration: "https://youtu.be/XJmnB32JJVw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Alternating Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/ozPUu1GnFTI?si=mWpQsYkoy7akxELn",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/2rYLwmQGZXg?si=FC91EHLdOWAxPSXL",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Contralateral Step Up",
    shortYouTubeDemonstration: "https://youtu.be/23z9Mb4sMVk?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Ipsilateral Step Up",
    shortYouTubeDemonstration: "https://youtu.be/fWhOG_9eHdE?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Ipsilateral Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/8G0AKIfWSBs?si=A1jj7DSnbvZ7u7t-",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Low Switch Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/Eod-qE6O33E?si=6CUX35luY_zr0tT_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Low Hold Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/svU3rff73Mo?si=wBPTEMnydOoIKHgd",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Low Hold Alternating Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/ZclBW2lK-lY?si=fR_4w2NKvW_BzggV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Ipsilateral Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/AYgBothlkOA?si=hiSrcI8KbslXlQrq",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/iD8tG0qfztk?si=Z2QMS4VxJJkJ-kUk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Overhead Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/7JUe6YXSM3g?si=TrnVTv62WQxSpsZ1",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/sUaLKjZx4X0?si=tcwai7A-NJGrnfYn",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Overhead Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/UTV5o4Oi2KM?si=RDXt3oFCH3cgDQiw",
    inDepthYouTubeExplanation:
      "https://youtu.be/5xtllI7frxI?si=U4ZEObQbJpoBX4nC",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/m7e4dzCqoGA?si=wc7zBINGvkkas6BV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Half Kneeling Bent Press",
    shortYouTubeDemonstration:
      "https://youtu.be/AIMfooNNmvw?si=QCorVlRf7tHTepHu",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Double Clubbell Order Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Alternating Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Contralateral Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Ipsilateral Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bar Advanced Tuck Back Lever",
    shortYouTubeDemonstration:
      "https://youtu.be/ixeU8JtnItE?si=yeqNnWyHu_lYZQay",
    inDepthYouTubeExplanation:
      "https://youtu.be/c9S9cqhwEdo?si=Vj-wrIBHkJ1qGX9G",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Advanced Tuck Front Lever",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/ebY8vV7JHQE?si=F6jN3mhs8Z89iWS4",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Alternating Double Dumbbell Sots Press",
    shortYouTubeDemonstration:
      "https://youtu.be/YLxytoB3RN4?si=bzXKJBCQCbLTNZhd",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Seesaw Sots Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Single Leg Standing Bent Knee Mid Row",
    shortYouTubeDemonstration:
      "https://youtu.be/mZJieN2H4PM?si=gtPnQWWttdqNc67H",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bar Circle Front Lever",
    shortYouTubeDemonstration:
      "https://youtu.be/ZiUXNRmnC9o?si=H4E1QFrZ06yPO-Jz",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Suspension Single Leg Standing Bent Knee Low Row",
    shortYouTubeDemonstration:
      "https://youtu.be/PaYajo0NIjs?si=BnxQHt0l6HLbbkgL",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Suspension Rotational Row",
    shortYouTubeDemonstration:
      "https://youtu.be/EOjx-EK_91I?si=RWxX91ZewMkt9AFa",
    inDepthYouTubeExplanation:
      "https://youtu.be/YqhHuFNJ-Pw?si=4tSOi6oLRJPrlnaZ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Horizontal Pull",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Double Indian Club Outer Heart Shaped Swing",
    shortYouTubeDemonstration:
      "https://youtu.be/3j-GT-SlBj4?si=UkgK_A3tck5Lm2rK",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Indian Club",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Double Indian Club Parallel Swing",
    shortYouTubeDemonstration:
      "https://youtu.be/nDugTXCHzFY?si=NQvVJIZJswsF1HNn",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Indian Club",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Suspension Feet Elevated Decline Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/rZ2F0Fo1Cts?si=ki-LUP1NvXaLVXL3",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bar Front Lever Pull to Inverted Hang",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Full Back Lever",
    shortYouTubeDemonstration:
      "https://youtu.be/I5pStn4M6AU?si=xYguBx9qhd3Movl6",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Full Front Lever",
    shortYouTubeDemonstration:
      "https://youtu.be/1QCwhp_WlEA?si=wXgs8tAgUOVzgUhI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Slider Atomic Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/XsU1dAVQ04M?si=xZbKraABgDpY1zUM",
    inDepthYouTubeExplanation:
      "https://youtu.be/xt3zs3eQuVM?si=I5aW-mu5DT50GUqg",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Reach Push Up",
    shortYouTubeDemonstration: "https://youtu.be/7OwOfbA13Nw?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bar Half Lay Back Lever",
    shortYouTubeDemonstration:
      "https://youtu.be/mT2_DYAVu8c?si=shnn4gm9QMQ0x3Y5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Half Lay Front Lever",
    shortYouTubeDemonstration:
      "https://youtu.be/z-zP32fnugI?si=38IL3ATf8aLehR74",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Hanging Knee Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/KNzJ3GuIpB8?si=va7oq1yMev2p_dQ2",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Rectus Femoris",
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bar Hanging Knees to Elbows",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/RXM3S7Zu2Uw?si=4iwyfTGqH7LI7GGH",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Rectus Femoris",
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bar Hanging Knees to Wrists",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Rectus Femoris",
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bar Hanging Leg Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Hanging Toes to Bar",
    shortYouTubeDemonstration:
      "https://youtu.be/xX9Hzi7Onnw?si=DF7ySd87D6LcLvwN",
    inDepthYouTubeExplanation:
      "https://youtu.be/S2QVHl6DoNo?si=_wSbbPfIY45-7i8d",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Hanging Oblique Knee Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/sqDdHFC1KYk?si=VwW9AhJxnFtKqLWf",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bar Inverted Hang",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/h7OTCWs5nnI?si=JX5XrUWlWmxqTyHN",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Hanging L Sit Flutter Kicks",
    shortYouTubeDemonstration:
      "https://youtu.be/MGBT77oSGiA?si=AGhUTOg_vYJNxD4y",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Half Kneeling Ipsilateral Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/6p9PqTZuhcg?si=nxxkNsm2jrR22MT1",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Rotational Row",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Horizontal Pull",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Alternating Reach Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/Rz_FBXCafls?si=wfY5MWfyEHQ-ZbZR",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Single Arm Landmine Z Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Bull Whip",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Bar Single Leg Out Back Lever",
    shortYouTubeDemonstration:
      "https://youtu.be/3M3VxKm08cs?si=dt2GQl57ObWtHdOH",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Single Leg Out Front Lever",
    shortYouTubeDemonstration:
      "https://youtu.be/HzcWRdP78Wo?si=l0PzesASSgyca9XI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Bottoms Up Push Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bar Straddle Back Lever",
    shortYouTubeDemonstration:
      "https://youtu.be/-H0jvoX9D4U?si=JgYHw7fT5duJS_3Q",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Straddle Front Lever",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Alternating Double Kettlebell Bottoms Up Push Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Double Kettlebell Bottoms Up Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/xjbycsKgqjQ?si=LkTmhk8Js8iT50DU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bar Tuck Back Lever",
    shortYouTubeDemonstration:
      "https://youtu.be/LfyGMZh-Bz4?si=6Cp5HCRlHxaaAXAk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Bottoms Up Seesaw Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/HDzbviKeH8A?si=B97qZHv-l5DP5Zwg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bar Tuck Front Lever",
    shortYouTubeDemonstration:
      "https://youtu.be/BDYs4d0-dbs?si=xhEemMS0ZwEdNi-P",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Bottoms Up Half Kneeling Seesaw Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Full Planche Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Grand Master",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Straddle Planche Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Grand Master",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Fingertip Full Planche Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/kw0kXtvOpfU?si=l1qrLXesjuSAv8NK",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Grand Master",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Fingertip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Wall Supported Handstand Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Grip Push Up",
    shortYouTubeDemonstration: "https://youtu.be/d305HI37Rc0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Barbell Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Oz--LasDphM?si=JVdkguhnIxf9Ho8X",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Shoulder Stand",
    shortYouTubeDemonstration: "https://youtu.be/_Jf4hAHEwm8",
    inDepthYouTubeExplanation: "#ERROR!",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Strap Handstand",
    shortYouTubeDemonstration: "https://youtu.be/3cLo1dWPqis",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Handstand",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/UU2gnuYZYcE",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Strap Handstand Push Up",
    shortYouTubeDemonstration: "https://youtu.be/nUt-_d3zP2w",
    inDepthYouTubeExplanation: "https://youtu.be/BMeac2RxtM0",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Straddle Press Handstand ",
    shortYouTubeDemonstration:
      "https://youtu.be/olR47A-UOYU?si=XvqzFclDvXSJPmsi",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Alternating Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/lUSmIRNqt9w?si=2Uzz5dQAroAGZKAK",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/V9ButqpLLcw?si=W7rot5ocLsfGP3zd",
    inDepthYouTubeExplanation:
      "https://youtu.be/gF9mAgwFV0U?si=-l753jr2phBx6o3o",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Macebell Order Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Pike Press Handstand",
    shortYouTubeDemonstration:
      "https://youtu.be/5qjQF8Bwk9Y?si=hKn5hERkDvTWUSxe",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette L Sit to Straddle Press Handstand",
    shortYouTubeDemonstration: "https://youtu.be/Hx31luas38Q",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette L Sit to Pike Press Handstand",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/_cObaNpz7Qo",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Heavy Sandbag Clean to Push Press",
    shortYouTubeDemonstration:
      "https://youtu.be/AVH3_x1LZA4?si=xUfQv7BiQgAH0riW",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Tuck Front Lever Pull Up",
    shortYouTubeDemonstration: "https://youtu.be/7gLyX3Q1KJA",
    inDepthYouTubeExplanation: "https://youtu.be/F5s7rHb2xLY",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Advanced Tuck Front Lever Pull Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Suitcase Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/OFSepehKEsg?si=cACSI6X-vniOrBik",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order March",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Clubbell Order March",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Ring Straddle Front Lever Pull Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Ring Push Up",
    shortYouTubeDemonstration: "https://youtu.be/9sjQEtGoScA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Anti-Rotational ",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring L Sit Muscle Up",
    shortYouTubeDemonstration: "https://youtu.be/CP4kwFLxRYg",
    inDepthYouTubeExplanation: "https://youtu.be/d_UZZJ3WMJE",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "False Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Strict Muscle Up",
    shortYouTubeDemonstration: "https://youtu.be/vJTJFc2wmk4",
    inDepthYouTubeExplanation: "https://youtu.be/j-5Ubq3ZOds",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "False Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Suitcase Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/ojCvehn5SjY?si=tdD_tXPCt_VXy9h3",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/9C-hKwyOaE4?si=SpYmw0aHIO29g-Cj",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/ApTlAc-7lGY?si=SjnB0ffZ9Ws6qo9D",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Walking Lunge",
    shortYouTubeDemonstration: "https://youtu.be/0D5CejWdGE4?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Landmine Isometric Split Squat Shoulder Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Clubbell Inside Pendulum to Outside Pendulum",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/eIkqXJ5d7V4?si=wMNBiWYPBNkNHefs",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Inside Pendulum",
    shortYouTubeDemonstration:
      "https://youtu.be/KPxWt4X3CYQ?si=LHuzEfvY58pZcQ4P",
    inDepthYouTubeExplanation:
      "https://youtu.be/sfzt6cLkFW0?si=PS8mGN_7PKhADecq",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Inside Pendulum to Outside Pendulum",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/GULjXPS_ba4?si=tEzS4-HdvzA8fx13",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Clubbell Outside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/66BuPCRIPdg?si=SSDiysrTJUP0RpMQ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Double Clubbell Outside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/5kSlzeUzVUU?si=lw7yT3UxjoIb6l5U",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Inside Circle to Outside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/olY-kqcOHDM?si=ArgXh53D_rsysMnR",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Romanian Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/keiZFdUgvKQ?si=dkMliNkbyV8fodl2",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Snatch Balance",
    shortYouTubeDemonstration:
      "https://youtu.be/XuFaD1sAVGI?si=TR-XC6iaJP514gda",
    inDepthYouTubeExplanation:
      "https://youtu.be/8KKQTdnxWso?si=Xzo-jpnXcLQ3yPMS",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Parallette Straddle Press to Handstand",
    shortYouTubeDemonstration: "https://youtu.be/DRYQDMUVgYE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Dumbbell Suitcase March",
    shortYouTubeDemonstration:
      "https://youtu.be/Yz0g3nK0UH8?si=uzYt2n3dgbhVRnnW",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Dumbbell Suitcase March",
    shortYouTubeDemonstration:
      "https://youtu.be/l5n8bNkwXFo?si=N5Nmp5n6RrmLD2uu",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Dumbbell Front Rack March",
    shortYouTubeDemonstration: "https://youtu.be/46yupJpHPBM?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Dumbbell Front Rack March",
    shortYouTubeDemonstration:
      "https://youtu.be/x_pMZHT1PJI?si=gXaoVxcFe0j1mtPQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Dumbbell Overhead March",
    shortYouTubeDemonstration:
      "https://youtu.be/Iqc40RmX2t8?si=6XNRQXHsREEsYjGr",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Dumbbell Overhead March",
    shortYouTubeDemonstration:
      "https://youtu.be/6Yw94hTsI2s?si=oPrzNDtNw4g-Xhy-",
    inDepthYouTubeExplanation:
      "https://youtu.be/dN2mr1X82vA?si=Oq7QjiM6QhPUpzw9",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Front Rack March",
    shortYouTubeDemonstration: "https://youtu.be/dSSBwrzbtGI?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Back Rack March",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/QF_3mIHjVqw?si=Auzs6S93LYtOrOtw",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Back Rack Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/H8YHDNCH5-o?si=niOwS0JaOXdOT4Ip",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/fP3L8yqDaYo?si=xq03w4XotIlArOk3",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Single Leg Romanian Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/wacHvU9ISqQ?si=6Hco-OabboEOEO3N",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Ring Eccentric Chin Up ",
    shortYouTubeDemonstration: "https://youtu.be/Vg0K1uuNQLI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Freestanding Handstand",
    shortYouTubeDemonstration:
      "https://youtu.be/Qoyxwu0i5Og?si=v6_bUX0l76eWrYRZ",
    inDepthYouTubeExplanation: "https://youtu.be/Qcuib7_44qI",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Gironda Sternum Chin Up",
    shortYouTubeDemonstration:
      "https://youtu.be/PUjiG2iQHzk?si=OVi5AVNaOFs0SP5b",
    inDepthYouTubeExplanation: "https://youtu.be/STqWO-kYEnw",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Front Rack Contralateral Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Front Rack Ipsilateral Pistol Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/RHj4ErHsJAw?si=ZUMLXqjq5pmMSAf_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Contralateral Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Ipsilateral Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Kettlebell Horn Grip Pistol Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/L0S7ATOR1Rw?si=KpjiKwE_QaiTxnfw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Overhead Contralateral Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Overhead Ipsilateral Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Contralateral Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Ipsilateral Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell L Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/AOjVLnxbmHU?si=LVrFAJ6HK8bfJmCb",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell L Sit Lift Over",
    shortYouTubeDemonstration:
      "https://youtu.be/FNsKwVfAF2A?si=ZLDbQY35pGpv6Wk5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Windmill",
    shortYouTubeDemonstration:
      "https://youtu.be/sGgI_gV85Zs?si=0_msxxqLJEv8yQl7",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Bent Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Half Kneeling Bent Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Ring L Sit Archer Pull Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Overhead March",
    shortYouTubeDemonstration:
      "https://youtu.be/R2nuXQJt-08?si=ZZwubaIV-9OycLD5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Overhead March",
    shortYouTubeDemonstration:
      "https://youtu.be/GL4yx2rQpIs?si=lvmUx2j0LaKZx4RZ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Suitcase Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/oeyAEgHBVYc?si=mHjzSFPeM2YyoC0H",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Suitcase Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/zO8xPAa4-cY?si=bSfD4Gd8EdQ631Hq",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/TzuHADj8h4M?si=tAyLqN0pCIXqxity",
    inDepthYouTubeExplanation: "https://youtu.be/cJs1VoCH1Nc?feature=shared",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/KIDRnwRAKAY?si=b00pYocO2xqWBGiJ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/JKk87eVdbG8?si=Est-myfua9sI06NN",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Alternating Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/A4SnLhdMKu4?si=AWoi6qQOHivzUZeZ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/GkgTBlp417A?si=2RKL7GSC-wlwXQrE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/V-crv5-Tqbg?si=k00dfu1tLmH4-h3a",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/Ambx6K-_AfY?si=2pUqPVUnlmZLMMwH",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/1iT74xBv0LA?si=vNMiZEtQ8W3QCkqc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/8OZUh9sHk-8?si=euVM8-cldcw4zaJf",
    inDepthYouTubeExplanation:
      "https://youtu.be/inttAOhcV_4?si=JVlHdarqW2zzsco_",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/eK7AzF0-rt4?si=0L-vfrm5QmGhcV2l",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/DbANzYj8EWQ?si=NULTCgfWBvm6vNpX",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/kTfl5mhcwso?si=iDo9iOmHhKSZIQlN",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Single Arm Dumbbell Low Hold Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/b3ewFBSqc9k?si=l6I7tV4HN4z6vcCS",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/1uuCmY9bVao?si=0iam54INq6LqKgrV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/RNdGRLDFZ_E?si=ViWm3Cym-_kPAyPr",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/y6Z1csYJqI8?si=VJQkALrooI76ZWQ9",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/iPBOqxEBcto?si=yJqaSgMnybSQX6Oy",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/HFjBFM1Fswo?si=BiUd6crmcvrtRZx2",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/xFvob3P7I74?si=o6y90mzLlkb5kjLo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/MjHkEW-AMQI?si=EyW7vqzwyfCJv1bN",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/YidVOnuiDfc?si=ECuN-ZTMBkyH_maZ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Alternating Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Alternating Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/dNrYT5iU7BQ?si=VgjB2U40EdHaPV2P",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Alternating Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Alternating Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Alternating Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Alternating Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Low Hold Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Goblet Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/-hWgE1P2aAA?si=7mOaE_-aBxpQNBSX",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Goblet Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/VI0GDe_doBk?si=U14f8Dk6Ly1aMzBr",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Alternating Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Alternating Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Alternating Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Alternating Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/aopAoW1cmUk?si=EyVEsJC9bLaQC6ND",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Cyclist Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/QV4DL31Ch94?si=6O9QTMoEB9MtwsZY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Cyclist Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/eGKpS3AxCVA?si=-uyv4kyU-FY0yBfB",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Cyclist Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/Fm-EgA1xP4g?si=TXFdciSwYJ3flVng",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/FvJS_MSN4Lo?si=Z7h-t5HEEQC6trw6",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/0RqJM6GM5bg?si=eL5TvNrMzUaI1oOW",
    inDepthYouTubeExplanation:
      "https://youtu.be/CpvfDjEulYQ?si=y9FyEYKBCzncPpqK",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/OX0fKkaY6_c?si=T0Ta2iyvXrGIGA7w",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/iGLwbS5aHY4?si=f7TNizeYPw8xX1xR",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/SokWJEUYgfc?si=OWsmg8u6_2Xz09z9",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Front Rack Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/6DO1p1pOAwM?si=zeLSk3SSoVkoP_B9",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/7rGFnvK6KkE?si=SL3VLXM4o_8TDV_0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Ipsilateral Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Contralateral Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/iylKd9ymBQE?si=D_mNdhDHgU7B8xbD",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Ipsilateral Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/7oQoOglG_cA?si=JLNoB9O2s2KyOAf1",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Contralateral Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/-vKdvtdkRRc?si=CPo0dP5KaIc0TJu5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Ipsilateral Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/pEZWYmpCzu8?si=i70Ip_o4npwew5bY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order March",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Macebell Order Walking Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/0bqrj4BimaI?si=03pxBE_5_ozxIivb",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/fJePN1sD5ok?si=g-YYXG1x8L53Vuv-",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/FNr5JBGrJTU?si=bn24rl-sBOt5WTfx",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/a8y1Qwir7YQ?si=izeBmxPLl4E0ekvy",
    inDepthYouTubeExplanation:
      "https://youtu.be/mQTDtKsvU1w?si=T-FpFQkffSsSciAJ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Bear Hug Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Sandbag Front Rack Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/0el8H9fy3g0?si=BdlZ75xoh6Xq1wpJ",
    inDepthYouTubeExplanation:
      "https://youtu.be/LnzGMMZkbVQ?si=zqERNyO8tP3t4fpr",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/mGwXPP-QKko?si=pUfEZOZPOOYaTV3n",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/1L2HnCKmsRs?si=fIVyc7oXYDkkRzgJ",
    inDepthYouTubeExplanation:
      "https://youtu.be/DOg-FzxnFKE?si=cD9DX5H-0kSOHKrL",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/SJe_O4NPU-E?si=OKoj1OGsurlSWTEA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/hVIaVvyY-H8?si=HsyRlDh-j--gHbsk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/k6pHuYm2nV8?si=ttotAgiXtgPihuX3",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/X5UicuSpd-g?si=vkWg2RXcC-HFi6Pk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Single Leg Standing Bent Knee Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Barbell Single Leg Standing Bent Knee Contralateral Overhead Press ",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bodyweight Tuck Planche",
    shortYouTubeDemonstration:
      "https://youtu.be/VFYZh24e0RI?si=_Vjvy9tWBn4nc7l_",
    inDepthYouTubeExplanation:
      "https://youtu.be/mR-8cNSYvYE?si=AV7-k3IZs0hk0Xw4",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Other",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Barbell Single Leg Standing Bent Knee Ipsilateral Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Push Up to L Sit",
    shortYouTubeDemonstration: "https://youtu.be/V-157r2C-qU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Hanging L Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/WHi1bvZLwlw?si=NKvlsqG8aI-wDQfJ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Hanging L Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/8DMns2IRlg4?si=hbMMsP9DfSOthR7b",
    inDepthYouTubeExplanation:
      "https://youtu.be/iyr4PtWBF08?si=QcxDk9hLR9xK8GT8",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Bar Hanging L Sit ",
    shortYouTubeDemonstration: "https://youtu.be/HvdS2ClV9KU?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Ring Hanging L Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/_o_4N2yJwAw?si=Hum3bBKngYoqfDUc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Suitcase Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/CQR7UUijw38?si=ncO4L8hVq2h4htQQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Parallette L Sit Flutter Kicks",
    shortYouTubeDemonstration:
      "https://youtu.be/zDRj6Sw6tw8?si=Fp368ZWQaw_YDQay",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Single Arm Contralateral Single Leg Push Up",
    shortYouTubeDemonstration: "https://youtu.be/I6f7uUmozDY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Tuck Planche Push Up",
    shortYouTubeDemonstration: "https://youtu.be/hFHpQAqqMDA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Other",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Maltese Push Up",
    shortYouTubeDemonstration: "https://youtu.be/kpOpHoywVKU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Tuck Planche Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Other",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette L Sit to Tuck Planche Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/uI8nV93qBOE?si=dEvkASEnkOSkbUd8",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Other",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring L Sit to Tuck Planche Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Other",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Advanced Tuck Front Lever Pull Up",
    shortYouTubeDemonstration:
      "https://youtu.be/cVdb8oUGKAw?si=tC4dDZ3QsBtE_4_m",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Gironda Sternum Chin Up",
    shortYouTubeDemonstration:
      "https://youtu.be/58QkcGVA12A?si=ddrndE8UqnvYVadB",
    inDepthYouTubeExplanation:
      "https://youtu.be/kcWFzrolwHU?si=FzhQhg349iqrVu8i",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar L Sit Archer Pull Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Straddle Front Lever Pull Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Strict Muscle Up",
    shortYouTubeDemonstration:
      "https://youtu.be/t8_M2aHiNDk?si=s9zri6LcdUJrvwbV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "False Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Tuck Front Lever Pull Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Tuck Planche Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/U-MgWVM_2-Y?si=-XnkVL5OAVXtyCPu",
    inDepthYouTubeExplanation:
      "https://youtu.be/4IISjdSCw5k?si=HWpyENQN5lT6kfEx",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Other",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Clubbell Asynchronous Mill",
    shortYouTubeDemonstration:
      "https://youtu.be/2t7u5sapU1Q?si=KigwClnysDsb8CGJ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Order Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Alternating Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight L Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/pO4BH0dKCIY?si=qKwpWcDltQZ0K61z",
    inDepthYouTubeExplanation:
      "https://youtu.be/IUZJoSP66HI?si=4Rss_iv_l3qXCY_0",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Single Arm L Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/l-7PDo_nf-c?si=SV8BnhirXI2QflsN",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "L Sit",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Alternating Single Arm Kettlebell Low Hold Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/X8I4Uq4QgYE?si=0ZNJz2TPEC0nSZaa",
    inDepthYouTubeExplanation:
      "https://youtu.be/jMMpHfKVb-s?si=9nnfdpAU8JLm1RqJ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/vVElqek25fI?si=4-FGE3vFSRTkYdG4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/oOB02xJgzrA?si=IO-ooFFstcNesTGD",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/tildBryP8bI?si=mIky-m7uqR4kMvB3",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Alternating Forward Lunge",
    shortYouTubeDemonstration: "https://youtu.be/q7sQB0_p7XQ?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Parallette V Sit to Pike Press Handstand",
    shortYouTubeDemonstration:
      "https://youtu.be/i3tkgdhZuj0?si=lupWBeLYXNXi2bV0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Pseudo Planche Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/f09iB8jbioo?si=MFJiOigiohOtQybY",
    inDepthYouTubeExplanation:
      "https://youtu.be/uJ8BSKqNL2Q?si=yrWRLDv4E3twf0UP",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Macebell Order Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Foot Elevated Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Feet Elevated Glute Bridge",
    shortYouTubeDemonstration:
      "https://youtu.be/8Ta_A9vAEGs?si=pSj3gDFijzwcALE4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Mountain Climber",
    shortYouTubeDemonstration:
      "https://youtu.be/kLh-uczlPLg?si=WfwS9PlCOc9d1t1N",
    inDepthYouTubeExplanation:
      "https://youtu.be/cnyTQDSE884?si=-R4zNi4l233bGK8A",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Suspension Feet Elevated Mountain Climber",
    shortYouTubeDemonstration:
      "https://youtu.be/XiB48dLaB9g?si=RkTU535X9lQ-XULA&utm_source=MTQxZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/Xp22HNYkZRI?si=STxSvQzTFkqZV_Ra&utm_source=MTQxZ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Straddle L Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/XS7Y1jQ-kxs?si=hFDuiao7cTRRHUCT",
    inDepthYouTubeExplanation:
      "https://youtu.be/FAkSQE9cLDM?si=8vu1ONbtVyBDEhZQ",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Alternating Reverse Lunge",
    shortYouTubeDemonstration: "https://youtu.be/xhyigP6lpAM?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/lyMHR7F8lPA?si=An72TBlVkZQu4GMO",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Wall Facing Handstand Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/ZDhNSacJLEE?si=aGw3Fw5a7Q34pWuk",
    inDepthYouTubeExplanation:
      "https://youtu.be/gdhmNaZ7nAk?si=T4ilRD-M0KLF7m_h",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Pelican Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/4zSzWYRiBGI?si=NqLN5I_ZFwPkfPXM",
    inDepthYouTubeExplanation:
      "https://youtu.be/FdHD9_QPrYQ?si=_YoFuGGgP9tX8_95",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Back Rack Alternating Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/_iZ9bGw84H8?si=4Ff3XGU-WRY1uN0k",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Alternating Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/b8ldbeOnJEI?si=PBXslcF1v1YEXgGU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Feet Elevated Pelican Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/HdaAXHcN0-M?si=fT7_2ec7wdcSALfm",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Suspension Pelican Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Tuck L Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/Vuc-nodHS0Y?si=S81fiCUEtPrZUe6Z",
    inDepthYouTubeExplanation:
      "https://youtu.be/NeJDHqCt-Iw?si=teutU9ZtUh-eMFtg",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tuck L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Hanging Tuck L Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/SLyOG8ujcu0?si=IAzc53JTuuKNMz90",
    inDepthYouTubeExplanation: "https://youtu.be/U6vPgL10NT0?feature=shared",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Hanging Tuck L Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/QA_dH6cjbw0?si=29xMuvVPe0ttRvvK",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Overhead Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/LMStE_hD9E4?si=_iskUn08-BQH0mYu",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Mountain Climber",
    shortYouTubeDemonstration:
      "https://youtu.be/5BaV4f58I3c?si=LhV-BmrDvHK1G_uI",
    inDepthYouTubeExplanation:
      "https://youtu.be/H3M1UKeySQs?si=dbukNE8t9wj_3xyc",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Feet Elevated Mountain Climber",
    shortYouTubeDemonstration:
      "https://youtu.be/kbPOFMH-Ivk?si=ftd7bXesKjVBgNrW",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Overhead Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/neuw_JknIms?si=QPBFpV8bvbtlFLfL",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Dead Hang",
    shortYouTubeDemonstration: "https://youtu.be/uMcoQ-ijpsk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Teres Major",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Kneeling Push Up",
    shortYouTubeDemonstration: "https://youtu.be/iHR7BprMyEc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Clubbell Outside Circle",
    shortYouTubeDemonstration:
      "https://youtu.be/9lVJZ8o8nzM?si=4NnTRdg9x60PkNsZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/-MuseVIc0bg?si=Ud93xU7eP4DnCjdH",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Macebell Order Carry",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Order Carry",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Macebell Order Carry",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Macebell Order March",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Macebell Order March",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Alternating Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Alternating Reverse Lunge",
    shortYouTubeDemonstration: "https://youtu.be/N4GPqbj8Nds?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball T's Y's I's ",
    shortYouTubeDemonstration:
      "https://youtu.be/1jP1PR9Gls0?si=esOirS5dWd5oUqG0",
    inDepthYouTubeExplanation:
      "https://youtu.be/jihh8FFWoMk?si=qyxtXrUK9hFRpAAE",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Postural",
  },
  {
    name: "Resistance Band Reverse Fly",
    shortYouTubeDemonstration: "https://youtu.be/C2wsrjVHvuA",
    inDepthYouTubeExplanation: "https://youtu.be/cyihFNmsq-A",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Resistance Band Lateral Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/1feV0cW5U60?si=e6dhNFXt6CLSbkRE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Lateral Deltoids",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Trapezius",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Lateral Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/XPPfnSEATJA?si=yNFrwT2Aj4G98NVF",
    inDepthYouTubeExplanation: "https://youtu.be/3VcKaXpzqRo",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Lateral Deltoids",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Trapezius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Resistance Band Standing Shoulder External Rotation",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/cFyP6e4XeGo",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Seated Lateral Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/GBo4Cj8i9VI?si=_ZCYRalndjXZl58y",
    inDepthYouTubeExplanation: "https://youtu.be/3zohLHTjFH0",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Lateral Deltoids",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Trapezius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Side Lying Shoulder External Rotation",
    shortYouTubeDemonstration: "https://youtu.be/_qPQKid-LRs",
    inDepthYouTubeExplanation: "https://youtu.be/UmVD6TKo9CA",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Lying",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Miniband Standing Shoulder External Rotation",
    shortYouTubeDemonstration: "https://youtu.be/4cpQr1VbcEU",
    inDepthYouTubeExplanation: "https://youtu.be/VpiQKz-PUxU",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Dumbbell Side Lying Shoulder Internal Rotation",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/KDyPlr_tm-w?si=ideKS24XjGyapd7Y",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Subscapularis ",
    secondaryMuscle: "Teres Major",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Lying",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Internal Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Double Dumbbell Seated Arnold Press",
    shortYouTubeDemonstration: "https://youtu.be/4Hwcp9HP9D4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 2,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Cable Lateral Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/9s0F9lgTG0E?si=hlzVQJ0I5qgbvM45",
    inDepthYouTubeExplanation: "https://youtu.be/FGU9j1P5L-w",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Lateral Deltoids",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Trapezius",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Seated Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/3GFZpOYu0pQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/AqzDJHxynwo?si=FpgeOvlc1u-WxGMb",
    inDepthYouTubeExplanation: "https://youtu.be/M2rwvNhTOu0",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Shrug",
    shortYouTubeDemonstration:
      "https://youtu.be/llSrlpd7TEE?si=7L7ARn0S6ByQmI59",
    inDepthYouTubeExplanation: "https://youtu.be/cJRVVxmytaM",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Standing Scaption",
    shortYouTubeDemonstration:
      "https://youtu.be/bhemEvr0qiM?si=WahKrQS3-uEP1hYU",
    inDepthYouTubeExplanation: "https://youtu.be/XOAIGRH90RY",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Supraspinatus",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Scapular Plane Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: null,
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "EZ Bar Kneeling Rollout",
    shortYouTubeDemonstration:
      "https://youtu.be/qGVLUwKTvTw?si=wziniMZUeqke6bE4",
    inDepthYouTubeExplanation:
      "https://youtu.be/MLwO9-cAjcA?si=rIoXi2XPlr8-o9Q7",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "EZ Bar Standing Rollout",
    shortYouTubeDemonstration: "https://youtu.be/zGZrhC_VWIQ?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Seated Scaption",
    shortYouTubeDemonstration: "https://youtu.be/Vn1cULRUhZI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Supraspinatus",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Scapular Plane Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: null,
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Double Dumbbell Seated Scaption",
    shortYouTubeDemonstration: "https://youtu.be/PKgkMmXAVUs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Supraspinatus",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 2,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Scapular Plane Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: null,
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Double Dumbbell Bicep Curl",
    shortYouTubeDemonstration: "https://youtu.be/WYezBGuUsdw",
    inDepthYouTubeExplanation: "https://youtu.be/xxgxVU1NsNc",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Incline Bench Bicep Curl",
    shortYouTubeDemonstration: "https://youtu.be/bgYt7ZgFc9M",
    inDepthYouTubeExplanation: "https://youtu.be/soxrZlIl35U",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Hammer Curl",
    shortYouTubeDemonstration: "https://youtu.be/h46ccQsXDEk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Cross Body Hammer Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/buP9fSqWcw4?si=-lKec0VHJ1XbZYRH",
    inDepthYouTubeExplanation: "https://youtu.be/0jLf1MYSp3c",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Incline Bench Preacher Curl",
    shortYouTubeDemonstration: "https://youtu.be/DPYrHeVKvQA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Bicep Curl",
    shortYouTubeDemonstration: "https://youtu.be/at2g_OGyuDE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Zottman Curl",
    shortYouTubeDemonstration: "https://youtu.be/wrjEdVZrkhk",
    inDepthYouTubeExplanation: "https://youtu.be/aAuOsw9D7Hc",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachioradialis",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Waiter Curl",
    shortYouTubeDemonstration: "https://youtu.be/DjgrEWlgGaY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Straight Bar Drag Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/s_5mJUQqQpY?si=4zKcXdHvIHVCrn6n",
    inDepthYouTubeExplanation: "https://youtu.be/3ib-M9kKSvU",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Rope Hammer Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/BXcSLzXrab4?si=KZPHi7uurh7Nb31j",
    inDepthYouTubeExplanation: "https://youtu.be/vsarApmqJmo",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/Z8dcGhS8giQ?si=iQZ35AJwvoHewxyk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Bicep Curl",
    shortYouTubeDemonstration: "https://youtu.be/nipJ27JfpUI",
    inDepthYouTubeExplanation: "https://youtu.be/-oKBUozdRdI",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Tricep Kickback",
    shortYouTubeDemonstration:
      "https://youtu.be/m_UlDFNX4mk?si=FAleOyAOFc4IiSBT",
    inDepthYouTubeExplanation: "https://youtu.be/ShCYaoHmWmk",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Tire Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/yrNR2OK50Lw?si=o9UhhO3HdGYOlRvS",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Tire Jump Through",
    shortYouTubeDemonstration: "https://youtu.be/1DBz3vodUUc?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Tire Broad Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/juTI6wnRiZ8?si=AItO7HER5TxfhHc9",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Tire Step Up",
    shortYouTubeDemonstration: "https://youtu.be/4RsPF6KynpE?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Tire Alternating Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/JdYIi6Vedy8?si=XLKOd1kgeuZgH3Wp",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Tire Alternating Toe Taps Around the World",
    shortYouTubeDemonstration:
      "https://youtu.be/diT5j5QRKhs?si=KBmQGQunZ8mtj5zz",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Dumbbell Seated Overhead Tricep Extension",
    shortYouTubeDemonstration: "https://youtu.be/-aBcUgsn8Dc",
    inDepthYouTubeExplanation: "https://youtu.be/nRiJVZDpdL0",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Tire Lateral Jump Through",
    shortYouTubeDemonstration:
      "https://youtu.be/H80_t9poKQo?si=eTIuIU_bwT40hUvJ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Tire Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/QskOD3ROxGs?si=Vh3moyP5PVPO8sMy",
    inDepthYouTubeExplanation:
      "https://youtu.be/gnqD0m-uosY?si=25hCZEL3NusAufP2",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Other",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Dumbbell Overhead Tricep Extension",
    shortYouTubeDemonstration: "https://youtu.be/7h3lG2WnLXg",
    inDepthYouTubeExplanation: "https://youtu.be/-Vyt2QdsR7E",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Close Grip Floor Press",
    shortYouTubeDemonstration: "https://youtu.be/s6ydoB3ktlI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/c2D4GkTgyo4?si=s6c03eCCz8TWg7br",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Barbell Suitcase Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/-FZcqOBDphU?si=FQJnUQP2TsxKmhRA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/BnLkbAGE4b4?si=mRL2wc8pDdJKZNbY",
    inDepthYouTubeExplanation:
      "https://youtu.be/fwyXHjQHahE?si=yPUP0ZC5mO7XZfqm",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Bulgarian Split Squat Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/ABtwgwo4zyQ?si=eWDNpXtH8qJ31y72",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Bodyweight Lateral Bear Crawl",
    shortYouTubeDemonstration: "https://youtu.be/JLtXEZAwNxQ?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Hover Quadruped",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Animal Flow",
  },
  {
    name: "Bodyweight Step Up Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/bZYAKXoBXGs?si=HbHeFnXtAvKsYndx",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Tire Step Up Jump",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Bodyweight Alternating Step Up Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/vX2vagAc8Mw?si=UH9R_7g0TbIQyHja",
    inDepthYouTubeExplanation:
      "https://youtu.be/TGtwCyVqfvM?si=nY8PVGvM5w-oe3pA",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Tire Alternating Step Up Jump",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Barbell Power Clean to Push Press",
    shortYouTubeDemonstration:
      "https://youtu.be/4ws-kHR5NaU?si=3YQjL6sBFZ3aL-hW",
    inDepthYouTubeExplanation:
      "https://youtu.be/1LB8uJ53rtU?si=NIsnNwBdgEC2BFQY",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Double Dumbbell Close Grip Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/bo6bVNho2v8?si=hNk_wo1PWsqhkRyo",
    inDepthYouTubeExplanation: "https://youtu.be/zZX5AGyg3VQ",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Inside Pendulum",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Clubbell Outside Pendulum",
    shortYouTubeDemonstration:
      "https://youtu.be/nDGz-drTS1E?si=phIMAk1VibF9KzwH",
    inDepthYouTubeExplanation:
      "https://youtu.be/SchCGLfQbjI?si=4uNXcTAfcXJIg1Zk",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Outside Pendulum",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Inside Pendulum to Outside Pendulum",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Outside Pendulum",
    shortYouTubeDemonstration:
      "https://youtu.be/8v5XgK3oeeE?si=kU1NrAcgDEWvlUj6",
    inDepthYouTubeExplanation:
      "https://youtu.be/y9qsJ0bpmzs?si=igrSLxqXhCydTTCr",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Inside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Outside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Side to Side Swing",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/W1CVv9d7S2s?si=zhItsVu0-7YPmT9k",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Dumbbell Close Grip Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/a2RWkUS7ja4?si=MlLBdANbCwT-w0d1",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Rope Tricep Pushdown ",
    shortYouTubeDemonstration: "https://youtu.be/e5aj8hhCPkA",
    inDepthYouTubeExplanation: "https://youtu.be/kiuVA0gs3EI",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Incline Push Up",
    shortYouTubeDemonstration: "https://youtu.be/CKKfNBe687Q",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Kneeling Push Up",
    shortYouTubeDemonstration: "https://youtu.be/TBpk09QuVN8",
    inDepthYouTubeExplanation: "https://youtu.be/utzhPQuXWcA",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Suspension Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/cp_Hl7qd7CI?si=Tw8VVXnhtyW9vra4",
    inDepthYouTubeExplanation: "https://youtu.be/-vPgHzuRI7I",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Chest Fly",
    shortYouTubeDemonstration: "https://youtu.be/ELmdfR9JvEA",
    inDepthYouTubeExplanation: "https://youtu.be/VeiB4nfSpeQ",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Double Dumbbell Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/pHsw9uHVXWA?si=0LlXNPKcyTKyfgU4",
    inDepthYouTubeExplanation: "https://youtu.be/XrtKbiQdblE",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 2,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Dumbbell Pullover ",
    shortYouTubeDemonstration: "https://youtu.be/TI1gb3GFUVA",
    inDepthYouTubeExplanation: "https://youtu.be/clxR72S_Gpo",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Triceps Brachii",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Tire Feet Elevated Glute Bridge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Incline Bench Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/JSDpq14vCZ8?si=DX2UhxTVlOLFkyF3",
    inDepthYouTubeExplanation: "https://youtu.be/bDaIL_zKbGs",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Low Row",
    shortYouTubeDemonstration:
      "https://youtu.be/hULU2N_9qjk?si=XmozOzBr-Uny0t4A",
    inDepthYouTubeExplanation: "https://youtu.be/fW_jdwZT804",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Tire Flip",
    shortYouTubeDemonstration:
      "https://youtu.be/44E5KRVFWVQ?si=M9W-NS9JbwJV8hDU",
    inDepthYouTubeExplanation:
      "https://youtu.be/E0G9LdH3ElA?si=hdeIwvYNbInrIJv-",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Horizontal Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Tire In and Out Squat Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/4h3cIxkFwlI?si=s_iXYmvt1ljfSFML",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Kettlebell Goblet Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/wkMhmQ5wVWY?si=kFZCkvoaBfUNdjvU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Feet Elevated Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/UCfMPCfug60?si=hzjhqnpt1-9bHCWt",
    inDepthYouTubeExplanation:
      "https://youtu.be/tkQ0GiXjnLY?si=YH5gL0smmH4Zzsp0",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/wsOcmGYOn3M?si=2w1Cs0RdcdjnHLYG",
    inDepthYouTubeExplanation:
      "https://youtu.be/Xfe4ZqiKvnY?si=SPmV8K7dm9_wENj9",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Mid Row",
    shortYouTubeDemonstration: "https://youtu.be/W-nnq0Ks1A0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Seated Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/3ZRe_QpvRPg?si=X5ees0OsHDogPrA9",
    inDepthYouTubeExplanation:
      "https://youtu.be/v_49uUA_87Y?si=ELs6WJVxlAxiBxc1",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Seated Calf Raise",
    shortYouTubeDemonstration: "https://youtu.be/hv00OCqm0HI?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Feet Elevated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Feet Elevated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Feet Elevated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Hand Assisted Feet Elevated Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/JUDbOvgH6AQ?si=p3CkDDLIlKjuufVF",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Hand Assisted Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/HwG4_WIMB7g?si=ly2SGRWM5lHuzOHF",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/tg3HcGWhGN8?si=i7ZBKBUTgTovDmeO",
    inDepthYouTubeExplanation:
      "https://youtu.be/_5R7wFS6l9o?si=it4x_lijASZb-Hin",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Hand Assisted Foot Elevated Single Leg Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/5hkhz_nMuws?si=gPxN6_F1w9qQdHvy",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Hand Assisted Single Leg Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/5hkhz_nMuws?si=M_cdEJeEYZLJJD6j",
    inDepthYouTubeExplanation:
      "https://youtu.be/OG3OgpXsirQ?si=P1K2mbeIf5RN75wg",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Single Leg Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/AWBGE0PlYkI?si=INJvlHfbZ6BpG0RT",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Feet Elevated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/Q8s5KVgRjsI?si=LU2DAUzkwtjOm87N",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell L Sit Flutter Kicks",
    shortYouTubeDemonstration:
      "https://youtu.be/bNmYhWaTtDE?si=0pRJsSgsFQN8tX9D",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Dumbbell Front Rack Feet Elevated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Calf Raise",
    shortYouTubeDemonstration: "https://youtu.be/nDJ9cjw2J7Y?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Feet Elevated Calf Raise",
    shortYouTubeDemonstration: "https://youtu.be/-zJsdaS13fk",
    inDepthYouTubeExplanation: "https://youtu.be/3UWi44yN-wM",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Tire Mountain Climber",
    shortYouTubeDemonstration:
      "https://youtu.be/-ouYHaP9g9g?si=qc9f_XLeK0tBdsDc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Wall Supported Tibialis Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/nQKgHwi8W9E?si=h2cdsN6y8_YWkxWd",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shins",
    primeMoverMuscle: "Tibialis Anterior",
    secondaryMuscle: "Extensor Digitorum Longus",
    tertiaryMuscle: "Extensor Hallucis Longus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Dorsiflexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Seated Tibialis Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/XPrwraNV8zU?si=uYKDsDSy6F1lqx7L",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shins",
    primeMoverMuscle: "Tibialis Anterior",
    secondaryMuscle: "Extensor Digitorum Longus",
    tertiaryMuscle: "Extensor Hallucis Longus",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Dorsiflexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Seated Single Leg Tibialis Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/tSDRe05L18Q?si=tzWWp_aDlp6K7_QS",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shins",
    primeMoverMuscle: "Tibialis Anterior",
    secondaryMuscle: "Extensor Digitorum Longus",
    tertiaryMuscle: "Extensor Hallucis Longus",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Dorsiflexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Kettlebell Goblet Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/oV97EckMQlo?si=-UB0G60JaIQ6f-4v",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Seated Tibialis Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/2amvxbpU20c?si=ymK8PzcHyFCMv-oX",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shins",
    primeMoverMuscle: "Tibialis Anterior",
    secondaryMuscle: "Extensor Digitorum Longus",
    tertiaryMuscle: "Extensor Hallucis Longus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Dorsiflexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Kettlebell Horn Grip Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/hP0wET7bCog?si=trU9Rde7VACKCuEn",
    inDepthYouTubeExplanation:
      "https://youtu.be/cdkgLvRQrds?si=646WtiitsMnlvkeL",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Low Hold Alternating Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/w6vfiCgfbXA?si=RhaJhv_PYjW4LLj5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Seated Feet Elevated Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/W5FNgQSaDfU?si=mrb4anmAuXMyWfuC",
    inDepthYouTubeExplanation:
      "https://youtu.be/ldpodfZ7LWY?si=EH3iaPoAqbWcsd0W",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Seated Feet Elevated Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/TyJOknODp8g?si=lIKKdyiWkncjpZtZ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/fZeR04SyMnM?si=PcC3GMitpRy-d_N5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Tire Leg Press",
    shortYouTubeDemonstration:
      "https://youtu.be/YtKIXuPCj1M?si=ng5HKT4Y_EUFLk95",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Isometric Split Squat Pallof Press",
    shortYouTubeDemonstration: "https://youtu.be/zMR-P_9GGKE?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bodyweight Isometric Split Squat Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/pM_ycFCgDxU?si=YT2fo22-rIu4kKPM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bodyweight Isometric Split Squat Foot Elevated Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/mdl2K7zkcQ8?si=HIQ62ZGgxGxvMCfb",
    inDepthYouTubeExplanation:
      "https://youtu.be/9oFtS1mmQqI?si=xhMPJdIcP3qhe0rX",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Dumbbell Suitcase Isometric Split Squat Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Dumbbell Suitcase Isometric Split Squat Foot Elevated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/_3QAdrNQ3NY?si=zaDfMakntgtadbWa",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Kettlebell Horn Grip Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/hn0H9wrT7I0?si=2puOZbS5dzRQTGh6",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/d7cVOMtyjS8?si=-LwL939gyb_zs3lu",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Isometric Split Squat Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Back Rack Isometric Split Squat Foot Elevated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Front Rack Isometric Split Squat Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Front Rack Isometric Split Squat Foot Elevated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Dumbbell Suitcase Hand Assisted Ipsilateral Foot Elevated Single Leg Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/xASrMCHjL4M?si=-Ue1QOKJH5pRPoTH",
    inDepthYouTubeExplanation:
      "https://youtu.be/DlcI-MK6jAA?si=HTeklTo4dzB7J-Q8",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Straddle L Sit",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Dumbbell Front Rack Isometric Split Squat Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Dumbbell Front Rack Isometric Split Squat Foot Elevated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Front Rack Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Foot Elevated Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Squat Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/YGGq0AE5Uyc?si=or6Xddi0YaAkHuXV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Double Dumbbell Suitcase Alternating Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/R61TjoYofDE?si=sA8kbakWIt24ow1A",
    inDepthYouTubeExplanation:
      "https://youtu.be/9ZknEYboBOQ?si=etxIUbD8aSv-CXob",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/hKLIHPXmPA4?si=mk9hkktF_4qw0okV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable V Grip Seated Low Row",
    shortYouTubeDemonstration: "https://youtu.be/EhAho9Szp-0",
    inDepthYouTubeExplanation: "https://youtu.be/4mRy8U542Fo",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Half Kneeling Face Pull",
    shortYouTubeDemonstration: "https://youtu.be/pxnaBaRRZiY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Prone Cobra",
    shortYouTubeDemonstration:
      "https://youtu.be/NZSBjpVpvw8?si=lyk8zIAtzX2ETUc_",
    inDepthYouTubeExplanation:
      "https://youtu.be/0RAs3-Yx8oo?si=bbVyMH6ocCggjG5u",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Erector Spinae ",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Postural",
  },
  {
    name: "Barbell Hang Power Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/-mLzQdVAwlw?si=sQHYkOPNIgOBbsrh",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Hang Squat Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/IucshEToDyM?si=ifH3zkJMJVCHypGV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Double Dumbbell Seated Reverse Fly",
    shortYouTubeDemonstration: "https://youtu.be/cL1HxbOBkTs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Seated Concentration Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/a2OQCwG9bd0?si=d_4n3IRKXeYoxBNs",
    inDepthYouTubeExplanation: "https://youtu.be/dgvKbfP6lTU",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Seated Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/eZAvPxEB5Dw?si=ZrwbDJ6qgGac-wRn",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Front Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/c4EhnuYZQI8?si=O-MyHEA_d4DRkcEA",
    inDepthYouTubeExplanation: "https://youtu.be/941eb4N2Xeo",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Wide Grip Lat Pulldown",
    shortYouTubeDemonstration: "https://youtu.be/UWhyxvCCzhw",
    inDepthYouTubeExplanation: "https://youtu.be/83Y3CFcgnkQ",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Reverse Grip Lat Pulldown",
    shortYouTubeDemonstration: "https://youtu.be/zLKwAYUmGMc",
    inDepthYouTubeExplanation: "https://youtu.be/apzFTbsm7HU",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable V Grip Lat Pulldown",
    shortYouTubeDemonstration: "https://youtu.be/8hzVLzu-RJk",
    inDepthYouTubeExplanation:
      "https://youtu.be/neP32qCyPbQ?si=4k6HBAqUAMlVJSMT",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Bicycle Crunch",
    shortYouTubeDemonstration:
      "https://youtu.be/fHXcyedPCPo?si=haa5Z5z5wbVY6loh",
    inDepthYouTubeExplanation:
      "https://youtu.be/lv6BT8_5iIs?si=1SKpBjIi2BRf2k0f",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Alternating",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Broad Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/0P8dbnUQrJI?si=IoU6OTqa34IekCVQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Bodyweight Forearm Plank",
    shortYouTubeDemonstration: "https://youtu.be/YvUw_mKMGfQ?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/MP6yL_KKxYY?si=Q87bAjMVT-uTdGRq",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Clubbell Clean to Shoulder Park Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: null,
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Shoulder Park Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/oNZnCluUrjQ?si=NER_BSsVDrgi7GOm",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Clubbell Shoulder Park Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Swing to Alternating Shoulder Park Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/88ySRsmla4U?si=HG4Mctbie8EQOKUi",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Dumbbell Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/q3cXdiyY7-Q?si=8ulm789f1CXgoDiT",
    inDepthYouTubeExplanation: "https://youtu.be/x5IU1KAVwSo",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/ZaDlbm8E8Tg?si=BvNUvyhh8eTuBDsz",
    inDepthYouTubeExplanation: "https://youtu.be/xphvjGDZeYE",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Split Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/GUDkOtraHHY?si=rRrpCqPIVW7T-7T5",
    inDepthYouTubeExplanation:
      "https://youtu.be/yyZAPfOaONk?si=ylej6-jrchib31VF",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Power Clean to Split Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/Sk1vhXhHO_A?si=scaLm9b6g937lMhn",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Double Dumbbell Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/7QUcsq019Qs?si=rxXGikxFs6Y3YwPL",
    inDepthYouTubeExplanation: "https://youtu.be/0G2_XV7slIg",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Power Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/XtRq5jzUHqE?si=dBupO-9VrVoLknW-",
    inDepthYouTubeExplanation:
      "https://youtu.be/Ir_34nxrk1Q?si=L37XmNS-wuocDj7E",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Squat Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/vXTeZah_FjI?si=21zLDY_gy9epZ8bD",
    inDepthYouTubeExplanation:
      "https://youtu.be/iFc4l24llpw?si=IacHpBp4zAC09W4q",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Double Kettlebell Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/t7dkLHdZ9uM?si=2TNd4Es589Vlu5uz",
    inDepthYouTubeExplanation:
      "https://youtu.be/ygFBq3Bfb4c?si=iz5oUuggWLJU3cLH",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Seated Wall Angels",
    shortYouTubeDemonstration:
      "https://youtu.be/_VrAJlhDkIc?si=8vRLbrTcTLygHKZE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Parallette Kneeling Close Grip Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Shrug",
    shortYouTubeDemonstration: "https://youtu.be/dB5Wxd_zS80",
    inDepthYouTubeExplanation: "https://youtu.be/QncHUDKABEQ",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius ",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Alternating Split Squat Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/yncmjpwl_9g?si=OTCbmCenqG5BN1WW",
    inDepthYouTubeExplanation:
      "https://youtu.be/ZiupDCper-M?si=YY5sAICbd44A8efW",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Suspension Y Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/0Kr9lVl4JQ8?si=bGLAYv480sV-7xjg",
    inDepthYouTubeExplanation: "https://youtu.be/SdSZwVpun28",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Standing Wall Angels",
    shortYouTubeDemonstration:
      "https://youtu.be/pNuHObBC-rg?si=vkl3Eaw-boo60WvV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Mountain Climber",
    shortYouTubeDemonstration:
      "https://youtu.be/AHwcb1JLtp4?si=XfL4K_pZpBu8QsfO",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Split Squat Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/RtY9kyhuh5I?si=ryQL7SpLXYab74U9",
    inDepthYouTubeExplanation:
      "https://youtu.be/J_4uubd0QX8?si=-Iv6OThDGvT5CPwq",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Bodyweight Duck Walk",
    shortYouTubeDemonstration:
      "https://youtu.be/-swSVo8-i4I?si=sEL_AtnfPtYy7b1X",
    inDepthYouTubeExplanation:
      "https://youtu.be/Wr_IV43jF5Q?si=p2agYKHg9gfmam43",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Transverse Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Animal Flow",
  },
  {
    name: "Barbell Front Rack Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/VsgCBIQE8gU?si=1KNObbTrjXSha2sF",
    inDepthYouTubeExplanation:
      "https://youtu.be/LAt1MjyPtcw?si=MCxotqep2Mnc0eBG",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/wQrvCnYb4yw?si=z3YIBbCc8EKvTdgG",
    inDepthYouTubeExplanation:
      "https://youtu.be/UkC-AQ6k38o?si=7pdkQhi_C1EIaKP0",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Split Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/KpE5v62Qnbk?si=0JFSRtn2gnAhSMeD",
    inDepthYouTubeExplanation:
      "https://youtu.be/hDVCPG3u-xI?si=tQNcuh71dIqaihiD",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Reverse Fly",
    shortYouTubeDemonstration: "https://youtu.be/bYYJ4jQCUtg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Decline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/2B6WxyLaIrE?si=YFskQesFUqPMQA7s",
    inDepthYouTubeExplanation: "https://youtu.be/Pf1nDoqx_1A",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Split Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/li8Cf-vxDvk?si=xn7C8oJeNgbhkv-d",
    inDepthYouTubeExplanation:
      "https://youtu.be/PI-PfjQxr_0?si=vCQbRLiEfsKWR5SP",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/FTRy8SXUJXs?si=9fREcoDrSO9GfdAR",
    inDepthYouTubeExplanation:
      "https://youtu.be/IyY4ungWeRU?si=s6AwB03kSQ7a01Vr",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Bodyweight Copenhagen Plank Side Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/0Cwk_wwL6uM?si=N_sqB6NG5HF2Hv7U",
    inDepthYouTubeExplanation:
      "https://youtu.be/i965d8Rn-XA?si=343e1_vvqPHuB7tW",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Side)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Copenhagen Plank with Leg Lift",
    shortYouTubeDemonstration:
      "https://youtu.be/Tt5O0gfZmr0?si=9wq43SCcrrNE16rB",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Side)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/Nhvz9EzdJ4U?si=MdnuiWNh7Wkz1qK_",
    inDepthYouTubeExplanation: "https://youtu.be/QENKPHhQVi4",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Decline Bench Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/7NlIkLqcgnw?si=uIGPB18ukc3iERL2",
    inDepthYouTubeExplanation: "https://youtu.be/Pf1nDoqx_1A",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Suitcase Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/gI-GqUg47UU?si=GQfpc8cxUMQ4kcui",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Feet Elevated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Bent Over Row",
    shortYouTubeDemonstration: "https://youtu.be/ppmAYXaz0_k",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Bicep Curl to Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/3hFzUnWOQLU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Elbow Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/O2SYdrskhPU?si=RFInB5nFomiISnhm",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Floor Press",
    shortYouTubeDemonstration:
      "https://youtu.be/2pN9ascZfGc?si=MWKxU4_8cj6Sv5bs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Overhead Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/thF_jzznoVk?si=T8bHLGYmbaMBD8uL",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Suitcase Isometric Split Squat Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bodyweight Single Leg Hip Thrust",
    shortYouTubeDemonstration:
      "https://youtu.be/1Dbd7wStRJg?si=Yx13oEQ5A4kl4YJ5",
    inDepthYouTubeExplanation:
      "https://youtu.be/qCObDXTe4KY?si=gnfQ6Ju2Wvq1ZkY0",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Single Leg Hip Thrust",
    shortYouTubeDemonstration: "https://youtu.be/p2Z02O1M18w?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/8-bwTM-m2Ic?si=RTzRlWCm-FPP1lRN",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Suitcase Isometric Split Squat Foot Elevated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Suitcase Hand Assisted Ipsilateral Foot Elevated Single Leg Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/o4VnNZJ_ifM?si=mpuDr1i-66ZFR_7I",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Isometric Split Squat Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Cable V Grip Seated Floor Lat Pulldown",
    shortYouTubeDemonstration: "https://youtu.be/wo-YhhSpEJI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Isometric Split Squat Foot Elevated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Battle Rope Alternating Wave",
    shortYouTubeDemonstration: "https://youtu.be/ZujykKeVZpM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Rope Tall Kneeling Tricep Pushdown",
    shortYouTubeDemonstration:
      "https://youtu.be/fjYbHu5oXn0?si=h7OFn1fToKpfmC3B",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Feet Elevated Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/VuvZCiSMw_A?si=wJFjWj_7127inskf",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Reverse Hyperextension",
    shortYouTubeDemonstration:
      "https://youtu.be/ujcZZ0kLEmY?si=Vb7GDY3_NgNICWqW",
    inDepthYouTubeExplanation:
      "https://youtu.be/ta3YEAkwY38?si=jb8BysD-nNqEPrzP",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Frog Reverse Hyperextension",
    shortYouTubeDemonstration:
      "https://youtu.be/zH8QN413Vuo?si=htM_QtEmupefpV2z",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Reverse Hyperextension",
    shortYouTubeDemonstration:
      "https://youtu.be/UP44YFNMF4A?si=ymXfKPXP3jXmkT4j",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Rope Tall Kneeling Low to High Chop",
    shortYouTubeDemonstration:
      "https://youtu.be/dz0OxCiLkjI?si=-FrxaHRLjT-KzMPb",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight V Up",
    shortYouTubeDemonstration:
      "https://youtu.be/7UVgs18Y1P4?si=o0GvxxE-1wAYvgfE",
    inDepthYouTubeExplanation:
      "https://youtu.be/WTmnP0xIdq8?si=fMOoyGheRtiFA8qN",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Barbell Front Rack Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Barbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Barbell Back Rack Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/svmnL4VOmdQ?si=LsXy5ZYYQ72FtD7F",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Barbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/X9swqObTGJw?si=Qpxrkq0cR0xf5eiU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Push Jerk",
    shortYouTubeDemonstration: "https://youtu.be/VrHNJXoSyXw",
    inDepthYouTubeExplanation:
      "https://youtu.be/Om7vLD6x8W0?si=0w9UP8SpjqwviezS",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Power Clean to Push Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/LtoksZKesMA?si=rSvsSk9ilVqlS937",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Squat Clean to Push Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/GqAEuwXQXRU?si=a2lQdD8ZT7OeBRNX",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Single Arm Kettlebell Outside Swing",
    shortYouTubeDemonstration:
      "https://youtu.be/sEerteQ9q8Y?si=eO7tUCscpuCkcIez",
    inDepthYouTubeExplanation:
      "https://youtu.be/JPKCHFPoAFU?si=BqhPLkb1SjRm5lfM",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Suitcase Alternating Forward Lunge Pass Through",
    shortYouTubeDemonstration:
      "https://youtu.be/61BWrwBMUlk?si=zXjflLRvn7EaFnuR",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Alternating Reverse Lunge Pass Through",
    shortYouTubeDemonstration:
      "https://youtu.be/6flBwO_bKB8?si=_cijIvoTOn2fDR7y",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Contralateral Forward Lunge Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/T6QWzXtiHVk?si=6Qx4S0Y9YS8kR-E8",
    inDepthYouTubeExplanation:
      "https://youtu.be/iAgBpCQUfnc?si=n0yC5vg0Bj6SAWZY",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Alternating Forward Lunge Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/yVbXFUpxZDo?si=fGc1RAIfM6JUdZ4B",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/IfGxPcgiTmY",
    inDepthYouTubeExplanation: "https://youtu.be/VJZDDi-0vGU",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Straight Bar Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/F3Y03RnVY8Y?si=8uzaga9fPI14rc9M",
    inDepthYouTubeExplanation:
      "https://youtu.be/840rgLSw-84?si=4z2ViUdKdvN8MLLp",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Glute Bridge Isometric Floor Press",
    shortYouTubeDemonstration:
      "https://youtu.be/hEEUpEwRE7g?si=x48upd1YMj1w_xrR",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Front Rack Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Suitcase Contralateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/MAiTY-4x82Q?si=zKIXO7qWRH9Fp9yh",
    inDepthYouTubeExplanation: "https://youtu.be/v9gwDwAgT-w?feature=shared",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Suitcase Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Overhead Contralateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Overhead Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Dumbbell Front Rack Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/RoS53TjR2QY?si=6bemyT1DeK6D_ziA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Dumbbell Suitcase Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/jo1G9aygVIY?si=rDCyU7nAR0DQrhQr",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Dumbbell Overhead Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/t27p0HCStHg?si=P5VidxzYpMaxRdyY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Hammer Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/fM0TQLoesLs?si=Jdgh0xyXpZA-KwyM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/-umNkuKth1U?si=17upb868pBHT1MIg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Clubbell Order Contralateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Clubbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Clubbell Order Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Clubbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Clubbell Order Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Clubbell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Clubbell Order Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Clubbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Macebell Order Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Macebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Macebell Order Contralateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Macebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Macebell Order Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Macebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Landmine Goblet Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Landmine",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Landmine Shoulder Contralateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/EKtY3UJFmTg?si=_1L9MCgCQ4f1c_fB",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Landmine",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Landmine Front Rack Contralateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Landmine",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Landmine Front Rack Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Landmine",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Landmine Suitcase Contralateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/XUrqwdRtU54?si=i9PTTagf_EVKwx0j",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Landmine",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Landmine Suitcase Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Landmine",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Landmine Overhead Contralateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Landmine",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Landmine Overhead Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Landmine",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Squat Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/NcyZj45wcnY?si=cwEgFB3aBkfIjMQy",
    inDepthYouTubeExplanation:
      "https://youtu.be/DOg7y1pl830?si=jaq9ut-8jXqSkL-v",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Alternating Double Dumbbell Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/xt1UdzhkMfY?si=OIM1LWctboVJi66d",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Decline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/XuYszvlq1Zk?si=cRt_Xb7fwOGFU40U",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Glute Bridge",
    shortYouTubeDemonstration:
      "https://youtu.be/Zr2RLjIjCN0?si=CFxCFwgSlgd_2sCv",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Top Down Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/LD5vanDs9G4?si=beAWPFWY1Y8shTBO",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Top Down Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/oPk0SGlvX98?si=AjZmhQyk03HHYgPO",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Top Down Decline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Ztg7B04oVXU?si=KGYDSnNrZiBMfVab",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bar Dead Hang",
    shortYouTubeDemonstration:
      "https://youtu.be/4RqNGRVaTUQ?si=geYUBIdFOo8AzeHT",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Teres Major",
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Trap Bar Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/FYx76NSijfU?si=SQ4p_SUWbJGUlk0N",
    inDepthYouTubeExplanation:
      "https://youtu.be/EsqwERaSTMI?si=46F4WdMC1GtBTszu",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Staggered Stance Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/UfCzhPWBmhU?si=PEQal1FTSXhdUQED",
    inDepthYouTubeExplanation:
      "https://youtu.be/F2xkUATJMtw?si=5vZ0oXTeyAWSBokL",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Alternating Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/E-6iFVLC66I?si=HTrleCkD1HyCvWuq",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Goblet Alternating Curtsy Lunge",
    shortYouTubeDemonstration: "https://youtu.be/XLnOFLtWCaU?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Goblet Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/5Pwef_si8Yg?si=GkCw1mY-FLxDTAKz",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Alternating Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/VrOZZjPvj84?si=nwwNU54x-itcb4Ha",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Alternating Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/zUV4jRr6DPk?si=WdsGqclPVPcWvX9C",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Alternating Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/-CSU1ZIDcRs?si=r1puJp7Mv2H5UpDs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Suitcase Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/df-MeZsxCAM?si=DWozx3zEr924L2oN",
    inDepthYouTubeExplanation:
      "https://youtu.be/WEZdzYWaBHE?si=EVbL_ApdGt5F-TTT",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Trap Bar Romanian Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/2L_LpH_IIbc?si=bI9uPdiltgD6G9Mf",
    inDepthYouTubeExplanation:
      "https://youtu.be/rKSiBkmNF4k?si=VH1kreY7mgcDdyPe",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/xE20IwkSELc?si=FM0m4qOgocoDEdDz",
    inDepthYouTubeExplanation:
      "https://youtu.be/pXS-fSPWpk8?si=OPRHTpJpcAIeossv",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Chest Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Rn-hf5iauTc?si=9JMXffEInfAmWfNH",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Resistance Band Alternating Chest Press",
    shortYouTubeDemonstration:
      "https://youtu.be/m3wEZExvGCY?si=qPi52D7LtCC72Ccj",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Trap Bar Deficit Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/n2nbRRSMWu4?si=twYL2iJC0VYVj6WF",
    inDepthYouTubeExplanation:
      "https://youtu.be/ZByBA06ckAA?si=qsVUTvA0N_Sxac7N",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/aciS41CW_Mc?si=7y6xxA-nZjKbqeNc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Squat Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/52-P8hlrKqg?si=cgixMNp8OmG6lTNQ",
    inDepthYouTubeExplanation:
      "https://youtu.be/03pRrE0exUg?si=aE863FCQfwWyA0iv",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Resistance Band Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/gm9bWFtRIrk?si=u3u3eYJ1rcURrYwf",
    inDepthYouTubeExplanation:
      "https://youtu.be/gdZVKOvWI7I?si=9lQDByOgrpRNM_LD",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Battle Rope Power Slam to Burpee",
    shortYouTubeDemonstration:
      "https://youtu.be/WQ7QzKOCVLE?si=rWX43WDQ4l8VmtIy",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Resistance Band Low Row",
    shortYouTubeDemonstration:
      "https://youtu.be/wRLkttcydwo?si=F9hMpgbV2W-oo3W5",
    inDepthYouTubeExplanation:
      "https://youtu.be/5TSE0Irvvmg?si=hz8rIGlf1iimQTNu",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Battle Rope Alternating Reverse Lunge Alternating Wave ",
    shortYouTubeDemonstration:
      "https://youtu.be/cpytZ7Uv85s?si=tl6ya3gXriejNfxT",
    inDepthYouTubeExplanation:
      "https://youtu.be/fb4lS71Js2Q?si=8mxx-uWIeK6GWpl3",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Isometric Split Squat Hold",
    shortYouTubeDemonstration: "https://youtu.be/36kJjDfMHIc?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/-gxiBbZ32Zw?si=FIJP1q9xE4M3IGeJ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bodyweight Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/-aMgxO760L4?si=9gx0HVA_RdsNSgFi",
    inDepthYouTubeExplanation:
      "https://youtu.be/Ms7aIhDm0uc?si=pgjcaF14O52_VWTc",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Frog Pump",
    shortYouTubeDemonstration:
      "https://youtu.be/coFi5XRmTAk?si=b564Njzd_-7c0U9x",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/_gDcrYTfTCU?si=HKjUJaexuiWSopvB",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/SpwcssWT0p4?si=XhO_l77nZbQDRttr",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/-Jb6VkZ4-tc?si=ZY9K1ZxEHtlV_gOz",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Cyclist Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/guw95GpKkY0?si=TrefJn9gELbrR9t3",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Rack Pull",
    shortYouTubeDemonstration:
      "https://youtu.be/5zBwce39LfU?si=N9TY90hZ5tEbb3oc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Mid Row",
    shortYouTubeDemonstration:
      "https://youtu.be/mdf7cMhqRqs?si=P_AYp9PgEajEP_il",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Face Pull",
    shortYouTubeDemonstration:
      "https://youtu.be/HHZ1_OZKLII?si=CyqPWtENsIMkdeyn",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Face Pull to Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/_VZ1cR730rs?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Resistance Band Low Row",
    shortYouTubeDemonstration:
      "https://youtu.be/apYOwiF9moM?si=bOCR3Ldpx6nSTzj0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Resistance Band Mid Row",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Resistance Band Chest Press",
    shortYouTubeDemonstration:
      "https://youtu.be/8gcpEaHDgsY?si=5iKOYsOZ_3phaShu",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Reverse Grip Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/zgV5PpkReuI?si=SX9-dariFRe2W5q5",
    inDepthYouTubeExplanation:
      "https://youtu.be/1Zurwnbeq0g?si=27Ko7dtmR2q-l8jK",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Alternating Reverse Grip Bicep Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Hammer Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/bcond2tqWg0?si=YEuafUqhelVkqYol",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Battle Rope Jumping Jack",
    shortYouTubeDemonstration:
      "https://youtu.be/jnCBdIA1Mno?si=SHMrXoMGIywOdwJ4",
    inDepthYouTubeExplanation: "https://youtu.be/_Optm-uBWHQ?feature=shared",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Lateral Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Lateral",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Battle Rope Squat Jump Power Slam",
    shortYouTubeDemonstration:
      "https://youtu.be/3RbFYYr4RDQ?si=I_hq0oqYA6dy8acI",
    inDepthYouTubeExplanation: "https://youtu.be/L8H8Rmel03c?feature=shared",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Battle Rope Alternating Side Slam",
    shortYouTubeDemonstration:
      "https://youtu.be/0ieiwGvtCT4?si=eBnoeYkD7iu_tawZ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Battle Rope Squat Jump Alternating Wave",
    shortYouTubeDemonstration:
      "https://youtu.be/HMK1KfYKJKw?si=8_j1X9PceX4ykwe_",
    inDepthYouTubeExplanation: "https://youtu.be/vGmTmdm5dCU?feature=shared",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Battle Rope In and Out Squat Jump Power Slam",
    shortYouTubeDemonstration:
      "https://youtu.be/HGV2NJ6EI3A?si=2zud6P-SPcw2soRh",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Battle Rope In and Out Squat Jump Alternating Wave",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Bodyweight In and Out Squat Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/5KT8dr-J65U?si=YGtdHgvAy0DIgmt5",
    inDepthYouTubeExplanation:
      "https://youtu.be/ZAK9zuAmEgM?si=gG1N5knGSir6hDQP",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Miniband Thigh In and Out Squat Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/cguZ74v0_bE?si=wU22GaKrEc-GA4sw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Miniband Ankle In and Out Squat Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/DUf4-qvOroU?si=LFkNn97WQn5oz1m6",
    inDepthYouTubeExplanation:
      "https://youtu.be/Pel6_WkinfE?si=Oki7JKFarr4nz1jL",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Resistance Band Alternating Hammer Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/ojap6yuuKP8?si=iwf3ksV8Zdrr0-Bn",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Y Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Battle Rope Isometric Split Squat Power Slam",
    shortYouTubeDemonstration:
      "https://youtu.be/7cBlrIqHv9o?si=34m2WPXJArSvm8ap",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Battle Rope Alternating Split Squat Jump Alternating Wave",
    shortYouTubeDemonstration:
      "https://youtu.be/0B_lk4-o850?si=g42on5mrqq1cAdUb",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Battle Rope Alternating Split Squat Jump Power Slam",
    shortYouTubeDemonstration:
      "https://youtu.be/nkEeL2ULZGI?si=gDhAhABHiXhwi1Hv",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Single Arm Kettlebell Front Rack Contralateral Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/4NCYLWTv5Mc?si=OT9LNGr9wS3RbezC",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Cuban Press",
    shortYouTubeDemonstration:
      "https://youtu.be/13Au7iJ02c8?si=2JaXbdRT8-eAxkx-",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Horizontal Pull",
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Overhead Contralateral Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/I4lYPJdwnDg?si=8AgvVHOfdxgX_-zE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Tall Kneeling Cuban Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/wKqLt6yMnUc?si=yzbXny1IeJSvvYRH",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Horizontal Pull",
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Pull Apart",
    shortYouTubeDemonstration:
      "https://youtu.be/MnDpmNYUjbc?si=PjX7rTfbGKTyeip0",
    inDepthYouTubeExplanation:
      "https://youtu.be/I2RAu0JicUQ?si=sCosAUyA4-V9ZcOb",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Lateral",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Resistance Band Tall Kneeling Face Pull",
    shortYouTubeDemonstration:
      "https://youtu.be/6VDr-3Cmjzw?si=E5zp1jznZ4XPQQ5b",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/GeA6o0q5ccM?si=958ZadG3-_7ru6ZD",
    inDepthYouTubeExplanation:
      "https://youtu.be/tQ40C0WD6OY?si=V4vctYoeVmYIaH5f",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Alternating Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/kVnIb_csFRw?si=bJHQnzuc7AHgbv9P",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/yQg0mHo-fjQ?si=1wCoEdQg1fR5hmAp",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/Q2eMD8iA-uE?si=aldL_x3sKGW4AXDO",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Dumbbell Front Rack Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/EgG51yB1uZU?si=2CM1EcrBstAp5uOM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Dumbbell Suitcase Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/90Smo-K6RbY?si=kkqWO4ejlGrcq6rR",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Dumbbell Overhead Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/jO2Jl9eZpXk?si=u6mgvf-sooUW7DFo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Incline Bench Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/G4Vdjr-byjE?si=-fBrLWIYYbgneaLx",
    inDepthYouTubeExplanation: "https://youtu.be/osHzkwG-9JE?feature=shared",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Decline Bench Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/UjS2nItQCf8?si=tgrOnpPIy1_W-KAt",
    inDepthYouTubeExplanation:
      "https://youtu.be/6YecVVStK5g?si=NizVn6jI44uFLdd_",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/ndVUBZ0Bch0?si=pSuQf6mCBer_ztTt",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Incline Bench Skull Crusher",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Decline Bench Skull Crusher",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/6gvmcqr226U?si=Ubc_zUNwRYINkZSI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Reverse Grip Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/mq_KoN3oCgo?si=zVWL6owtdpddPPFb",
    inDepthYouTubeExplanation:
      "https://youtu.be/k5K5hBbh5GU?si=TwwhRipuAVNIa80O",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Foot Elevated Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Foot Elevated Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Foot Elevated Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Foot Elevated Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Foot Elevated Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Foot Elevated Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Foot Elevated Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/ma__uqUlYmE?si=Yw6Iw4KOA3T7mJeL",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Knee Supported Row",
    shortYouTubeDemonstration:
      "https://youtu.be/ZRSGpBUVcNw?si=x3MRv2xRNjCc6s42",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Knee Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Pullover",
    shortYouTubeDemonstration:
      "https://youtu.be/owr5y-s6-Qk?si=gd2Nfg1PVMbahXjx",
    inDepthYouTubeExplanation:
      "https://youtu.be/tcHaHIQStsk?si=PqW1mpuuLU_9M5qj",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Triceps Brachii",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Incline Bench Pullover",
    shortYouTubeDemonstration:
      "https://youtu.be/LQEag7MKXSs?si=vVcujNN4QVFLQ71H",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Triceps Brachii",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Tire Incline Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/sYpuz37bK2k?si=UpMtMbHU8GOboER_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Dumbbell Close Grip Decline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/vpLJQad7knM?si=pIJlngHZuaHODElA",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Eccentric Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/4JJB2m4AuO8?si=NqYITu6_1fcaAbn7",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Dumbbell Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/HnHuhf4hEWY?si=WSqsCA9Khdbz3ag0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Knee Hover Quadruped Fire Hydrant",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Hover Quadruped",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip External Rotation",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Incline Bench Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/aG7CXiKxepw?si=FH8eUTIYzp_z04m0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Seated Hammer Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/4hKyhFBeclI?si=OrpNWuwGzVfolESP",
    inDepthYouTubeExplanation:
      "https://youtu.be/BbxA1QF3TxY?si=m2zHc3OC-vZ5FGpY",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Seated Hammer Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/YW9citXbrQc?si=5VFsuGIAvF6WHm17",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Incline Bench Hammer Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/1Z6XiaBxwHQ?si=Da0lptFOFg_s0tyV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Half Kneeling Windmill",
    shortYouTubeDemonstration:
      "https://youtu.be/c0LP3YIO4vY?si=w_DOEV2ERQmctiSb",
    inDepthYouTubeExplanation: "https://youtu.be/tAmKMKeR2D4?feature=shared",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Double Dumbbell Windmill",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Alternating Double Dumbbell Incline Bench Hammer Curl",
    shortYouTubeDemonstration: "https://youtu.be/Z_oWLq9uQZI?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/UmtLSH0s4v8?si=mi5RzLbOJtgscXNS",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Cyclist Thruster",
    shortYouTubeDemonstration:
      "https://youtu.be/qoswYkyJG-I?si=Jigh3MmNt7IIj-BA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Cyclist Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Alternating Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Kettlebell Goblet Pistol Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/JS5HxlkWZzU?si=gKhPydrLwgHeGTcO",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Kettlebell Horn Grip Alternating Pistol Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/WGCrIXBHteQ?si=lcLSwZ_90St3r6W4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Dumbbell Bent Press",
    shortYouTubeDemonstration:
      "https://youtu.be/4cCItXCsEDo?si=xrvm1LxY3e8jhStd",
    inDepthYouTubeExplanation:
      "https://youtu.be/XuCIox7PkwE?si=inxKBdmuWIacD8Yw",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Single Arm Dumbbell Half Kneeling Bent Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Double Dumbbell Seated Zottman Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/FG6Y_r6-DJM?si=2qExXvynTbOnna2u",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachioradialis",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Straight Bar Tricep Pushdown",
    shortYouTubeDemonstration:
      "https://youtu.be/LXkCrxn3caQ?si=24dygODdgdRhEqJK",
    inDepthYouTubeExplanation:
      "https://youtu.be/zEHmnpgi-dg?si=gojDTRhS6wpAdM5x",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Straight Bar Reverse Grip Tricep Pushdown",
    shortYouTubeDemonstration:
      "https://youtu.be/GqK6WrZEyEk?si=JPCXXCLg2YG3rQa7",
    inDepthYouTubeExplanation:
      "https://youtu.be/h0AMOYndGRM?si=nfOvCEAtMNcYKbiq",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Zottman Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/2IBxr91kSI8?si=NutPVlDJSpcDczLP",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachioradialis",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Seated Zottman Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/GIGFFYAKG6M?si=5QEN9x3BJwkxTal7",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachioradialis",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Tall Kneeling Overhead Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/9kib4kUJJ1A?si=KTQ4D8iMokjT6LqW",
    inDepthYouTubeExplanation:
      "https://youtu.be/17n2BnYVepk?si=b5hRitIQziFVau-P",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/156_Z9969FQ?si=bmP-isrzfk-iAjdj",
    inDepthYouTubeExplanation:
      "https://youtu.be/PWQ9xEVNwkQ?si=SHzV3BeE62Ue0pG6",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Seated Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/9DB2kibw0os?si=-BYlQ8gHAlszJaDo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Seated Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/40w4sx4FAVU?si=i0K5ruXclQupBuxc",
    inDepthYouTubeExplanation:
      "https://youtu.be/BsULGO70tcU?si=1kniO7BjerK_8SmQ",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Incline Bench Zottman Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/o9w3-CMPRxQ?si=nSVQxRbx2GvgZi-u",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachioradialis",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Incline Bench Zottman Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/Xakexn9Y5Oo?si=YY664vMjXBLBT2Ha",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachioradialis",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Seated Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Z4fmeY-GQ8o?si=jZD1QoPzdXBx4Hd8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Floor Press",
    shortYouTubeDemonstration:
      "https://youtu.be/GC0TS5XuuAA?si=1gRhkWItRmgaTYmb",
    inDepthYouTubeExplanation:
      "https://youtu.be/1_-ECzAoCoY?si=gB243CJHNOnav7gA",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Floor Press",
    shortYouTubeDemonstration:
      "https://youtu.be/P_ijh09h23s?si=U9pK9AQYG1xx2yxE",
    inDepthYouTubeExplanation:
      "https://youtu.be/B340QckIfJM?si=YLrQG5Gul0_HHm8D",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Floor Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Uf1jY-575lo?si=pKedIxKhmO0-sY6O",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Ipsilateral Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/S1-SPv3YXG8?si=QCE1ikc3-Mg60u3x",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Seated Overhead Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/o_3RHmSwIgE?si=jrBjCATOeTuvtWzq",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/jdx2kl5K0Ps?si=ABHltAh0E_8BUz7i",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Battle Rope Double Wave",
    shortYouTubeDemonstration:
      "https://youtu.be/mTZENozi5x4?si=Us7_yx5MJoQLZHhO",
    inDepthYouTubeExplanation:
      "https://youtu.be/u5k-9NLlBZc?si=xzDDOCtbUMS1zqnK",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Front Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/67-J94MVJUg?si=TUVKne9uaJdYMy3x",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Incline Bench Prone Lateral Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/e8K9KPGcwr8?si=HpsrB1akXMIU8ANX",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Seated Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/xZKMteV7T6I?si=r_V-HvZTiORRBmxM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Incline Bench Prone Hammer Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/P-QvV7zOHjw?si=suRdks_sCJLNPIKX",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Foot Elevated Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Foot Elevated Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dummbell Front Rack Foot Elevated Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Foot Elevated Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Incline Bench Prone Hammer Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/N_eGFKGR7ZQ?si=J-4OOQpNwgwM0LrL",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/1RdiI_ta3CY?si=ELtb0jc2iPVUiqNN",
    inDepthYouTubeExplanation:
      "https://youtu.be/QPi2iPxIOMU?si=njIA2IAXw562aiYL",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Decline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/SisxAKThq70?si=tJqclsa9iiqndA6R",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Copenhagen Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/l2Hu2D3z84w?si=H3JslwI5uQK49RTu",
    inDepthYouTubeExplanation:
      "https://youtu.be/ggPSnMVIQ08?si=7hv_e4CLgcwRPbWh",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Side)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Floor Press",
    shortYouTubeDemonstration:
      "https://youtu.be/3u2DR9HL0tY?si=3Bcig3xQ4BI89qLa",
    inDepthYouTubeExplanation:
      "https://youtu.be/Zt1s1YhZ8Ag?si=VdqFI6Yr9LCxrUfE",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Glute Bridge Isometric Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Floor Press",
    shortYouTubeDemonstration:
      "https://youtu.be/hyb1jJ98ORU?si=UKrLCDD8rhcoKu0p",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Seated Single Leg Tibialis Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/kIRvGGD21Zw?si=nBLhNjFMITgsl7fd",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shins",
    primeMoverMuscle: "Tibialis Anterior",
    secondaryMuscle: "Extensor Digitorum Longus",
    tertiaryMuscle: "Extensor Hallucis Longus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Dorsiflexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Seated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/uki30vzaltY?si=sWNIzvhqvIBU2krb",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Seated Feet Elevated Calf Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/trgsU9LSHcM?si=LkOOKLtsyEAMWIWJ",
    inDepthYouTubeExplanation:
      "https://youtu.be/jQOQsYSYPiY?si=ZEW3fQfh2Xy1BX0H",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Soleus",
    secondaryMuscle: "Gastrocnemius",
    tertiaryMuscle: "Tibialis Posterior",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Thruster",
    shortYouTubeDemonstration:
      "https://youtu.be/NDA72gV21vM?si=nr1ibCzWJfLIYTXz",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Floor Press",
    shortYouTubeDemonstration:
      "https://youtu.be/0S0pPgQXWNk?si=sd5taBTsE1Qux9Er",
    inDepthYouTubeExplanation:
      "https://youtu.be/yDoBD0EAd90?si=4PQFvzpTeE2_ofzS",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Inside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/MSt1cYAiLzI?si=tzz_-RCN5C_q8Zk5",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Macebell Outside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/ZuaKcM41dP4?si=jhfiB9Rsa8B6eQv2",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Macebell Inside Circle to Outside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/XWIFyifqSr8?si=VCcBN4FzzFmcTjSf",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Macebell Inside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Macebell Outside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Macebell Inside Circle to Outside Circle",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Battle Rope Clap",
    shortYouTubeDemonstration:
      "https://youtu.be/KTcHetEk8Vw?si=xFuh3rDHIThNVEbK",
    inDepthYouTubeExplanation:
      "https://youtu.be/s57pXx2t2FM?si=pgWPT_kwUw2FlLcU",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Lateral Deltoids",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Battle Rope Inward Circle",
    shortYouTubeDemonstration:
      "https://youtu.be/WH4rwFZoce8?si=Yt1fEhmIXXEAa1s1",
    inDepthYouTubeExplanation: "https://youtu.be/lVhChaGkx4I?feature=shared",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Battle Rope Outward Circle",
    shortYouTubeDemonstration:
      "https://youtu.be/ta0cdvQmADs?si=B6OcdshuVkMO34iV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Tall Kneeling Shrug",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/UKjQMYiQnS0?si=Lg6kuQMDGFaxi6X7",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Battle Rope Alternating Cossack Squat Alternating Wave",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Low Switch Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/sj_bFtL9Oy4?si=osmoYlG_O5Fs6lPE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Alternating Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/mPyE_hQolbs?si=0ulL0aaE23nJ0OiJ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zombie Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/Siwj8KDU5zI?si=qiHYnyo8qzTOwk1L",
    inDepthYouTubeExplanation:
      "https://youtu.be/UNxVJsKCYFc?si=_9cwP9k4OoN-j8Ot",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zombie Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/KRkgAJe8Uo4?si=0wdpF0mE1yM7kNjz",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Bear Hug Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/G5gCl5b0E-4?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Bear Hug Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Zombie Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Suspension Foot Elevated Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Suspension Ipsilateral Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/8xX1a7o6bKU?si=rLYvcvZkeDzk1KV5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Battle Rope Low Switch Cossack Squat Alternating Wave",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Plate Overhead Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Alternating Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Alternating Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/wqXP71ooU44?si=oje6--5yoC_aZeha",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Alternating Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/XOCZvsIB-ys?si=icJ1C2ots-yLy5_7",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Dead Bug",
    shortYouTubeDemonstration:
      "https://youtu.be/DPNDaQoxjsQ?si=KOvphYYrIaszuK1F",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Rectus Femoris",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Postural",
  },
  {
    name: "Sandbag Front Rack Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/41RTZolbtPk?si=HjTttPYPllgpQXeT",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Back Rack Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/uuVkmAJd-y0?si=JvCPYFXj-MAzRMAF",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Russian Twist",
    shortYouTubeDemonstration:
      "https://youtu.be/JYftrLVWUD8?si=WwaPZ7K8HUnsrnqN",
    inDepthYouTubeExplanation:
      "https://youtu.be/8ohhG1Y4tzU?si=QVPlYYzdIkgNwonk",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Plate Feet Elevated Russian Twist",
    shortYouTubeDemonstration:
      "https://youtu.be/4p5jWyz-YRQ?si=A80S2QY5Wu5Lql2-",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Feet Elevated Russian Twist",
    shortYouTubeDemonstration:
      "https://youtu.be/WT9UCB_1Y8Q?si=dmkzRkM-dzlFe1ux",
    inDepthYouTubeExplanation:
      "https://youtu.be/874-Or2w75o?si=koYCn0aGS7qYWc8s",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Russian Twist",
    shortYouTubeDemonstration:
      "https://youtu.be/m-dlg3v8SkY?si=KI1hgOAtTqI0ty6r",
    inDepthYouTubeExplanation:
      "https://youtu.be/hg7xqoWmYhw?si=cUMpM7AIyf--MpHB",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Landmine Russian Twist",
    shortYouTubeDemonstration: "https://youtu.be/OyKu-DvXxAc?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Alternating Hawaiian Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/_nfx1aDx87o?si=T4Vw1FKJpAnHEuV6",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Hawaiian Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/6mefiFE8CVM?si=KyPC_eM0qqnT8F_x",
    inDepthYouTubeExplanation:
      "https://youtu.be/Tm9u4Lahm7s?si=XSf1ikmSQUlIL9OF",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Suspension Hawaiian Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Hand Assisted Hawaiian Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/qnw_7_U_fJU?si=0CZNhyLC07DBXGKk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Co5EWd-aiVk?si=NBvXIzNsQ1egWtQz",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/ifEMtPwfvV0?si=_xR4TF-oMs8-LVSH",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/R3_u3kg7Ioo?si=ekSihU-Mge0xIWxv",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Seated Overhead Press",
    shortYouTubeDemonstration: "https://youtu.be/LcVh7l7WyJo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Knee Supported Row",
    shortYouTubeDemonstration:
      "https://youtu.be/JdXRG8B3N8E?si=uO1aFa0IBUO3nVqz",
    inDepthYouTubeExplanation:
      "https://youtu.be/l_cgMGUbFfc?si=-xSrea1LJbWpdbzh",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Knee Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Offset Thruster",
    shortYouTubeDemonstration:
      "https://youtu.be/yeaFdnu5pls?si=N1yYEQFwZfUlKLMg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Anti-Lateral Flexion",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dummbell Overhead Foot Elevated Contralateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dummbell Overhead Foot Elevated Ipsilateral Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Seated Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/vSjthx8vHNs?si=HUKI9YcVXeNdFeVx",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Cyclist Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/1ij5SfH4PMo?si=HuKVOjAkOpK16kCi",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Seated Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/AlwLsoYSZo8?si=vd7o72xnaBnjH3gj",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/R2LOc0ZTcLI?si=0ry8ntEThAk2l6WI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Bear Hug Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Cyclist Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Landmine Goblet Cyclist Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/MeBEmS3QRjE?si=lZ0o-kYlVdKtkDqe",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Tall Kneeling Shrug",
    shortYouTubeDemonstration:
      "https://youtu.be/-E9IilV53AI?si=3376PVeqdmgVn2AJ",
    inDepthYouTubeExplanation:
      "https://youtu.be/uN5rwCivJXc?si=jZRWafwZEh2p1iIN",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/jme7uJ99oI4?si=zSBDr4Bv5l6vINmf",
    inDepthYouTubeExplanation:
      "https://youtu.be/g5EZwana3R0?si=hdAX7pyAoiCI7kwS",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Pistol Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/QPzYCYVpsFA?si=Kc9-HoWbiLTj997Y",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Dumbbell Goblet Alternating Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Alternating Double Kettlebell Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/nE9UnkFqPMg?si=uhDy9WDlpMa_ogud",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Alternating Pistol Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/uqIMqZmyyH8?si=J2AzvjdNfcenC6Jm",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Zombie Pistol Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/G-neztXXSCA?si=txR7W1HSVUCckbMc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Front Rack Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Back Rack Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Zercher Pistol Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Dumbbell Crush Grip Front Rack Squat",
    shortYouTubeDemonstration: "https://youtu.be/00Dc5QnwzGI?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Decline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/bKh4C0xyCRw?si=hRBvxJouDXj8MfIL",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Decline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Sandbag Front Rack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/-TTZd1lASkw?si=T4OTaFzbqRaGAc3m",
    inDepthYouTubeExplanation:
      "https://youtu.be/gNapNZqyYEQ?si=7yIu-b9Efjvb3Mvl",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Back Rack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/TTZlek-Jeec?si=nJsuOnJws7uylodj",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Back Rack Alternating Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/V-CvLcQhsPk?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Back Rack Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Back Rack Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Back Rack Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/6Y7jLhsURck?si=ZI60iuhlYRh4x0Ul",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Decline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Suspension Ipsilateral Skater Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Sandbag Back Rack Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/LUESjt8b2vY?si=vYksLJ6mIw7_F_DZ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Pull Apart",
    shortYouTubeDemonstration:
      "https://youtu.be/Z9Bryd2XtwY?si=13MbA6khrvgobwKt",
    inDepthYouTubeExplanation:
      "https://youtu.be/kn5simXHspc?si=12YyyWs66i5tclcg",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Lateral",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Sandbag Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/QWniDREaQVY?si=nOmYsg0t5nXPcb0Q",
    inDepthYouTubeExplanation:
      "https://youtu.be/hnt1DO1q4fs?si=Nbw2OkPvZt3CvBtf",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Bent Over Reverse Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/hf7jnF45N_I?si=1OHNa_B7yazQ9w4L",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Knee Supported Tricep Kickback",
    shortYouTubeDemonstration:
      "https://youtu.be/om2bTuwKGes?si=nJJaeiJglypyQD_G",
    inDepthYouTubeExplanation:
      "https://youtu.be/ZO81bExngMI?si=tAjqe65qTyEFxoMh",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Knee Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Incline Bench Prone Tricep Kickback",
    shortYouTubeDemonstration:
      "https://youtu.be/kR9mqN6rxpQ?si=1GxxxZw4G3kFbAi0",
    inDepthYouTubeExplanation: "https://youtu.be/PJSQwBUwifw?feature=shared",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Cable Tricep Kickback",
    shortYouTubeDemonstration:
      "https://youtu.be/DYsQWSbj7UM?si=XUOYSUKOaqGmOCQP",
    inDepthYouTubeExplanation:
      "https://youtu.be/ZvF4Oi_6Vtg?si=Pu0EfDBC9h0ygyq-",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Tricep Kickback",
    shortYouTubeDemonstration:
      "https://youtu.be/MQOnCts9N9c?si=0NLgrLb84fi_4vxZ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Dumbbell Goblet Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/bN9sXaI7tdg?si=W3RoLGE6wUeZ8kQg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Front Rack Contralateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Front Rack Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Overhead Contralateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Overhead Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Low Hold Contralateral Lateral Lunge",
    shortYouTubeDemonstration: "https://youtu.be/QJ_WNRYaM-s?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Low Hold Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Seated Shrug",
    shortYouTubeDemonstration:
      "https://youtu.be/9IGbUVfZan8?si=FGf_5wCGLmr8DVD_",
    inDepthYouTubeExplanation:
      "https://youtu.be/WLKlzUFqwgM?si=eGbw33LUwxuQonoJ",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Seated Shrug",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Clubbell Order Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Clubbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Clubbell Order Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Clubbell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Clubbell Order Contralateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Clubbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Clubbell Order Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Clubbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Macebell Order Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Macebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Macebell Order Contralateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Macebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Macebell Order Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Macebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Miniband Feet Elevated Glute Bridge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "Miniband",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Frog Reverse Hyperextension",
    shortYouTubeDemonstration:
      "https://youtu.be/iiQueNJKmVQ?si=Ty5Dh9uswMacl2Jd",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/NqNgdW_cvIg?si=KoSk_5f75bTzur4R",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Bulgarian Split Squat Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/SFj46t9F1OQ?si=_kzqwXcEvJtP-gv1",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Slider Suspension Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Suspension Trainer",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Bulgarian Bag Back Rack Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bulgarian Bag",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Sandbag Front Rack Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Sandbag",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Sandbag Back Rack Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/GkANtw3THOg?si=LWzQCihOFKfrRvJz",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Sandbag",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Ankle Monster Walk",
    shortYouTubeDemonstration:
      "https://youtu.be/PlktrKgFcT0?si=O4YEDtcE-rMg5fLn",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Landmine Goblet Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Landmine",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Landmine Low Hold Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Landmine",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Front Rack Contralateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Front Rack Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/q56KJzFPbz4?si=QBb7bgZdSeYK7Q0i",
    inDepthYouTubeExplanation:
      "https://youtu.be/OCKL8G3UCKE?si=2LEwtBHn0aShvwJZ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Bottoms Up Front Rack Contralateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Bottoms Up Front Rack Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Overhead Contralateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Overhead Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Bottoms Up Overhead Contralateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Bottoms Up Overhead Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Low Hold Contralateral Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/W22ESpzYHdY?si=Vh4542ktziwY39x1",
    inDepthYouTubeExplanation:
      "https://youtu.be/3OIpp5SYWYA?si=8fkHeY1Tefkk63MJ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Plate Overhead Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Weight Plate",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Plate Overhead Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Weight Plate",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Reverse Grip Incline Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/obc23NwC-3c?si=NHdYgvLBQoFpvdLm",
    inDepthYouTubeExplanation:
      "https://youtu.be/22aAph9oDBA?si=mWhFkQBDo4M-ZW6T",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Dumbbell Shrug",
    shortYouTubeDemonstration:
      "https://youtu.be/neQw53mbivA?si=4di6VUfOBarrAAWQ",
    inDepthYouTubeExplanation: "#ERROR!",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Tall Kneeling Shrug",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Seated Shrug",
    shortYouTubeDemonstration:
      "https://youtu.be/L15snvTU1qY?si=MYRw1-yq79vC87vm",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Shrug",
    shortYouTubeDemonstration:
      "https://youtu.be/iJmHIt3pq5U?si=O6Skib3fQIO2I526",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius ",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Hang Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/cSmvSLAiJUM?si=h-chBAq-PsufLIrW",
    inDepthYouTubeExplanation:
      "https://youtu.be/dRAt2NB1bi0?si=gZM-j0lCV-3Bm6LP",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Dumbbell Hang Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/VpZwBT07DR4?si=07HCrANRza3gU5O3",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Dumbbell Hang Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/BNyymHJvcJc?si=Fwbl__UOgmJahIO5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Miniband Kneeling Side Plank Clamshell",
    shortYouTubeDemonstration: "https://youtu.be/DD2ntrZLoEQ?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/Ij-m5ABQ_jk?si=QmNlVwARKCjeMiJQ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip External Rotation",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Thigh Side Plank Hip Abduction",
    shortYouTubeDemonstration:
      "https://youtu.be/TBYwwlojtvE?si=QWpnXUtKvTpFNuv_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Stability Ball Feet Elevated Russian Twist",
    shortYouTubeDemonstration:
      "https://youtu.be/gyTX0ttszBs?si=mR6_J7SkVOuRHrQN",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Alternating Single Leg V Up",
    shortYouTubeDemonstration:
      "https://youtu.be/0EIDVDbzVNo?si=B73itVIXJWWYaH0C",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Battle Rope Alternating Lateral Lunge Alternating Wave",
    shortYouTubeDemonstration:
      "https://youtu.be/XVLaBw4NWe8?si=tFm4FlWxePeCRyh7",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Battle Ropes",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Tall Kneeling Shrug",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Seated Shrug",
    shortYouTubeDemonstration:
      "https://youtu.be/LaywjdRLK3c?si=nTMNGy0BPyxW6WR3",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Hip Thrust",
    shortYouTubeDemonstration:
      "https://youtu.be/k_HORfTCsi0?si=-RDu4SzCjbkXl4P5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Incline Bench Prone Shrug",
    shortYouTubeDemonstration:
      "https://youtu.be/Cm4HfYm9w3A?si=iRKP7u31KGlnfQZt",
    inDepthYouTubeExplanation:
      "https://youtu.be/F4HvRmG-47E?si=n9CjooC15SOMrKxM",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Single Leg Foot Elevated Glute Bridge",
    shortYouTubeDemonstration:
      "https://youtu.be/TiPDApTAJu0?si=dVw4o9DCHCZrIteK",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Tire Single Leg Foot Elevated Glute Bridge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Incline Bench Prone Shrug",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Sissy Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/YedqbteiWoU?si=rMl_RLv88kcBcMUR",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Incline Bench Prone Shrug",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Incline Bench Prone Shrug",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Trapezius",
    primeMoverMuscle: "Upper Trapezius",
    secondaryMuscle: "Levator Scapulae",
    tertiaryMuscle: "Rhomboids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Scapular Elevation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Seesaw Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/fv3jtm7zP1I?si=Vx6jxC1bB20dsahE",
    inDepthYouTubeExplanation:
      "https://youtu.be/JcE41bUbw2U?si=RreeAeHrJZFG19Bh",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Dead Squat Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/xeUVzgEapmQ?si=ieR0dXu6Bem56sNy",
    inDepthYouTubeExplanation:
      "https://youtu.be/_rvrT_1FJDw?si=hbKW2DKEimzjn-If",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Seesaw Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/82ZJhsIOF8w?si=uigPvHNUp-5ce1jQ",
    inDepthYouTubeExplanation:
      "https://youtu.be/Ctt1fvwm6kk?si=_eO9I6wQ-MAX6yer",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Seesaw Decline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Hand Assisted Pistol Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/tiA23NSUm7A?si=_N2Va66rdUdrcMpD",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Suitcase Alternating Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/XE7MrZADkr4?si=F2dW-lk_yYLoGHjE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Alternating Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/1VkEZirajQQ?si=4EJltD-xdvd_ifWT",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Alternating Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/SQHyEoZLd1o?si=_TJYUJVzm_zR7ZxZ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Alternating Curtsy Lunge",
    shortYouTubeDemonstration: "https://youtu.be/lJyMP5H-_pw?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Alternating Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/rzwJACyQNas?si=VKxH9lJuYtpzFxQo",
    inDepthYouTubeExplanation: "https://youtu.be/1GdKCwHpTD8?feature=shared",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Alternating Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/0xnBB7_WBpQ?si=DNO9eiIOlnVvq62-",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Alternating Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/dj2zCtnlZEM?si=zXmmDlSwlhudznYC",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Alternating Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/SNtgnXpolPY?si=RQdshbRrgML5pKNu",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Heavy Sandbag Bear Hug Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Plate Overhead Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/aETd5ebI3NU?si=vTA4pe6vXlRyhpd4",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Back Rack Alternating Curtsy Lunge",
    shortYouTubeDemonstration: "https://youtu.be/L6KZyggcDjE?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Hollow Body Hold",
    shortYouTubeDemonstration: "https://youtu.be/Qiu_qPGaGYM?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Seesaw Floor Press",
    shortYouTubeDemonstration:
      "https://youtu.be/xxUSV06CkFM?si=I4ywyVcTwGhyUwsk",
    inDepthYouTubeExplanation:
      "https://youtu.be/oGfNL09b7aI?si=R5JthaF_xBc5wnR8",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Seesaw Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/CpQIh8MxCCQ?si=UvCgYzi5mZCUTXaX",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Seesaw Incline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Tuck L Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/4_7EUMcoYYY?si=s_ew72Z5lyKk18Er",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tuck L Sit",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Seesaw Decline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Hollow Body Flutter Kicks",
    shortYouTubeDemonstration:
      "https://youtu.be/-UVAa92y1r4?si=CIm_rryJMtDs0TPj",
    inDepthYouTubeExplanation:
      "https://youtu.be/SnoeNEynaXo?si=N-b7r6M6EqsxD6_z",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Seesaw Floor Press",
    shortYouTubeDemonstration:
      "https://youtu.be/h_L7Ntxcgtk?si=g04F5mBJSHow1QbI",
    inDepthYouTubeExplanation:
      "https://youtu.be/1RQvVrCp4Ps?si=MAOVfxzYeZoRlsXh",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Seesaw Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/N4Y5hWOwDBY?si=TDvtFSl9MGsAg0L6",
    inDepthYouTubeExplanation:
      "https://youtu.be/BNVZDnNWZ8A?si=yN1PSSk8hN-7USPx",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Arnold Press",
    shortYouTubeDemonstration:
      "https://youtu.be/sbGP9VjnjEg?si=QtatKrbr2B5FgS6F",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Arnold Press",
    shortYouTubeDemonstration:
      "https://youtu.be/9ZxNf7ZyXNA?si=RYR75ThTJf8rKwxi",
    inDepthYouTubeExplanation:
      "https://youtu.be/H1MhGoqnF0Q?si=EN3_3uy1NaCMbdKf",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Seated Arnold Press",
    shortYouTubeDemonstration:
      "https://youtu.be/EtPb646Va9s?si=J7PWxe7OwlEdfLZW",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Seated Arnold Press",
    shortYouTubeDemonstration:
      "https://youtu.be/2dw6SwEJlH4?si=UCaE7pKKJDaRm0lz",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Feet Elevated Frog Pump",
    shortYouTubeDemonstration:
      "https://youtu.be/K2AvS_4hjd4?si=WeXgOnAQd6Db4L-d",
    inDepthYouTubeExplanation:
      "https://youtu.be/NK4axZ_5xCc?si=-6TyqUc4PiCzSXK5",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Miniband Feet Elevated Frog Pump",
    shortYouTubeDemonstration:
      "https://youtu.be/B1brbzxGCqM?si=OdHzF3vTHn2YmADJ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Feet Elevated Glute Bridge",
    shortYouTubeDemonstration:
      "https://youtu.be/hKUOvDXVREw?si=RIjR5zIo0hOuYfY0",
    inDepthYouTubeExplanation:
      "https://youtu.be/f_bOTuS8P2g?si=EH_ss7eAKpSH5qYG",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Reverse Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/_oFQ3G5iwtc?si=3F2p69DpOKAmGXoE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Wall Ball Toss",
    shortYouTubeDemonstration:
      "https://youtu.be/fpUD0mcFp_0?si=Ymlmi7cDC_sfB1zE",
    inDepthYouTubeExplanation:
      "https://youtu.be/ryJoFCMNIr8?si=MXodcxnqxCF_bcKW",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Wall Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Wall Ball Feet Elevated Russian Twist Lateral Toss",
    shortYouTubeDemonstration:
      "https://youtu.be/Bio87vFoJW8?si=NJ1qbIlIwQxlLPYE",
    inDepthYouTubeExplanation: "https://youtu.be/_f4r2vB1Lyo?feature=shared",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Wall Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Wall Ball Russian Twist Lateral Toss",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/A7Gs9U3l_bM?si=gYbFmn76YoyxmFzn",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Wall Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Wall Ball Lateral Toss",
    shortYouTubeDemonstration:
      "https://youtu.be/R87xzEuBmlY?si=tsszJ0gQHwdhFaFH",
    inDepthYouTubeExplanation:
      "https://youtu.be/c7fB-K8Ih54?si=eE-kYZAFC5Ave-qK",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Wall Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Wall Ball Sit Up Toss",
    shortYouTubeDemonstration:
      "https://youtu.be/mSSReQ1b9NQ?si=XbGTmB14_eldcuBz",
    inDepthYouTubeExplanation:
      "https://youtu.be/D0Yoa0_cfkk?si=DXBEuUEqlVCl3R3D",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Wall Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Suitcase Bulgarian Split Squat Jump",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Double Dumbbell Tall Kneeling Arnold Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Rd3pRGf7fyQ?si=E19yq3x4ySAePC_i",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/15EmaPxPbe4?si=K_IYnXhJNu1WAP8c",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/EeNk8sLr9z8?si=kN5JtBlDa5WiKxzK",
    inDepthYouTubeExplanation:
      "https://youtu.be/ygPXImMvA0o?si=Wft_lt3TWoza9u8Z",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Ipsilateral Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/o_M9wYTtIBA?si=BXIV9tiqPcpzzreB",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Goblet Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/Xv7xtX-iHXw?si=Tr0jv2-w6qpFctJh",
    inDepthYouTubeExplanation:
      "https://youtu.be/ablOuQIMktw?si=ziNtqS0vfEsi2I_t",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Contralateral Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Ipsilateral Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Tire Bulgarian Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Tire Bulgarian Split Squat Jump",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Double Dumbbell Front Rack Knee Over Toe Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/WQUXh0Zk1XU?si=nWvh_443nHiOu2bH",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/7obV55SSiaw?si=S805NWBkc0FbMt7c",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/h_S_Bb9rWCE?si=Dr_V3tDtxcRysPGX",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Knee Over Toe Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/JlcQSTjIpk8?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/H5KGoSK1TMw?si=wfO6lfzcy7AhIt-M",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Foot Elevated Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/FpwomyrCcCk?si=JJyauhDa3bMzRSkq",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Foot Elevated Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Foot Elevated Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Foot Elevated Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Foot Elevated Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Foot Elevated Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/yw2PSqN1ELo?si=2h_po3eQI5bN1T8l",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/Z-9VnaY1F7k?si=NW_jj2yOwfUGesC3",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Barbell Overhead Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Foot Elevated Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Foot Elevated Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Foot Elevated Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Foot Elevated Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Foot Elevated Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Foot Elevated Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Foot Elevated Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Foot Elevated Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Foot Elevated Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Foot Elevated Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Foot Elevated Contralateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Foot Elevated Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Foot Elevated Ipsilateral Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Suitcase Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/IgatQ8Mh6nM?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/m0tnThP_AXQ?si=iR-GoGMInvuKSunC",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Alternating Split Squat Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/Vl3Gb37CyMI?si=claxpb93HZUyctUA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Single Arm Dumbbell Suitcase Contralateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/eT5ol-m5gQU?si=1yRDnXPgi913NC1Q",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Ipsilateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/PL3rLZbBgZQ?si=NevvL1vzasNBOgVT",
    inDepthYouTubeExplanation:
      "https://youtu.be/cIp4a9Sj_54?si=24y6vu_iqwfImM44",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/Bf4HVTwMjkc?si=j0OgjVc5PW-T2bs6",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Contralateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/nogkCbiduHI?si=5gA5NaZqt_y4a8ir",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Ipsilateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/Fc6I5y692zE?si=WC2rmdrASF2eyb71",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/c9SSkKRR_fc?si=MOjZ2orbxCB5hdiO",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Contralateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/jmgelOGoxE8?si=dRdbKJvwm7kJy_Fs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Ipsilateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/XpcDH-_hkD8?si=ZolNMoUBWOAc0Xms",
    inDepthYouTubeExplanation:
      "https://youtu.be/zofsIbMpfQ4?si=FtowdyCJ9K6aSW2k",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/EUHaKY3aA1Q?si=H2a-9iB71twMingb",
    inDepthYouTubeExplanation:
      "https://youtu.be/O_XaZR7-5lo?si=V-7vvAXlgmxto7UI",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Wall Ball Feet Elevated Russian Twist",
    shortYouTubeDemonstration:
      "https://youtu.be/w0CTy_eIIcM?si=RtrXOHk6gyF6NsFi",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Wall Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Wall Ball Russian Twist",
    shortYouTubeDemonstration:
      "https://youtu.be/0DwFec0Aeog?si=bohJ8yWsahjfyyVf",
    inDepthYouTubeExplanation: "https://youtu.be/-_iuNMMSCGs?feature=shared",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Wall Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bulgarian Bag Back Rack Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/VI6qhpokyPI?si=vlQYMvQBOEZ4sjof",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Contralateral Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Ipsilateral Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Contralateral Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Ipsilateral Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Split Squat",
    shortYouTubeDemonstration: "https://youtu.be/p3aoeo0dbZg?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/xM1KKtO7XFE?si=IGg02TkKhvMfNUNE",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Bear Hug Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/EDEgJ8gSJHo?si=tuk25VgOk61zTjT4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Contralateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/ayWcRkvxO-I?si=AtCYmB8SJA-QD071",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Ipsilateral Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Sandbag Back Rack Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/h1IDfUy9JCg?si=8aLbq-QZwId9tfAE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/b0rzm8OUjAc?si=Rz4zXBOgcisU6tEb",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Dumbbell Tall Kneeling Arnold Press",
    shortYouTubeDemonstration:
      "https://youtu.be/oMbi7Tppy-Y?si=xztRuodoUOeyiGKn",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Landmine Goblet Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/IfR7ezW6Oxc?si=-Zb29PMa_gZ8yJr9",
    inDepthYouTubeExplanation: "https://youtu.be/pUlZP43RYI0?feature=shared",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Landmine Front Rack Contralateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/kZKDLL-1IXw?si=wnx7XbsDFO37wHb3",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Landmine Front Rack Ipsilateral Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Landmine Suitcase Contralateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/rD7QCqe4g0k?si=13maugTiL5P1XI6m",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Gunslinger",
    shortYouTubeDemonstration:
      "https://youtu.be/spmQS--R39Q?si=CXJgE_ppmc8oU7i4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Front Rack Ipsilateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/Xy9DrXmYIdw?si=e3qLZQjQ9a0RnC4q",
    inDepthYouTubeExplanation:
      "https://youtu.be/VV0ZpKYykgA?si=kIRKUh5Ozq6OIq4n",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/NH32TQinW94?si=UfgmRs54Foklrrlw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Contralateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/kTJfy28oNFE?si=SfdE8XDz_tYT0vyI",
    inDepthYouTubeExplanation:
      "https://youtu.be/AZXE2GxnLLg?si=klSkY0q0wz02HD1_",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Ipsilateral Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/Q_NVo7MW61E?si=3xxOUWjsx7Th2Acq",
    inDepthYouTubeExplanation:
      "https://youtu.be/JeRkV9ebv_8?si=i5WB_-WOS9obtf3g",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Contralateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/3HxbM0lO3a8?si=7zxP4xa8ZMIRdBAW",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Ipsilateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/7TXfixD6LwA?si=ZgzyV23h1nt4RVQQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Contralateral Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Ipsilateral Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Suitcase Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/lQH6gx3-q8E?si=ySQAsX-z8SQ9haRk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Contralateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/JLyFg72CCrk?si=dyii9fe_jm4Th1O8",
    inDepthYouTubeExplanation:
      "https://youtu.be/WWh6IyHUouU?si=Mw843r1ICzI9GlHa",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Ipsilateral Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/ZqPQvlALHlw?si=B7EklAroPtpJvXvc",
    inDepthYouTubeExplanation:
      "https://youtu.be/vc55ELVmtns?si=QbvA9EZhpX-bVelg",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/X13mW_a88Hw?si=bAwJPsrYMO6xCJWC",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip March",
    shortYouTubeDemonstration: "https://youtu.be/sd6bu56nO9A?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/aAFF0WrHnfU?si=UT-K4YyZrGZnIOFT",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Dumbbell Front Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/B6e5b8SY64g?si=OFbYwa08fPFsxurs",
    inDepthYouTubeExplanation:
      "https://youtu.be/xOksWZVV1_g?si=vYz-4oXhlU7lLENu",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Cross Body Hammer Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/_aiZoy57VFI?si=skTwggqvw_kxkno5",
    inDepthYouTubeExplanation:
      "https://youtu.be/n4J53LpjvUk?si=P8g1wW_RnUgwerf4",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Hamstring Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/xh13VO9_qEA?si=lzogbMJOWGILmMX3",
    inDepthYouTubeExplanation:
      "https://youtu.be/Mjsws0TEZSE?si=eqHvE-lLaHR3MHPU",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Single Leg Hamstring Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/xHvXPam-ZBQ?si=8jfCw-5i-zrJ9hUd",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Superband Prone Hamstring Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/LtTcXXgeRYo?si=80zdQRqZ21dGBf6n",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Prone Hamstring Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/qOu-89KQsIg?si=NzRrmfpYz9Rwpoy8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Superband Prone Bench Hamstring Curl",
    shortYouTubeDemonstration: "https://youtu.be/e5TRSsFNeug?feature=shared",
    inDepthYouTubeExplanation: "https://youtu.be/zQnw_Zb_iIM?feature=shared",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/DE6BcaMCwJA?si=Q1Lbpg92nykSCfEE",
    inDepthYouTubeExplanation:
      "https://youtu.be/74qC_TVP8yo?si=WNrv0C4iHCPcez8-",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Hammer Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/yCDJmfP1Tr8?si=UDCf5aMfQvMiW-69",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Dips",
    shortYouTubeDemonstration: "https://youtu.be/EznLCDBAPIU",
    inDepthYouTubeExplanation: "https://youtu.be/Kr5Uuuy5DAI",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Single Arm Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/CQ6VEzQAI7w?si=_nTW1Yq_iP18uBgt",
    inDepthYouTubeExplanation: "https://youtu.be/azjQG10quYw",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Anti-Rotational ",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Aztec Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/MeunnPVySSI?si=wuDGH7XuHo-e8M5X",
    inDepthYouTubeExplanation: "https://youtu.be/4z5kffSzjWI",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Slider Barbell Front Rack Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Barbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Kettlebell Front Rack Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Suspension Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Suspension Trainer",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Landmine Goblet Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Landmine",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Barbell Overhead Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Barbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Barbell Back Rack Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Barbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Barbell Zercher Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Barbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Bulgarian Bag Back Rack Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bulgarian Bag",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Kettlebell Suitcase Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Kettlebell Overhead Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Kettlebell Bottoms Up Front Rack Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Kettlebell Bottoms Up Overhead Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Front Rack Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Suitcase Contralateral Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/Bu50PXycHv8?si=SlReQTpVRUbKnVsC",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Overhead Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Bottoms Up Overhead Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Bottoms Up Front Rack Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Dumbbell Front Rack Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Dumbbell Suitcase Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Dumbbell Overhead Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Front Rack Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Suitcase Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Overhead Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Dumbbell Goblet Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/lyYXfpCV5ys?si=iACRC6Vlz_wbm5zc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Kettlebell Horn Grip Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Kettlebell Goblet Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Clubbell Order Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Clubbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Double Clubbell Order Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Clubbell",
    CountSecondaryItems: 2,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Clubbell Order Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Clubbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Macebell Order Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Macebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Macebell Order Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Macebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/3psxN3YA0wg?si=BW-ePbc5Pg6OJ8z6",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Slider Plate Overhead Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Weight Plate",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Sandbag Front Rack Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Sandbag",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Sandbag Back Rack Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Sandbag",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Front Rack Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Suitcase Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Overhead Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Bottoms Up Overhead Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Kettlebell Bottoms Up Front Rack Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Front Rack Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Suitcase Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Dumbbell Overhead Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Dumbbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Clubbell Order Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Clubbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Single Arm Macebell Order Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Macebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Cyclist Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/JMGY7iOxEd8?si=VQLmn1jf71I47o_a",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Knee Over Toe Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/9b4Aatm0Wvo?si=35ADJVaHZbeshP13",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/JGpJCYbDefo?si=NOFTsBroAKhZtrMl",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/gA6gJS2ePGU?si=Ug9x4DfIITtyX9FE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Maltese",
    shortYouTubeDemonstration:
      "https://youtu.be/CvVSQjBGdxY?si=NNbbzDLa-chZFz3I",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Grand Master",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Front Rack Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/oZCa8oh_YVI?si=rPzLwq3xpBKREAf7",
    inDepthYouTubeExplanation:
      "https://youtu.be/Kt3knQShh-A?si=sWwsEazcmrI0by7m",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/b10GH56Feuc?si=DTF4gfUaKajgDIEP",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/tiuw2sbuhl0?si=TK4HTHPYjPWelq8-",
    inDepthYouTubeExplanation:
      "https://youtu.be/yjwURBqqCYg?si=NUF6xvgot5JoPLus",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Back Rack Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/msvF1e9w2aQ?si=ZGUO8zKtN0DMjqex",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Suitcase Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/DEE806Xr4V4?si=Bi_n7QfcYh1KpvBP",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/u_cHR3_1IZw?si=oVJaTI9hNpMcfVFW",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Contralateral Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/XVsdDBiLk2I?si=yYz392PvLdjJCOy5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Contralateral Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/IlABYRygo3w?si=LYId2yiYvpqxybEC",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/ORgVFXTysI8?si=F2L2x6t0lsu7RXmy",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/tKQAKx25kyk?si=CVIu5jUCBGlS-CU4",
    inDepthYouTubeExplanation:
      "https://youtu.be/LYtjfGYxPGc?si=6u5LXuWotilcKGX6",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Contralateral Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/6-K9hgU8YUI?si=eubdVXn2jNhff_kr",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: "https://youtu.be/XSvx131FZ_s?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/sMUQOGVrmQM?si=shRczfTH98OihNfr",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Curtsy Lunge",
    shortYouTubeDemonstration: "https://youtu.be/sb9anlSqH6w?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/863JuZlLiA4?si=Zj6W2E1ana1MwTBv",
    inDepthYouTubeExplanation:
      "https://youtu.be/o9dDJfqomhY?si=nZV9tpIyNBei3gUE",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/cXHnXTR79Kw?si=HidnQgZQ02ZN6GNc",
    inDepthYouTubeExplanation:
      "https://youtu.be/rUD0rPjlxdQ?si=AMHO_Tvi4Muc361n",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Plate Overhead Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/fdt3gkMNv0Y?si=Wmdlb79kZmS0oZof",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/2DiU1YRLDQE?si=klXwkCZb6RsZjZl5",
    inDepthYouTubeExplanation:
      "https://youtu.be/Y9lSGKJYFwY?si=aFD5teAXtSt83DvO",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Back Rack Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/dwL1uWmadTI?si=6anEQDI0eEoOuB0Q",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/yswpCMZ98OI?si=xOcXSLCrJIH3odmK",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/8lACiuIcv_0?feature=shared",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Archer Pull Up",
    shortYouTubeDemonstration:
      "https://youtu.be/aFrdGmSHqFI?si=RfqnoOy6-Ppa73et",
    inDepthYouTubeExplanation:
      "https://youtu.be/qwBErsklUno?si=-zVJHul85jMEE9oB",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Single Leg Bent Knee Bicep Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Freestanding Handstand ",
    shortYouTubeDemonstration: "https://youtu.be/E2s-D009x6E",
    inDepthYouTubeExplanation: "https://youtu.be/JyyKGE-Ajs8",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Wall Eccentric Straddle Press Handstand",
    shortYouTubeDemonstration: "https://youtu.be/VVan0yoinV8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Kettlebell Horn Grip Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/LcF_derN9KA?si=U_Cqiq6zxtQlpRhf",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Kettlebell Goblet Carry",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/PN8ATPtOYEE?si=zcjMbUMXIWHgX7E_",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Dumbbell Goblet Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/qa-CYBhvSDA?si=qbgdCK6xq_Ftfez0",
    inDepthYouTubeExplanation:
      "https://youtu.be/9Xv_5oevuqw?si=cY6Vt15TX5V6EcvU",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Ring Feet Elevated Row",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Dead Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/7KN_RrCS_EU?si=seR_4LNmjEtTdXfj",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Dead Half Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/Afjg2rDHJ9Y?si=h7MYMycB-dIjcHL5",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Dead Half Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Start Stop Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/GwxzBGhm6ac?si=vrTFU3w6T1NGn8DM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Start Stop Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/BpwgvVjQXiw?si=SPwizx5lirRdfFmX",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Start Stop Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Start Stop Swing",
    shortYouTubeDemonstration:
      "https://youtu.be/djCYBs70KLE?si=JiYJei8Eqv-UiCG7",
    inDepthYouTubeExplanation:
      "https://youtu.be/fvwlIUW04hg?si=A2DjFOuq2Sw-6TW_",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Start Stop Swing",
    shortYouTubeDemonstration:
      "https://youtu.be/3Xhy3dz61to?si=8lmx3c2FvDHq6Zy5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Start Stop Swing",
    shortYouTubeDemonstration:
      "https://youtu.be/sS-bxWAoPWk?si=zgyeJNYUfOuTOFyj",
    inDepthYouTubeExplanation:
      "https://youtu.be/0EgT__MDZR8?si=rWcHJ2d9m_LxpJuW",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Ring L Sit Pull Up",
    shortYouTubeDemonstration: "https://youtu.be/Aa9U0XNNBfU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Suspension Skater Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/Y8Wn_vTZFFg?si=AtpqJfd4OVnOo7ZO",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Double Kettlebell Start Stop Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/SaBcgeWdynY?si=VUGBebh0ht8z7ISy",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Start Stop Clean",
    shortYouTubeDemonstration: "https://youtu.be/SLm1ou6-SLM?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/r1b8btVfk6w?si=mdFerl1Ftrhe1hjd",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Start Stop Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/_OtZfks5rfU?si=iwf-Hc6P6vZ3ke6I",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Staggered Stance Rotational Swing",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Staggered Stance Rotational Clean",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Staggered Stance Rotational Clean to Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Bulgarian Pull Up",
    shortYouTubeDemonstration: "https://youtu.be/Xk0GovwG8Go",
    inDepthYouTubeExplanation: "https://youtu.be/ek9in7TOqjs",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Bulgarian L Sit Pull Up",
    shortYouTubeDemonstration: "https://youtu.be/3U86aaJuyRs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Landmine Split Snatch",
    shortYouTubeDemonstration:
      "https://youtu.be/RzeAb6wnMsk?si=aedjaQmoWjF7IB75",
    inDepthYouTubeExplanation:
      "https://youtu.be/6My_MnlhTGU?si=Dxln5c_mwBhxUokl",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Hang Power Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/_1Tp01g9ciU?si=NTgkT4x59EZyPH9T",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Barbell Bicep Curl",
    shortYouTubeDemonstration: "https://youtu.be/NQ53MadCtW0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring False Grip Pull Up",
    shortYouTubeDemonstration: "https://youtu.be/7zn_K1omwQs",
    inDepthYouTubeExplanation: "https://youtu.be/dKSQFLBe4o0?feature=shared",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "False Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Slider Kettlebell Goblet Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Ring Feet Elevated Pike Push Up",
    shortYouTubeDemonstration: "https://youtu.be/T7F6-FEmvrs",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Landmine Split Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/tDKju5qmxOM?si=j82cBg7j8A8GUsiV",
    inDepthYouTubeExplanation:
      "https://youtu.be/X3Pe8IHTavA?si=xbfG5Os4grSyPxVe",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Squat Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/SYxObzJ3gn0?si=MxNFujZbMP9ff4gw",
    inDepthYouTubeExplanation:
      "https://youtu.be/5qzIQJUIwKk?si=CY_fvTbF-CbG9QgM",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Dumbbell Hang Squat Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/lYo3ofjjUKI?si=6bwkgshNWDvWIlQc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Landmine Split Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/J4MJUcilrmo?si=4cbvgzB0vHx2Gb3e",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Ipsilateral Forward Lunge Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Hammer Swing",
    shortYouTubeDemonstration:
      "https://youtu.be/8gLU9bNm4TE?si=4FnpId_WJCijmDqW",
    inDepthYouTubeExplanation:
      "https://youtu.be/Zk_uT6dHfFM?si=9gx2NoRe2hquzwXj",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Clubbell Hammer Swing",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Hammer Swing",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Ring Tuck Back Lever with Alternating Single Leg Extensions",
    shortYouTubeDemonstration: "https://youtu.be/DB63aMHSfX8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Tuck Front Lever with Alternating Single Leg Extensions",
    shortYouTubeDemonstration: "https://youtu.be/iK78Q6NwH-Q",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Split Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/a5CR3Bi2Gc8?si=fy5lJhtOGwem51y_",
    inDepthYouTubeExplanation:
      "https://youtu.be/MmCQ0tmk3KY?si=e-a6xgGpxdaSKD-Y",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Double Dumbbell Hang Split Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/ILaWpcO0NdQ?si=wZ59jqUF1LZLoldu",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Ring Archer Push Up",
    shortYouTubeDemonstration: "https://youtu.be/Go96FtKDQIA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Wall Ball Half Kneeling Lateral Toss",
    shortYouTubeDemonstration: "https://youtu.be/OE8VmAtG3iw?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Wall Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Wall Ball Isometric Split Squat Lateral Toss",
    shortYouTubeDemonstration:
      "https://youtu.be/vEI0fyG4150?si=H1RJwNd1aUDk0Xh7",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Wall Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Assisted Bar Muscle Up",
    shortYouTubeDemonstration: "https://youtu.be/tkhmiyJiZ2E",
    inDepthYouTubeExplanation: "https://youtu.be/sbJHFZ-WHtE",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "Pull Up Bar",
    CountSecondaryItems: 1,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "False Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Push Up to L Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/VmLIr9_YfAs?si=auhUGS9WeZfuzEj-",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Barbell Bent Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/6i_nBZ282mI",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Sots Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Sots Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Bottoms Up Sots Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Seesaw Sots Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Half Kneeling Half Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/1_UrK5SopL4?si=GzXlC6ZMcCPP4sYK",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Ring Alternating Reach Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Outside Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/ck0Uf4NygPw?si=zoQyaxx1x__QjKbd",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Outside Half Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Outside Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Ring L Sit Dips",
    shortYouTubeDemonstration: "https://youtu.be/zMJpC7y-6SE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Bottoms Up Single Leg Standing Bent Knee Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Single Leg Standing Bent Knee Contralateral Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/8sJtCQgvc4Y?si=DkWjEgV5brDYcPXM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Ring Chin Up",
    shortYouTubeDemonstration: "https://youtu.be/cBuy7xDJZN0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Suspension Single Leg Standing Bent Knee Contralateral Low Row",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Suspension Single Leg Standing Bent Knee Ipsilateral Low Row",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Suspension Single Leg Standing Bent Knee Contralateral Bicep Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Suspension Single Leg Standing Bent Knee Ipsilateral Bicep Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Ring L Sit Chin Up",
    shortYouTubeDemonstration: "https://youtu.be/SnBGaBxK3T0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Ring L Sit Chin Up",
    shortYouTubeDemonstration: "https://youtu.be/Ha9sM7H6Prk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Single Leg Standing Bent Knee Ipsilateral Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Ring Pelican Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/GCU9MgR78go?si=9_MfbrIFqCoJ9wnJ",
    inDepthYouTubeExplanation:
      "https://youtu.be/lpC92lkXoUs?si=haZuxsNmnlch5_FY",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Two Finger Chin Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Pseudo Planche Push Up",
    shortYouTubeDemonstration: "https://youtu.be/lpZUsYQVwuE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Pseudo Planche Push Up",
    shortYouTubeDemonstration: "https://youtu.be/YDO8UmA9lr8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Parallette Single Leg Close Grip Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Parallette Bars",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Macebell Single Leg Standing Bent Knee Contralateral 360",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Macebell Inside Circle to 360",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/Rw_GVfopiMw?si=66BUG4kURKCCTyJH",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Landmine Single Leg Standing Bent Knee Ipsilateral Shoulder Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Landmine Single Leg Standing Bent Knee Contralateral Shoulder Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Alternating Single Arm Landmine Single Leg Standing Bent Knee Shoulder Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Macebell Alternating 360 to Pivot Split Squat Uppercut",
    shortYouTubeDemonstration:
      "https://youtu.be/zbJBaxCypSQ?si=93h4TqDxZreFns6w",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Clubbell Single Leg Standing Bent Knee Side Shoulder Cast to Side Flag Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Macebell Alternating 360 to Front Flag Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Anterior Deltoids ",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Indian Club Crescent Swing",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Indian Club",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Unsorted*",
    mechanics: null,
    laterality: "Unilateral",
    primaryExerciseClassification: "Mobility",
  },
  {
    name: "Single Arm Macebell Inside Circle to 360",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Bulgarian Bag Spin",
    shortYouTubeDemonstration:
      "https://youtu.be/PbysPTU69fc?si=8cDk2dXzGqWm8BiX",
    inDepthYouTubeExplanation:
      "https://youtu.be/QwaxyJG9MFM?si=2XrD59ek9Y4-o8-L",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bulgarian Bag Alternating Spin",
    shortYouTubeDemonstration:
      "https://youtu.be/m3pCByzR5Is?si=d4rUJA6uUKzAub51",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Feet Elevated Renegade Row",
    shortYouTubeDemonstration:
      "https://youtu.be/_eVC54UW6eE?si=6tC__RV3slyYwUuP",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Anti-Extension",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Feet Elevated Renegade Row to Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/9hZ1mWk3-gA?si=Tko55A45WxNaGz27",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Horizontal Push",
    MovementPatternCount3: "Anti-Extension",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Snatch to Overhead Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Barbell Zercher Alternating Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/eLcNzP40LXQ?si=NCe5LCfcGAS-20f4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/BGrdZtL5kqA?si=OVCBqhib32tJ12QT",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Walking Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/E9f1yZXR3Vk?si=dWF4gSXuKpukJ-1Q",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Barbell Zercher Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Barbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Barbell Zercher Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Barbell",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Pelican Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bar Archer Pull Up",
    shortYouTubeDemonstration:
      "https://youtu.be/ziQjz1-DmX8?si=8Y9dWdjG-9LfdUJv",
    inDepthYouTubeExplanation:
      "https://youtu.be/NuqcoOAsTMA?si=-CwDfUaya0Gs49EF",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar False Grip Pull Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/lrlpNcpWQHw?si=JBClpbbvT6bAMVhg",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "False Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar L Sit Chin Up",
    shortYouTubeDemonstration:
      "https://youtu.be/7Wd45lzZhQk?si=WbC5VTiJ33pRjzDJ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar L Sit Pull Up",
    shortYouTubeDemonstration:
      "https://youtu.be/QH0dDfyF7QM?si=W4RMoCz0b-U3zq7d",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Tuck Back Lever with Alternating Single Leg Extensions",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Tuck Front Lever with Alternating Single Leg Extensions",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Squat Clean to Push Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Squat Clean to Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Power Clean to Front Rack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/IJbop150-bY?si=9X5umbrrhrvCZkT0",
    inDepthYouTubeExplanation:
      "https://youtu.be/BkHMhgk-SBc?si=mTyvw2BeiYH2_0Eq",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Hang Power Clean to Front Rack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Hang Power Clean to Split Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/47WVg_XVE8I?si=4PkmY9S8bnXLI6A5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Hang Power Clean to Push Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/8IYt7AtP8BI?si=Mc82QusXSQLbFS6b",
    inDepthYouTubeExplanation:
      "https://youtu.be/0VuOmsp4uDU?si=v2BVJ0NBwPNvW6ur",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Hang Power Clean to Push Press",
    shortYouTubeDemonstration: "https://youtu.be/50VRLZancXI?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/--VNAdrjWCc?si=vJ7hZ-pv38QLsKQj",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Hang Power Clean to Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Hang Squat Clean to Split Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/ljPUr6K-it4?si=ivG82c-7_tzg3KRy",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Hang Squat Clean to Push Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/KBpys4KTG5Q?si=HQyyuqWBfXWcY7wV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Hang Squat Clean to Push Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Hang Squat Clean to Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Double Kettlebell Clean to Front Rack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/t7vqdHxMVGY?si=BMd0xRrTYjoV5zrL",
    inDepthYouTubeExplanation:
      "https://youtu.be/R3s6Wb_ApHM?si=vaDvU6g4YQWIfJph",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Clean to Push Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Xs5q4IDjTRA?si=v-B326quPWXgDphc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Clean to Front Rack Alternating Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/tG3t_B6t-88?si=JcYBrgVmlHOaRvf5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Glute Bridge Isometric Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/AvrSSwSSPFI?si=2q2v3SuLMeByGkJK",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Archer Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/Pca41QxE7l4?si=HXkK4AvIOETo2UkI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Archer Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/bIdsEOkgWTM?si=5aKZj2ofWld4V-Fb",
    inDepthYouTubeExplanation:
      "https://youtu.be/9Htat4rdJd4?si=NfKXRBP6Jj3XTIfU",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Chaos Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/Df4Jsk1ayk8?si=IICqh6B9ycW-xmJf",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Pivot Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/laMvUTGs0-k?si=zazYAAhek_WWCwAN",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Clean to Thruster",
    shortYouTubeDemonstration:
      "https://youtu.be/2AwE60IueM0?si=6m0bhquaUgiVawPE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Clean to Push Press",
    shortYouTubeDemonstration:
      "https://youtu.be/s16IX5IJDt0?si=mkoHNGyJw3Pa8PoM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Clean to Push Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/Shvnso0RADI?si=bnQTaetZPmjwCpd3",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Clean to Front Rack Contralateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Clean to Front Rack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Landmine Pivot Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/zBGaxRD-_UQ?si=vN7hcMF7S4eYQB1u",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Pivot Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Snatch to Overhead Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Outside Snatch to Overhead Contralateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Outside Snatch to Overhead Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Outside Swing",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Kettlebell Half Kneeling Swing",
    shortYouTubeDemonstration: "https://youtu.be/DJJ03oEDJGU?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Heavy Sandbag Shoulder March",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Heavy Sandbag Bear Hug March",
    shortYouTubeDemonstration:
      "https://youtu.be/3Nb6pMK8__Y?si=5ew2YOh7JxivCONp",
    inDepthYouTubeExplanation:
      "https://youtu.be/bk_B0CKGor4?si=DlMl7cHyVm-frwWe",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Heavy Sandbag Bear Hug Roll",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/NPLmgnPLI7Q?si=ETSyP2WtgLfQHxEo",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Alternating Hang Shoulder Clean",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Hang Shoulder Clean",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Kettlebell Dead Clean to Horn Grip Alternating Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Kettlebell Dead Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/JyElZdIB29g?si=v2iiDrMxGAq4A9rl",
    inDepthYouTubeExplanation:
      "https://youtu.be/5l9WeYcQGbg?si=nQk2TI5tJRo6v6qS",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Kettlebell Dead Clean to Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/NVWQauhMnRQ?si=UgmuOye7VOzX-UjA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Clubbell Barbarian Alternating Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Barbarian Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Macebell Barbarian Alternating Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Macebell Barbarian Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Overhead Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Contralateral Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/KGBRsXKjWOc?si=RnQ_ABDo5MNzq0-i",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Ipsilateral Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Contralateral Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Ipsilateral Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Alternating Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Step Up",
    shortYouTubeDemonstration: "https://youtu.be/LAjAtHI8zwQ?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/f2yk4cQVBpU?si=gSBurV0Zk38FHz_8",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Alternating Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Alternating Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Back Rack Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Back Rack Alternating Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Alternating Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Alternating Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/FVmLcTGmJZ0?si=EDG5LdzfEeiqin-z",
    inDepthYouTubeExplanation:
      "https://youtu.be/bbWycJMXNzQ?si=8VLoUx6yqH6yOVMJ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Alternating Step Up",
    shortYouTubeDemonstration: "https://youtu.be/efg-AS2o3lM?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Alternating Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Alternating Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Alternating Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Suspension Alternating Hawaiian Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Suitcase Alternating Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/LQOGjjbAF6w?si=YO-bbJpBtYiLPA1T",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/ci0s9-U1S50?si=yYac1epKRR8CESOn",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Alternating Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/uT2473eo8Rw?si=1pxHtkIQiIW_apsw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/PLk0TE6nYag?si=vbbSLrl8kCSWEbLQ",
    inDepthYouTubeExplanation:
      "https://youtu.be/3yPRuUPeiQU?si=7XSRn2zzSxJl4SV2",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Alternating Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/gcP-jawjJ0s?si=kFE3ztEzT7nJwF3I",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Tire Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Tire Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Tire",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Dumbbell Crush Grip Seated Good Morning",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Erector Spinae",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Bottoms Up Z Press",
    shortYouTubeDemonstration: "https://youtu.be/vKxoihlGR4A?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated Floor",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/ciJ8vZIyapM?si=F5Cq1A6IBA0ElWWo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Alternating Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/moDnqcjmUnw?si=2L_tGgiIN_WKjnSh",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Superband Assisted Reverse Nordic",
    shortYouTubeDemonstration: "https://youtu.be/GHI2nT9CchQ?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/-yf6BI9d4Us?si=IWx35pgv9LwAYvdt",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Clubbell Mill to Reverse Mill",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Macebell Mill to Reverse Mill",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Macebell Mill",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Dumbbell Hang Power Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/jIV6huBUy40?si=LI0qU1gmKWUnull4X",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Dumbbell Hang Power Clean",
    shortYouTubeDemonstration: "https://youtu.be/-hApznQV1wg?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Dumbbell Suitcase Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/OpEgnt3M98k?si=98bk34oOvELlwHao",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Dumbbell Front Rack Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Front Rack Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/KuNBOsyKvNs?si=xGQdh89b83Z6zfD1",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Suitcase Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/N3HnkJ4Sp2s?si=L6L1BDMG1XO5MO94",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Suitcase Contralateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Suitcase Ipsilateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Front Rack Contralateral Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/nijhpzgUUi0?si=OYbqhyHxgBZEG3ZY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Front Rack Ipsilateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Overhead Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Overhead Contralateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Overhead Ipsilateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Contralateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Ipsilateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Contralateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Ipsilateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Back Rack Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/SEh-o4ousa0?si=f_LvuDf-cSL8gy43",
    inDepthYouTubeExplanation:
      "https://youtu.be/WW-OvpN8iNo?si=lrpZWW1xXNmm5j4K",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Front Rack Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/KHHTwaBgTqg?si=0-6AOui90rWJD7EE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Dumbbell Overhead Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Dumbbell Overhead Contralateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Overhead Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Overhead Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/-UtFmeC_gz8?si=Cbn-i607GWj4GbJt",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Dumbbell Suitcase Contralateral Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/cB20h7IpdJQ?si=KBJR-jjHokOwHkYv",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Dumbbell Suitcase Ipsilateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Dumbbell Overhead Ipsilateral Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/h7uCFbFFEpg?si=rYfRpyQwdrzMUPgo",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Clubbell Order Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Clubbell Order Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Clubbell Order Contralateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Clubbell Order Ipsilateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bodyweight Alternating Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/uWQaD_zDNP8?si=e7uAr4KO-Uxs3C4h",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bodyweight Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/T0aGAd4z8_g?si=LLndgNIkangYyqvf",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Clubbell Order Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Clubbell Order Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Back Rack Alternating Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/Yk67o_LX2k8?si=zkvsiKBoliLmWwDT",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Front Rack Alternating Russian Step Up",
    shortYouTubeDemonstration: "https://youtu.be/FkOqXpYX2nE?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Dumbbell Suitcase Alternating Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/7xKPC6fiAnI?si=AjBy--nHV9jih9q4",
    inDepthYouTubeExplanation:
      "https://youtu.be/wFu4kyEHdpw?si=31XgiEpUAXgWVijK",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Dumbbell Front Rack Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Dumbbell Overhead Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Dumbbell Front Rack Contralateral Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/ZrFBGqWoSzw?si=pCq_xiI6MtbnQOMx",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Dumbbell Front Rack Ipsilateral Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/-4eThA6jaBY?si=rvYxSeDEierXbTvB",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Macebell Order Contralateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Macebell Order Ipsilateral Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Macebell Order Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Macebell Order Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Zercher Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/BSiPJ84ik7o?si=oeCPF5tgAOTrYNIS",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Zercher Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bulgarian Bag Back Rack Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bulgarian Bag Back Rack Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Sandbag Back Rack Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Sandbag Back Rack Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Sandbag Front Rack Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Sandbag Front Rack Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Plate Overhead Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/IBvPAsvfZvM?si=Dx3NbZqKQz2o3anT",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Plate Overhead Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Front Rack Alternating Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/-L2RxqXxw3w?si=c5bWCZNShpG6g4Zw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Overhead Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Double Kettlebell Suitcase Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Kettlebell Goblet Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/RZsegx5MjMg?si=jrgTO3B_RBqc2Tow",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Kettlebell Goblet Alternating Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/D_XZAV9sh2I?si=9d58XpgxLS_aoYoQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Dumbbell Goblet Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/Z8wrpP7TT5E?si=tMWVlz_jrcW6ilLl",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Dumbbell Goblet Alternating Russian Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/e-VjvaI7FEI?si=Uc1Aq16WW3xsbpcO",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Kettlebell Horn Grip Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Kettlebell Horn Grip Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Miniband Hip Thrust",
    shortYouTubeDemonstration:
      "https://youtu.be/GMoIkfo2nP4?si=IB4Q_47E137Hsx_H",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Bear Hug Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/LyD7nH85x0c?si=Li3dCfeeWkoCcSX-",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Bear Hug Alternating Step Up",
    shortYouTubeDemonstration:
      "https://youtu.be/O1zrmDKSt9E?si=aLhoWHS87gUaM6iV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Bear Hug Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Heavy Sandbag Bear Hug Alternating Russian Step Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Alternating Single Arm Macebell Reverse Mill",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Ring Grip Straddle Planche",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Grand Master",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Kettlebell Dead Clean to Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/N4wLE5NrCEs?si=yJrKqkN4Q6I88-sV",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Dead Clean to Push Press",
    shortYouTubeDemonstration:
      "https://youtu.be/aWPqX1VXr-g?si=6F2i3SQxg7mvF5tb",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Clean to Front Rack Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Clean to Front Rack Ipsilateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Dead Clean to Push Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Dead Clean to Push Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/vFOeFxuWMa4?si=UW2lvkjDkxHqSPIf",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Dead Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/QP8ZqZUuvmk?si=UOZV5omhXZ1F-93V",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Single Arm Kettlebell Bottoms Up Dead Clean",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Dead Clean to Front Rack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/oc0TnNUykEM?si=N_yVekSXidSRo2A4",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Dead Clean to Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Dead Clean to Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Dead Clean to Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/587yc5WQcB0?si=il91YAGQf5s9QyXC",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Dead Clean to Push Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Wq5CGNeQGUA?si=bULiT29sEH9tAv6z",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Dead Clean to Push Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Dead Clean to Front Rack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Macebell Bull Whip to Mill",
    shortYouTubeDemonstration:
      "https://youtu.be/NUhpNbRmNMg?si=vqY017BanR5_s992",
    inDepthYouTubeExplanation:
      "https://youtu.be/9AFgVsSXOCA?si=J-Zh0GlYFLOJWoaP",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Bear Hug Kang Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/XVlH1hEsqMY?si=60gTVsHXWLFVtref",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Feet Elevated Renegade Row",
    shortYouTubeDemonstration:
      "https://youtu.be/lLTBO5vqm8A?si=UXhSCQSR6oZS3B2T",
    inDepthYouTubeExplanation:
      "https://youtu.be/5FcaN35DaAQ?si=ZfAD4sAbgN70vQ_W",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Anti-Extension",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Feet Elevated Renegade Row to Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: "Horizontal Push",
    MovementPatternCount3: "Anti-Extension",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/9gglI77Kzq8?si=_dDcU05y48tssEAF",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Forward Lunge",
    shortYouTubeDemonstration: "https://youtu.be/tEnO9W001b0?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/HdsDj84oo-M?si=h7psbJWyTfoeXjLf",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/Y9EGHil8cj0?si=2FSctgexRfTrAxb-",
    inDepthYouTubeExplanation:
      "https://youtu.be/JH1x57CWPik?si=bxb00MkoSXUP23Qr",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Bear Hug Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Contralateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Back Rack Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/hUdSY_wXwWU?si=UfpUfMXiZqyUzBJ8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Suitcase Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/dgdMXVeApVM?si=C53j2jhBQ-HcBkp2",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/s-lZimLr_tg?si=Esmu-85tbaGWBDHx",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/gqAaDuZQjXY?si=XpGry05ejKZXpsz-",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/c-4dfhO8QTw?si=7jy_yBEvLZdLrTWC",
    inDepthYouTubeExplanation:
      "https://youtu.be/pBtSeAbiah0?si=UhmPxiSfn0QDaquV",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Contralateral Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/nEFul0yIBzU?si=Dt-DKAqMcRsQMRWd",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Contralateral Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/UbQwG3BPs54?si=OAD_X1vRpwmgJgHl",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Contralateral Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/b5LGhv3B2us?si=6V7uUbW59eAmJ9Lx",
    inDepthYouTubeExplanation:
      "https://youtu.be/TFH26fM07iw?si=zzR9FD2ulzDiot6R",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/ZS0_Pnqs18o?si=iqfhdouw2kgEVNp1",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/Q2ELBxwUp28?si=SahPctazGJoXnzHQ",
    inDepthYouTubeExplanation:
      "https://youtu.be/IzeZOET6R7U?si=oTFk5E4bDeCV8DoC",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/mVJyt-hJqQ4?si=ZyQU-rcyvqeQG8GO",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Contralateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Contralateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/1XKXGRQX-0w?si=hoLOL3F63ye-LGkD",
    inDepthYouTubeExplanation:
      "https://youtu.be/4JEsjeTA9M8?si=WxT6yU_vYpJsX-hU",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/GRFb4uKia9o?si=12NJKTAJm5VqsZCt",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/DoXtPhcQZ0A?si=-jOVMkwU4yMda8b5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/GLx4dqyToMQ?si=SE9oL2hGuFmb1rI_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Contralateral Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/93jOACk6hCI?si=Wh87FQShHz6PdDPL",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Contralateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/PHEZCp68iI8?feature=shared",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Contralateral Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/tCdyjT6r7IQ?si=rxUYwp8Jt_iRYs1A",
    inDepthYouTubeExplanation: "https://youtu.be/4wVgb2LPW-I?feature=shared",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Contralateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/Nsz_DAZS6cw?feature=shared",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/5zdsUZyVyZU?si=zOn7HfTe53mopVx9",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/B2jHsaojI4A?si=t3FbVaw_mjK5VgeG",
    inDepthYouTubeExplanation:
      "https://youtu.be/ianXxqc7-dA?si=A-HY3o-soYJxq8A9",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/bVOx0bS6BvI?si=E52DJq8hShYSUVbw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Ipsilateral Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/6qREgTKXbOM?si=gyM_F4WYjs2hqIS7",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Ipsilateral Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/hSqr6cDitEg?si=0Q3eJ7Civ09nXoAr",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Ipsilateral Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/qfpKsxIGOu0?si=fKCRBwv_aknD3aFj",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Ipsilateral Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/lBKvPGFLaKg?si=ysrtgn3hQImmLVaF",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Ipsilateral Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/TPCs1UFpADo?si=m8DKfTmxHGcavJDM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Ipsilateral Forward Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/vnwL74DnWK8?si=qsKdUhrsdu46i1An",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Ipsilateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Ipsilateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Ipsilateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Single Arm Dumbbell Plank Pull Through",
    shortYouTubeDemonstration:
      "https://youtu.be/Zko5x2SoQmo?si=PCTDak-unxScaIpM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Anti-Rotational ",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Single Arm Dumbbell Feet Elevated Plank Pull Through",
    shortYouTubeDemonstration:
      "https://youtu.be/Q7FtGv0v7vg?si=DvtZ3VraSeIPHfHk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Anti-Rotational ",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: "Frontal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Landmine Cyclist Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Landmine Cyclist Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "Slant Board",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Heels Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Swing",
    shortYouTubeDemonstration:
      "https://youtu.be/9JHFkrjW4_Y?si=m1HLdDm33Jymv5KP",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Macebell Half Battle Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/UNgnGEswyR4?si=oWVFZerU0mt-Io9N",
    inDepthYouTubeExplanation:
      "https://youtu.be/sntznDD9mKQ?si=agR7P_HTvfa3w_0h",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Clubbell Order Pivot Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Pivot Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Plate Assisted Hip Airplane",
    shortYouTubeDemonstration:
      "https://youtu.be/0JAmWCoB7ec?si=aUSwxvV3VwO7Fqfi",
    inDepthYouTubeExplanation:
      "https://youtu.be/HnR7Nz02Mms?si=okd1w8RUIAa6uBdA",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Weight Plate",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Hip External Rotation",
    MovementPatternCount3: "Hip Internal Rotation",
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Macebell Battle Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/ZJ95ZoB0ZXY?si=pipbT6H4SgqjMWv0",
    inDepthYouTubeExplanation:
      "https://youtu.be/a_24IRg2EcM?si=kjDi5i8SYvLLB0JG",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: "Sagittal Plane",
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Tactical Half Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Heavy Sandbag Shoulder Ipsilateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Tall Kneeling Cuban Rotation",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/iJDTNEOenI4?si=ki1UV_dGUSCuBj03",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Cuban Rotation",
    shortYouTubeDemonstration:
      "https://youtu.be/J9thOow3-iY?si=mZOrggfNx4BC4LdB",
    inDepthYouTubeExplanation:
      "https://youtu.be/Eum8TeApleI?si=2BFcHiplyVqD2iAT",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Single Arm Landmine Tall Kneeling Shoulder Press",
    shortYouTubeDemonstration:
      "https://youtu.be/9ExnOQh3WDU?si=7rIFSmGhbv4rgcJ2",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Feet Elevated Glute Bridge",
    shortYouTubeDemonstration:
      "https://youtu.be/mVzkA_m7I8k?si=nz9dAss-NvLHBUln",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Erector Spinae",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Tactical Snatch to Overhead Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Bodyweight Push Up to Alternating Lateral Kick Through",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/8pHMj4-Azg0?si=TXPShPnR-ER2dIw-",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Horizontal Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Animal Flow",
  },
  {
    name: "Double Dumbbell Single Leg Romanian Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/vexyZD8S1B8?si=qmrB8iZUTuht69xJ",
    inDepthYouTubeExplanation:
      "https://youtu.be/HsQDqJ66FKA?si=RJhp0WTei2W3CfdW",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Contralateral Single Leg Romanian Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/cqSuTycslLg?si=dnsKBV2QyBbtxyRD",
    inDepthYouTubeExplanation:
      "https://youtu.be/lI8-igvsnVQ?si=VlhBXjHbffsekHiF",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Single Leg Romanian Deadlift",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Clubbell Pullover",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Posterior Deltoids",
    tertiaryMuscle: "Triceps Brachii",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Unsorted*",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Tall Kneeling Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/yoKxUD9pUj8?si=8BcXj2frpNXsJmfa",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Tall Kneeling Overhead Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/1SeR4V-EYK8?si=jeUtHpyY3S0-eqZF",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Inside Circle to Shield Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Clubbell Inside Circle to Shield Cast",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Snatch to Overhead Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Cable Prone Bench Single Leg Hamstring Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/l66EvN4X6Mk?si=i4fPkqXo_4_8fmO6",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Tall Kneeling Cuban Rotation",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Macebell Single Leg Standing Bent Knee 360",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Macebell Single Leg Standing Bent Knee Ipsilateral 360",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Alternating Single Arm Macebell 360 to Ballistic Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Behind Back",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Dumbbell Suitcase Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/a3wg2b8pd_w?si=UH9NFJeHHPoQpalx",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/Vlgh0ImT5oU?si=WOAwroyeZ6jJWGto",
    inDepthYouTubeExplanation:
      "https://youtu.be/73OwYFfga1g?si=LaOU5bMAPop8e7Ii",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/lssvh3-XTas?si=rmOXOmN8Rlb5bMEe",
    inDepthYouTubeExplanation:
      "https://youtu.be/kFEYbh6Hme4?si=5OoUsLdwETNJoL7f",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Bear Hug Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Contralateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Back Rack Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/21r8Pdk6Vks?si=U-wSwCn696acnBp9",
    inDepthYouTubeExplanation:
      "https://youtu.be/9MBGvIYU2Lg?si=GJYnXWwoUahfSAKJ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Suitcase Reverse Lunge",
    shortYouTubeDemonstration: "https://youtu.be/zZfh3tvp5CI?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/PwtxLgNobQQ?si=DoSwEK_jWEv76qX3",
    inDepthYouTubeExplanation:
      "https://youtu.be/aeFRNwu-vnk?si=kbMbqd6PoPIVFs9o",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/JoV4UqO1tTc?si=3YJ_yF9NN8BUfwS9",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/Zv8CDt76v-o?si=2EUkwtXgQzLAb65b",
    inDepthYouTubeExplanation:
      "https://youtu.be/v8kvmY85TEQ?si=xMnBcXliF5Tir01K",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/k9GGgck623Y?si=lU__htPe1riSTjAv",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Contralateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/ZsmsBmOMtnw?si=FMtq9k1eAmHq4gEX",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Contralateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/d3oKvFQ2KOk?si=DHn68Kf7oX9vBrYU",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Contralateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/U0PGg34Vx8A?si=JVT4ugA6ELAoJP3g",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/R3Kd1U5hPyc?si=BSEMsU-3AstW_2LI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/pDA738FZsuk?si=bzG9vYvbc69IfMmO",
    inDepthYouTubeExplanation:
      "https://youtu.be/g5bphe5eFu8?si=Tsp0KtbwhVYuYo2-",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Contralateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Contralateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/rwlsbVNSqDQ?si=6ELRzgo6Ek1bVGBe",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/U7Nrwyu6Uqo?si=i10Myq56LE1Wlzzn",
    inDepthYouTubeExplanation:
      "https://youtu.be/qeJ3Si5r5y0?si=dVhY6YtUfCR-tcMl",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/RqMG5v-jUyE?si=hxI8O10U-7CcGVRp",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/I9YUnFtd81o?si=yuqTt95kbjtVETJd",
    inDepthYouTubeExplanation:
      "https://youtu.be/N2p6CryLOj4?si=q_yo92IuDgBe7ZMy",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/KC6oWhmOmPY?si=OWiPo66RrQ46WjHj",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Contralateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/kcVqtqe03WI?si=KuFsD1PlWdph7WCt",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Contralateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/Zy3uowra52Q?si=TqlOPzqiZOcb_wkA",
    inDepthYouTubeExplanation: "https://youtu.be/135S8xKiK4w?feature=shared",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Contralateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/bjxICX4wQMQ?si=s83QPA-v5pPzg1fM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Contralateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/FJSjoyq9das?si=zs-BmTlnKVXLf4--",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/s5w0EOsU7e8?si=UCHj4c3UE1LScgnx",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/gWN9epxFqX8?si=h3iRgeFCZgBGHOMT",
    inDepthYouTubeExplanation:
      "https://youtu.be/0ScjG-cDVLw?si=wq7juHd9xVil1SB7",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/StvRmr-ZxmA?si=G51-gqCZ-oQMhQyp",
    inDepthYouTubeExplanation:
      "https://youtu.be/nW9p5X3hdBY?si=G-FylsY4lEoQwCuZ",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/uzn966rWQ4c?si=XF_kMH6vfBIw4hz4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/RxBzGBShf9w?si=yD5EyWT1k3UeODJI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/IiijJRQxMKM?si=rak-3KhujfWzeG6V",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/Ae33oITfYwM?si=BTB-LZkHb2SHl8HM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/r1NS0BNUh3c?si=XwpKqEi6aUMJvPq5",
    inDepthYouTubeExplanation:
      "https://youtu.be/_LHiWY2gezc?si=-aG44dKv-qveA-NF",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/135S8xKiK4w?feature=shared",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/jDMv9KiKXco?si=j2SlwzpOX14P9zth",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/8AxBDKQTyR0?si=qTGmTVE5AbG0urg6",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Shoulder Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Macebell Order Walking Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Alternating Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Alternating Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Alternating Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Alternating Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Contralateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Ipsilateral Curtsy Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Contralateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Ipsilateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Contralateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Cable Incline Bench Preacher Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/Kx03EfVF0pU?si=ga2cI6XNh7JDM4dy",
    inDepthYouTubeExplanation:
      "https://youtu.be/OslO2-OvdYo?si=HTucRMrWb9bcAyE3",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Seesaw Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/Ej-Imk_vGeQ?si=XXtAfuJDxAf0G8hk",
    inDepthYouTubeExplanation:
      "https://youtu.be/56ddkvtZoF0?si=vHGtKLvvGs250CKI",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Seesaw Bent Over Row",
    shortYouTubeDemonstration:
      "https://youtu.be/BD5mTDoy2UE?si=00skC1JcPnkjtd86",
    inDepthYouTubeExplanation:
      "https://youtu.be/gIf1nQ3Q9IY?si=Ye3ub8jzbnVDKxaK",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Posterior Deltoids",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Spider Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/Gi_ccf9-y0k?si=cNFfPXedcyCb_lSv",
    inDepthYouTubeExplanation: "https://youtu.be/DqznVAFQv5k?feature=shared",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Kettlebell Horn Grip Reverse Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/wRgS5ObhBdQ?si=jFFxWIOs9ZRlGwqN",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Kettlebell ",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Superband Good Morning",
    shortYouTubeDemonstration:
      "https://youtu.be/6U-qtYBP-bc?si=-53gPzTz2qX4pX-W",
    inDepthYouTubeExplanation:
      "https://youtu.be/CTRaCzE8pWU?si=OlIokQWK4WAo6gIc",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Erector Spinae ",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Trap Bar Feet Elevated Calf Raise",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Calves",
    primeMoverMuscle: "Gastrocnemius",
    secondaryMuscle: "Soleus",
    tertiaryMuscle: "Tibialis Anterior",
    primaryEquipment: "Trap Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Toes Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Ankle Plantar Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Superband Prone Single Leg Hamstring Curl",
    shortYouTubeDemonstration: "https://youtu.be/0spHTVOeZ-4?feature=shared",
    inDepthYouTubeExplanation: "https://youtu.be/OMVcG72FTcs?feature=shared",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Superband Prone Bench Single Leg Hamstring Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hamstrings",
    primeMoverMuscle: "Biceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Seated Cuban Rotation",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Teres Minor",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Rope Pullover",
    shortYouTubeDemonstration:
      "https://youtu.be/eAklBxVmR6w?si=FCt-1WsfkCKhD2P_",
    inDepthYouTubeExplanation:
      "https://youtu.be/h1qdFssQTsA?si=xFN8zuu8GES0yr-p",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Close Grip Push Up",
    shortYouTubeDemonstration: "#ERROR!",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Kettlebell Kneeling Close Grip Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Kettlebell Feet Elevated Close Grip Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Close Grip Incline Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/OfmxKG10F5Q?si=8a3RFQgve9SfI8Mw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Kettlebell Goblet March",
    shortYouTubeDemonstration:
      "https://youtu.be/murEjbBNhu4?si=wAJyraPSE67uNMnO",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Dumbbell Goblet March",
    shortYouTubeDemonstration:
      "https://youtu.be/WTpKwJlRLK4?si=0pMHaXA8XJ4fldaV",
    inDepthYouTubeExplanation:
      "https://youtu.be/lDsGM_8E_hI?si=h8e63R3KIAif2C9O",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Dumbbell Crush Grip Overhead March",
    shortYouTubeDemonstration:
      "https://youtu.be/LDkPoidjfsA?si=EVv239ngYX2tpMYR",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Cable Pallof Press",
    shortYouTubeDemonstration:
      "https://youtu.be/tvzoG7Ua05Y?si=-i5BoLWWqI_tGovS",
    inDepthYouTubeExplanation:
      "https://youtu.be/ma2OjgP5XDc?si=SF0B1_VMncYwLydw",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Ring Pallof Press",
    shortYouTubeDemonstration:
      "https://youtu.be/zJTqReYQQGo?si=YEkchANMatD1FCxY",
    inDepthYouTubeExplanation:
      "https://youtu.be/YSN3rqhYlKU?si=fRe28k3eokgn33qg",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Kettlebell Low Hold Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Low Hold",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Seated Overhead Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/wJvhlGDf1Hc?si=orGFEeLw20_33-Ur",
    inDepthYouTubeExplanation:
      "https://youtu.be/2wDAgrYXM5k?si=9Dp65YHdj_CtFVt5",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Standing Overhead Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/ebyvvmmA00k?si=wJN4gwe0omjm34CV",
    inDepthYouTubeExplanation:
      "https://youtu.be/9vrHoeYDEJM?si=mf0LZ7NOBQQVk2vu",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Tall Kneeling Overhead Tricep Extension",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Thigh Kneeling Side Plank Hip Abduction",
    shortYouTubeDemonstration: "https://youtu.be/RrL3tkrRefw?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/XNjuM_0Py64?si=sWEdf4N7Ita7XhSO",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Crunch",
    shortYouTubeDemonstration:
      "https://youtu.be/Gala3hWxFTw?si=5Qrh2TKQB1NMQpCG",
    inDepthYouTubeExplanation:
      "https://youtu.be/z6LRile4YiE?si=1_nlGdr2ALt1LXF2",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Reverse Crunch",
    shortYouTubeDemonstration:
      "https://youtu.be/aIyadD7d7OA?si=I96m4yP0SA4lVKvH",
    inDepthYouTubeExplanation:
      "https://youtu.be/YDvaOlhaA1U?si=4UJmTafdK-goIcb5",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Dips",
    shortYouTubeDemonstration:
      "https://youtu.be/vJhFJJu7ock?si=fw1wLN_DqI1nQovZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/yN6Q1UI_xkE?si=0VQVw7_b_8FgH05e",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Other",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Dumbbell Incline Bench Powell Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/dQcKaPnET_U?si=BnxCG8Nw6jQvo43a",
    inDepthYouTubeExplanation:
      "https://youtu.be/XSMxwgNpymA?si=RnZkCGORRbB08vow",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Rhomboids",
    tertiaryMuscle: "Trapezius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Side Lying",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Rope Half Kneeling Rotation",
    shortYouTubeDemonstration:
      "https://youtu.be/su38T53sj_I?si=cqcEdslivlwvc0tG",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Rope Isometric Split Squat Rotation",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Quadriceps Femoris",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Tall Kneeling Cuban Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Upper Trapezius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Bear Hug Good Morning",
    shortYouTubeDemonstration:
      "https://youtu.be/D4mJTEkNnLY?si=iLZLY-yBoFZVR8GZ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Erector Spinae ",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Clean to Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Kettlebell Horn Grip Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/uVDzXg1lrLY?si=qhBp6Nh9qXBsFBEK",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/OjBghWkudHk?si=LxwZc1KnuyA20kv-",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Foot Elevated Knee Over Toe Split Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Soleus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Knee Over Toe Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Front)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Alternating Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/VFFS9y4czO8?si=iICpgUIx3HuQxAXK",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Foot Elevated Cossack Squat",
    shortYouTubeDemonstration: "https://youtu.be/m7SpIGBcysg?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Lateral)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Low Switch Cossack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/_kY7RjpdeLk?si=RGQDn1PcABDT0id_",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Cossack Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/rSaWYv37zzE?si=A1Q8ZZrV4BpY2YTj",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/1Yw4YA4cwAo?si=fX6SXG6cfeXhhNQ_",
    inDepthYouTubeExplanation:
      "https://youtu.be/aNDUbH_Uv4g?si=AB7Gmq6LZkYpb6wp",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Overhead Contralateral Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/TyxhJBfOh58?si=ExY9V0DPBrWkWCel",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Ipsilateral Bulgarian Split Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/gOht2c4hMzg?si=yTn2j_m1x58wZj-l",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Single Leg Supported",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Rear)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Low Hold Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/HLDhxSqMQyE?si=3iYb1Ys4Ld0KFpSn",
    inDepthYouTubeExplanation:
      "https://youtu.be/R8jArZG2J6Q?si=Z3yEF8LGxl0s7dyZ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Front Rack Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/OEtwgF9fZcM?si=NiXeU6zewA9v0Fkx",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Overhead Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Bear Hug Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Bear Hug",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Heavy Sandbag Shoulder Contralateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Back Rack Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/1vL0XkLlP-w?si=hzM0tCpVcWoTpqc7",
    inDepthYouTubeExplanation:
      "https://youtu.be/dQZjFjYyghY?si=V6LePfJxqq9jPNlv",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Suitcase Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Front Rack Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/TzuHADj8h4M?si=iwVlpYdKhmpx03MU",
    inDepthYouTubeExplanation: "https://youtu.be/9mCPNtpVs78?feature=shared",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Front Rack Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Front Rack Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/yX1XqdeaczU?si=-zoUhOUe3G-CUM4q",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Overhead Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Suitcase Contralateral Lateral Lunge",
    shortYouTubeDemonstration: "https://youtu.be/-5W0Wi2_vps?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Contralateral Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/OWIhh8vYl-M?si=WNuup7a0fJkVHgbd",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Contralateral Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/Lfk8pR6zSpY?si=OohC0T89kZMsUcm0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Overhead Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Goblet Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/Vfl-OUHFQQo?si=zECktY2dytdpOMdK",
    inDepthYouTubeExplanation:
      "https://youtu.be/eP-4bV7QHyE?si=d_qLJvRMM3KWiCeD",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Clubbell Order Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Clubbell Order Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Contralateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Macebell Order Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bottoms Up Overhead Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Suitcase Contralateral Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/NlkYG2ZJ0OE?si=oa1-NGoydk-xKSsq",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/vwOrd9umMOc?si=dTiEBNYBRJajSW4a",
    inDepthYouTubeExplanation:
      "https://youtu.be/4NlJdSzHeUg?si=2E1_ojqfTLq4NlAF",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bulgarian Bag Back Rack Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sandbag Front Rack Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/U-z_jIM8Tew?si=SZspUD2oLZXeO5D2",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/iojT0TdeY-Q?si=ROEMSEe_KkOEdMc0",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Contralateral Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/Zsabw1IsO9I?si=b5LVn94BLkSHKB_5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Contralateral Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/MmjIL_vngvw?si=aEO8f0KqC36Pr-Lx",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Contralateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Contralateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Goblet Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/kLdLvTsVbeU?si=ncvaPkFaqqmfK76j",
    inDepthYouTubeExplanation:
      "https://youtu.be/hD8yDBkMvrY?si=RWCL1eyJbZDxcftm",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/rWKbV7s0bhc?si=DBfnajIIdfbAlzNg",
    inDepthYouTubeExplanation:
      "https://youtu.be/OLyBsmkkn-8?si=MmGtKt0dLzNU6gv2",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Zercher Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/xeeDCg5-Jxw?si=ji2BQOrjjkDkClD5",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Front Rack Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration:
      "https://youtu.be/eKSHQsVMOK4?si=5Lej30jpx3r7UZJB",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Clubbell Order Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Clubbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Front Rack Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Front Rack Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Overhead Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Overhead Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Heavy Sandbag Shoulder Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Heavy Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Macebell Order Contralateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Macebell Order Ipsilateral Lateral Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Macebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Order",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Single Arm Kettlebell Clean to Push Press",
    shortYouTubeDemonstration:
      "https://youtu.be/wmPn0Mvn1gU?si=J1dYeSMpkYaIcLj8",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Clean to Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/iMjJRSR2VjU?si=aNlEfyCdPcY-CarB",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Clean to Front Rack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Landmine Half Kneeling Ipsilateral Shoulder Press",
    shortYouTubeDemonstration:
      "https://youtu.be/JFAHbtg7yGo?si=D0wQ8DZcL7yrM3kB",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Copenhagen Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/-2epiOMX6MA?si=uVZg_03GZULcCJ7F",
    inDepthYouTubeExplanation:
      "https://youtu.be/aMh9KnHyJB8?si=WZf_Ph83rWi8kBN5",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Side)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Gorilla Clean",
    shortYouTubeDemonstration:
      "https://youtu.be/8iDWbo_j5v0?si=sHXK18f-6Tt7DZDW",
    inDepthYouTubeExplanation:
      "https://youtu.be/vn_fZo4rp44?si=FufgdgZ2zFp6DH8B",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Stability Ball Side Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/4PEb0vOgK-c?si=VnLjpuKoW3QEQjAS",
    inDepthYouTubeExplanation:
      "https://youtu.be/U6k6ToZyUyM?si=Y9zteFz7De0ht_D2",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Lateral Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Mountain Climber",
    shortYouTubeDemonstration:
      "https://youtu.be/P6etpDUfGWE?si=PNWuo_7oxajSyVST",
    inDepthYouTubeExplanation:
      "https://youtu.be/13wn0rh5cOc?si=F4AOoxtDJqfrhKGK",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Kettlebell Horn Grip Seated Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/8ZojxSRyeSc?si=VyMvt77RkP4-J8_Z",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Single Arm Kettlebell Clean to Bent Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Rotational",
    MovementPatternCount3: "Vertical Push",
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Clean to Bent Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Rotational",
    MovementPatternCount3: "Vertical Push",
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Copenhagen Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/vYpsixm7ETY?si=OnSWh63rxbrpvpV9",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Side)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Copenhagen Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/SDe0leCDjKA?si=GubJDQVVx4IoBbJa",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Side)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Bent Knee Copenhagen Plank",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Side)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Bottoms Up Bent Knee Copenhagen Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/5mF3RrwkX-M?si=sDX18PL3XzhLlBhu",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Side)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Kneeling Rollout",
    shortYouTubeDemonstration:
      "https://youtu.be/LgDDIt6oXkM?si=KauCb0BONYq4Old8",
    inDepthYouTubeExplanation:
      "https://youtu.be/916AGdLlFsc?si=Gpb4W69WdCtvr8QZ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Kettlebell Horn Grip Tall Kneeling Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/tW2C6Lo__Yk?si=Yp5YaQGXIq81DkOp",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Horn Grip Half Kneeling Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/iwRRckk8aSg?si=JM8g4iDrUB-VdtU4",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/-W0wS5W_PVw?si=5DGjI1VND3VVMHPC",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Seated Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/brZSl8Vvn1k?si=5ow9W6khPHpplZlE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Bicep Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/EDX7Sq5eGOQ?si=hSYR5MrGFA06VOJO",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Seated Bicep Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/f3LvSVbDINk?si=fJJqDtL6UzxX6HF2",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Seated Bicep Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Incline Bench Bicep Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Incline Bench Bicep Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Incline Bench Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/KKoE4bpJFHg?si=w_Jg92Al0uWTHBrc",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Incline Bench Bicep Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: "https://youtu.be/W9Fi7zqSu3w?feature=shared",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Alternating Double Kettlebell Tall Kneeling Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/gXoD6NsVG6A?si=T_xS8jfGx-kpADhE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Tall Kneeling Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/JfCsmOJVVZY?si=RffYK1zASlVfYN1a",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Kettlebell Tall Kneeling Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/hGE3lxAF2Ew?si=MwJzQO_RzHV8FcbT",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Half Kneeling Concentration Curl",
    shortYouTubeDemonstration: "https://youtu.be/UtdszXND3fg?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sled Push",
    shortYouTubeDemonstration:
      "https://youtu.be/MbQWu3GdWfc?si=KbIZoybRZD3g6-FW",
    inDepthYouTubeExplanation:
      "https://youtu.be/9XRRXaUpnLk?si=2IFvs6fVDMa6H8H-",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Gastrocnemius",
    primaryEquipment: "Sled",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Sled Rope Pull",
    shortYouTubeDemonstration:
      "https://youtu.be/gdtO9qeaiCE?si=S9DCMUsrnQHGFG6p",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Sled",
    CountPrimaryItems: 1,
    secondaryEquipment: "Battle Ropes",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Sled Rope Seated Pull",
    shortYouTubeDemonstration:
      "https://youtu.be/2E_kPuk5hvE?si=S5YhKa1bP3YcStRr",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Sled",
    CountPrimaryItems: 1,
    secondaryEquipment: "Battle Ropes",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Sled Forward Drag",
    shortYouTubeDemonstration:
      "https://youtu.be/r5cW_epFjIw?si=VKB6obgn3EIvcAkZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/eOakNqRwNms?si=eWVVX_EecvbRl0Ib",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Gastrocnemius",
    primaryEquipment: "Sled",
    CountPrimaryItems: 1,
    secondaryEquipment: "Suspension Trainer",
    CountSecondaryItems: 1,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Front Rack March",
    shortYouTubeDemonstration:
      "https://youtu.be/Lfra9QN-CEY?si=8LJ2F_o_hqib0dW7",
    inDepthYouTubeExplanation:
      "https://youtu.be/s_T4NtUScEw?si=3V9hwKOvz-evmjc1",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Tactical Clean to Push Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Tactical Clean to Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Tactical Clean to Split Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Tactical Clean to Push Press",
    shortYouTubeDemonstration:
      "https://youtu.be/VqGvsMrYawU?si=Ori5Rji8qPy2ADXI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Tactical Clean to Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Tactical Clean to Front Rack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Tactical Clean to Bent Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Rotational",
    MovementPatternCount3: "Vertical Push",
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Cable Straight Bar Incline Bench Tricep Pushdown",
    shortYouTubeDemonstration:
      "https://youtu.be/jygDw93Kpec?si=9DxPSP8Q1CPy0yy6",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Tall Kneeling Reverse Grip Bicep Curl",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Brachialis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Straight Bar Tall Kneeling Tricep Pushdown",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Cable Bayesian Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/TIwtTz5DX30?si=V3tF_pgDukqaKglY",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Contralateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Rope Incline Bench Tricep Pushdown",
    shortYouTubeDemonstration:
      "https://youtu.be/WT7TZA3xBHA?si=15gqGEo-GBZLm2qa",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Start Stop Half Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Start Stop Half Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Start Stop Half Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Kneeling Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/cMTMeVuzxrc?si=APyA08cxZpcn68qE",
    inDepthYouTubeExplanation: "https://youtu.be/fxizQJzMcPY?feature=shared",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Oblique Crunch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/teZDcxypX54?si=5hPKSeI_xcW5yftV",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "Head Supported",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Start Stop Clean to Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Start Stop Clean to Front Rack Alternating Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Start Stop Clean to Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Start Stop Clean to Push Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Start Stop Clean to Split Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Start Stop Clean to Front Rack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Start Stop Clean to Push Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Double Kettlebell Start Stop Clean to Front Rack Alternating Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Start Stop Clean to Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Start Stop Clean to Front Rack Contralateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Start Stop Clean to Split Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Start Stop Clean to Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Kettlebell Start Stop Clean to Push Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Start Stop Clean to Push Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Start Stop Clean to Front Rack Contralateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Start Stop Clean to Front Rack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Start Stop Clean to Front Rack Ipsilateral Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Kettlebell Start Stop Clean to Front Rack Ipsilateral Forward Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Start Stop Clean to Push Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Start Stop Clean to Thruster",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Quadriceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: "Knee Dominullt",
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Alternating Single Arm Kettlebell Start Stop Clean to Split Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Start Stop Clean to Push Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Start Stop Clean to Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Alternating Single Arm Kettlebell Start Stop Clean to Front Rack Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Knee Dominullt",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Single Arm Barbell Suitcase Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/E7vYUfMcFhs?si=bti9p5lCqTpD-Y-q",
    inDepthYouTubeExplanation:
      "https://youtu.be/n4sWXTMzyLw?si=z5uQAYV_VMWZ9PMm",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Suitcase Deadlift",
    shortYouTubeDemonstration:
      "https://youtu.be/29MJct32_6Y?si=ItNGT0m2qUZTy4_O",
    inDepthYouTubeExplanation:
      "https://youtu.be/BDb97sC2QQA?si=0KoMceC97bJL25gJ",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Bent Knee Copenhagen Plank",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Side)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Dumbbell Copenhagen Plank",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated (Side)",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Dumbbell Tall Kneeling Lateral Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/OzrufXl0b4g?si=Oc_ebRjhZGfC10tB",
    inDepthYouTubeExplanation:
      "https://youtu.be/YQEabNyRAXA?si=gkjRU26Twj5DTV53",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Lateral Deltoids",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Trapezius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sled Reverse Drag",
    shortYouTubeDemonstration:
      "https://youtu.be/-L-M4f3qHZA?si=9IPQGch1yER949WQ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Vastus Mediais",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Sled",
    CountPrimaryItems: 1,
    secondaryEquipment: "Suspension Trainer",
    CountSecondaryItems: 1,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Kettlebell Seated Overhead Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/bvCa5-w0hvo?si=FdCVlFz1TmRP9LXb",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Overhead Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/0eQnBZCrwVM?si=pY5IcCp4BNxSyhZL",
    inDepthYouTubeExplanation:
      "https://youtu.be/qS5q6FgddTI?si=Yn8BcKE1sbTlVnQS",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Kettlebell Tall Kneeling Overhead Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/oAaAFOKIojs?si=zUlHomJXt3sLWs_Q",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Tall Kneeling Bicep Curl",
    shortYouTubeDemonstration: "https://youtu.be/FMnsYQaeICE?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/oLjwkhamWh0?si=OeJ5LrGKgIQJG3au",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Bulgarian Bag Back Rack Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bulgarian Bag",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Incline Bench Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/FxVNp1EAcvo?si=XUiRmuJ_4P8w8nEj",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/-ngqbDJP-QE?si=onuXRsIy65F_bbPM",
    inDepthYouTubeExplanation:
      "https://youtu.be/rvDr7N7l3CQ?si=RT0gzkft4Xl-S9HT",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Kettlebell Decline Bench Chest Fly",
    shortYouTubeDemonstration: "https://youtu.be/88FvxU3txl4?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Bar Chin Up",
    shortYouTubeDemonstration:
      "https://youtu.be/vlASvQCD4lY?si=H4b5rDHWlAXSfLEz",
    inDepthYouTubeExplanation:
      "https://youtu.be/TOUl7e8kb-s?si=5MUqjtOQm38h1cFF",
    difficultyLevel: "Master",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Dumbbell Seated Cuban Press",
    shortYouTubeDemonstration:
      "https://youtu.be/Cz7-hfa1UG8?si=cU9RS2gcX9ME3VFs",
    inDepthYouTubeExplanation:
      "https://youtu.be/n70LVVTO2xQ?si=VDg9wvHRYysoyc7o",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Infraspinatus",
    tertiaryMuscle: "Upper Trapezius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder External Rotation",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Double Kettlebell Dive Bomber Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Feet Elevated Pike Push Up",
    shortYouTubeDemonstration:
      "https://youtu.be/Uhi9c2SDl6o?si=hootzYYWD4d2powE",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Inverted",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Kettlebell Pseudo Planche Push Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/mqmAWC_JkEM?si=nAwbpDPF6P2xviX7",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Sled Low Row",
    shortYouTubeDemonstration:
      "https://youtu.be/PvvNgvRwqXI?si=UMeSCbCrmSwbFJre",
    inDepthYouTubeExplanation:
      "https://youtu.be/5qozf6XzqDg?si=i2E16OKVU9VjBZJ5",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Sled",
    CountPrimaryItems: 1,
    secondaryEquipment: "Suspension Trainer",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Assisted Bar Chin Up",
    shortYouTubeDemonstration:
      "https://youtu.be/tKZ_IjDX7fA?si=ymbKZ_6m6CiddaOL",
    inDepthYouTubeExplanation:
      "https://youtu.be/6NoWVtcSUyI?si=1L8vLidqZV1vtBGK",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "Pull Up Bar",
    CountSecondaryItems: 1,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Commando Pull Up",
    shortYouTubeDemonstration:
      "https://youtu.be/MTpg2fM-_F4?si=oQ-nElz0soKFgFHT",
    inDepthYouTubeExplanation:
      "https://youtu.be/PWXWIh5c8L4?si=5AiLb_06rJkmTb2a",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Mixed Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Barbell Half Kneeling Bent Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Grinds",
  },
  {
    name: "Superband Assisted Bar Commando Pull Up",
    shortYouTubeDemonstration:
      "https://youtu.be/qUzqwzTWLoc?si=t4nKfRciAYbHRJyr",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "Pull Up Bar",
    CountSecondaryItems: 1,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Mixed Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Toe Balance Squat",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Toe Balance",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Climbing Rope L Sit Pull Up",
    shortYouTubeDemonstration:
      "https://youtu.be/YPIv3MogGgo?si=W46_DHRaS-ROfgcb",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Climbing Rope",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Mixed Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Climbing Rope Seated L Sit Pull Up",
    shortYouTubeDemonstration:
      "https://youtu.be/N1NCIgaCbmo?si=50uKC_L4pEPyhR7m",
    inDepthYouTubeExplanation:
      "https://youtu.be/0EdWY_0e_c8?si=p0Ti9qhFu_RXAmNJ",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Climbing Rope",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Mixed Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Climbing Rope Hanging L Sit",
    shortYouTubeDemonstration:
      "https://youtu.be/X91DSVDBT1s?si=UevmYNdSAy0aA49t",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Climbing Rope",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Mixed Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Climbing Rope Hanging L Sit Flutter Kicks ",
    shortYouTubeDemonstration:
      "https://youtu.be/ul8G6NfwcKE?si=bP1jwilThrtCP37m",
    inDepthYouTubeExplanation:
      "https://youtu.be/QSFMIf84MGA?si=T1Z6C_Rt2gfyPUIj",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Climbing Rope",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Mixed Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Climbing Rope L Sit Climb",
    shortYouTubeDemonstration:
      "https://youtu.be/ZuDgEhPspvo?si=BndR3kA8YnLxuZxN",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Master",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Climbing Rope",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Mixed Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: "Isometric Hold",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Climbing Rope Legless Climb",
    shortYouTubeDemonstration:
      "https://youtu.be/rfr-Tw3Pxh8?si=qrQ6_5_lPNIjF4eo",
    inDepthYouTubeExplanation:
      "https://youtu.be/7ckCqyAy_UU?si=Kaol49pIwsK5Jf7R",
    difficultyLevel: "Expert",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Climbing Rope",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Mixed Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Climbing Rope J Hook Climb",
    shortYouTubeDemonstration:
      "https://youtu.be/Pa4QUC9AvuA?si=_elyMb15TpqfSXja",
    inDepthYouTubeExplanation:
      "https://youtu.be/nI4MijQJ_No?si=BzM6pG_BTUdHc4ug",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Climbing Rope",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Mixed Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Climbing Rope S Wrap Climb",
    shortYouTubeDemonstration:
      "https://youtu.be/zBoTgBpkn7o?si=3Ix0hv2wZwd-m2Co",
    inDepthYouTubeExplanation:
      "https://youtu.be/QTMf7TS7ySk?si=PqMGO7zWw2svtNPj",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Climbing Rope",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Mixed Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Kettlebell Single Leg Standing Bent Knee Alternating Halo",
    shortYouTubeDemonstration:
      "https://youtu.be/P8Wv46CjIs4?si=z2T1LOoTqom5vyKi",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Posterior Deltoids",
    secondaryMuscle: "Medial Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Bottoms Up Horn Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Single Leg Standing Bent Knee Ipsilateral Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing Bent Knee",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Ipsilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Barbell Zercher March",
    shortYouTubeDemonstration:
      "https://youtu.be/05ABqEEgasA?si=8BF9AxQrgT3OY5u_",
    inDepthYouTubeExplanation:
      "https://youtu.be/E5MYGmOONJM?si=qOhwfjZ8d6aFmaiM",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Zercher",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bodyweight March",
    shortYouTubeDemonstration:
      "https://youtu.be/3Lc1n1iXM7s?si=7mcqsAivpC6eUgMu",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Kettlebell Rotational Snatch",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Suspension Pallof Press",
    shortYouTubeDemonstration:
      "https://youtu.be/UFgykifRSvQ?si=lUaVB8ZhF8ACrc4h",
    inDepthYouTubeExplanation:
      "https://youtu.be/uCrkeY8dees?si=fOQ5msbTKQIJerpX",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Climbing Rope Dead Hang",
    shortYouTubeDemonstration:
      "https://youtu.be/1kfxGBCXvrk?si=8pQzSrl0T2_7bVLw",
    inDepthYouTubeExplanation:
      "https://youtu.be/hDA_NmIzaNc?si=_P4yddl7T3evFAN1",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Forearms",
    primeMoverMuscle: "Brachioradialis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Teres Major",
    primaryEquipment: "Climbing Rope",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Mixed Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Suspension Kneeling Rollout",
    shortYouTubeDemonstration:
      "https://youtu.be/yFt5UltkFCA?si=o0SXv0YEikxLTThg",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Reverse Crunch",
    shortYouTubeDemonstration:
      "https://youtu.be/duhPBZkq0xg?si=K4QIb8cjoQDdU-dJ",
    inDepthYouTubeExplanation:
      "https://youtu.be/w2dxPtV77kg?si=2hZwJ20FpYXBs018",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slam Ball Overhead Slam",
    shortYouTubeDemonstration:
      "https://youtu.be/k9W6g9LvXDI?si=r2ny_BUMtle93fEw",
    inDepthYouTubeExplanation:
      "https://youtu.be/QxYhFwMd1Ks?si=hh_8HQ94iiDCrWVj",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Slam Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Slam Ball Tall Kneeling Overhead Slam",
    shortYouTubeDemonstration:
      "https://youtu.be/LhCS360FBvA?si=NOWK4R-Br_tSVldj",
    inDepthYouTubeExplanation:
      "https://youtu.be/yeE8VZhUPSE?si=ddsQXYx4p6ETZpMI",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Slam Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Slam Ball Alternating Rotational Overhead Slam",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/pjLbOaNInTk?si=7XgS5zAhyZBO0KQX",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Latissimus Dorsi",
    primaryEquipment: "Slam Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Slam Ball Squat Jump Overhead Slam ",
    shortYouTubeDemonstration:
      "https://youtu.be/LcgWDIYgnhg?si=OWBjxnU5ZUG1gCzK",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Gluteus Maximus",
    primaryEquipment: "Slam Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Slam Ball Tall Kneeling Alternating Rotational Overhead Slam",
    shortYouTubeDemonstration:
      "https://youtu.be/UwWVqgePy2w?si=r4YTnAupde84IgyA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Latissimus Dorsi",
    primaryEquipment: "Slam Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Ballistics",
  },
  {
    name: "Bodyweight Shrimp Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/rNsE0g9PeeA?si=zcNMA2u1Mkdf3Opf",
    inDepthYouTubeExplanation:
      "https://youtu.be/_FBuC-VPbRY?si=1MwyLFxnUG4qllif",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Hand Assisted Shrimp Squat",
    shortYouTubeDemonstration:
      "https://youtu.be/c-g9fmlQ5l4?si=-RKC_mk2P8oIA0kz",
    inDepthYouTubeExplanation:
      "https://youtu.be/tnGZCMjgbwg?si=4jYhF3_3VgOsqZwj",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: null,
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Hand Assisted",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Cable Bayesian Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/8A53W4ABe5I?si=PlVzkrowfJy1WXF1",
    inDepthYouTubeExplanation:
      "https://youtu.be/4O24gFksZ04?si=5GrZ3zJsUsOIDTqL",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Reverse Grip Incline Bench Press",
    shortYouTubeDemonstration:
      "https://youtu.be/fovEGjXSYj4?si=R3fPoSd5ejZCgKll",
    inDepthYouTubeExplanation:
      "https://youtu.be/vUbtOZ2NNtk?si=gb2XGpG6iD53oEMO",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Reverse Grip Decline Bench Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/pKjBQcEc6kU?si=B4SHho2yEZQIV1_F",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bar Windshield Wiper",
    shortYouTubeDemonstration:
      "https://youtu.be/q-5xzuVDZ0o?si=5L3fg2tvxhgRuWIr",
    inDepthYouTubeExplanation:
      "https://youtu.be/ygwy2b2marI?si=MyAxyOa-ssIPMUEB",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Transverse Abdominis",
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Windshield Wiper",
    shortYouTubeDemonstration:
      "https://youtu.be/3pZ6wfIz08Y?si=5fpjOOF_aj7Rqkva",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Transverse Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Windshield Wiper",
    shortYouTubeDemonstration:
      "https://youtu.be/XXcRdXIw0go?si=y-Sh6yOZyvTpiN50",
    inDepthYouTubeExplanation:
      "https://youtu.be/aIr0E8ZXUqw?si=Hs-OzSS-_dEyAKns",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Transverse Abdominis",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bodyweight Bent Knee Windshield Wiper",
    shortYouTubeDemonstration:
      "https://youtu.be/8ruEIfBzLrw?si=smM0Bo6E_xDv-x1e",
    inDepthYouTubeExplanation: "https://youtu.be/ZS-NQyNKyvU?feature=shared",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Transverse Abdominis",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Barbell Windshield Wiper",
    shortYouTubeDemonstration:
      "https://youtu.be/eNxGGePOIKc?si=7JyPr9YGL-PaAxUu",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Transverse Abdominis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Above Chest",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Bar Bent Knee Windshield Wiper",
    shortYouTubeDemonstration:
      "https://youtu.be/3fg-hQVEplQ?si=XEmrtzkwGBxeHlH4",
    inDepthYouTubeExplanation:
      "https://youtu.be/_LBPsGv4cWM?si=elgXDg0ZkSED_SjY",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Transverse Abdominis",
    primaryEquipment: "Pull Up Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Ring Bent Knee Windshield Wiper",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Transverse Abdominis",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Sled Lateral Drag",
    shortYouTubeDemonstration:
      "https://youtu.be/rGtYmX2aeAA?si=vGnxKaVzGlUTMmmQ",
    inDepthYouTubeExplanation:
      "https://youtu.be/29zEijB8GRg?si=rZFz2AbXxO328WFR",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Adductor Magnus",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Sled",
    CountPrimaryItems: 1,
    secondaryEquipment: "Suspension Trainer",
    CountSecondaryItems: 1,
    posture: "Walking",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Lateral Locomotion",
    MovementPatternCount2: "Hip Abduction",
    MovementPatternCount3: "Anti-Lateral Flexion",
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/zjBV2T7K0Rg?si=_bwLTITNdt5K9Gvl",
    inDepthYouTubeExplanation: "https://youtu.be/ipTU3nnZbcw?feature=shared",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Kneeling Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/zVYCZvgemlg?si=-a8bJrHDZxw6HPUH",
    inDepthYouTubeExplanation: "https://youtu.be/_ufp56PW80A?feature=shared",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Barbell Squat Clean to Squat Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/uKKoLcOJKB8?si=-OlEu2pk86XR-Gs7",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Power Clean to Squat Jerk",
    shortYouTubeDemonstration:
      "https://youtu.be/g-XhUMB6_wk?si=7RXzbNpwkvoBKK88",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Hang Squat Clean to Squat Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "Barbell Hang Power Clean to Squat Jerk",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Anterior Deltoids ",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Combo Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Hip Hinge",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push & Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Olympic Weightlifting ",
  },
  {
    name: "EZ Bar Close Grip Strict Bicep Curl",
    shortYouTubeDemonstration:
      "https://youtu.be/ELozuUa8rjk?si=pfjkNnOsw1MmdI5_",
    inDepthYouTubeExplanation:
      "https://youtu.be/Cr3EXYLQ3rQ?si=hvcgUjV--10sAoiB",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Biceps",
    primeMoverMuscle: "Biceps Brachii",
    secondaryMuscle: "Brachialis",
    tertiaryMuscle: "Brachioradialis",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead March",
    shortYouTubeDemonstration: "https://youtu.be/fzuxbZSW3UA?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/G7Ds_tGgG2A?si=mTxRraBGJdHOgS5S",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Slider Body Saw",
    shortYouTubeDemonstration:
      "https://youtu.be/cC3nItw-szY?si=-UBQr2PgbT6bRuKh&utm_source=MTQxZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/7mRhqSp1MIA?si=h4a13nU0b6Gy2bZF",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Parallette Mountain Climber",
    shortYouTubeDemonstration:
      "https://youtu.be/lmtz6T204No?si=jbae97NKFny9b463",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Anterior Deltoids",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "Parallette Bars",
    CountSecondaryItems: 2,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Spinal Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Plate Frog Pump",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Dumbbell Feet Elevated Frog Pump",
    shortYouTubeDemonstration:
      "https://youtu.be/67HLZ2-3_v0?si=57cdzDwX0TrSRLYm",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Plate Feet Elevated Frog Pump",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Kettlebell Frog Pump",
    shortYouTubeDemonstration:
      "https://youtu.be/cdvQmb5iNdc?si=WU6MMMqGPXHZwOf9",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Kettlebell Feet Elevated Frog Pump",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Biceps Femoris",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Kettlebell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Bridge",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Horn Grip",
    loadPositionEnding: "Hip Crease",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Body Saw",
    shortYouTubeDemonstration:
      "https://youtu.be/u8BCm4GkOSY?si=mivk-6ghBacHbVR9",
    inDepthYouTubeExplanation:
      "https://youtu.be/HmyWstLop08?si=uukj5CKTOhpHaTjI",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Bodyweight Single Leg Box Jump",
    shortYouTubeDemonstration:
      "https://youtu.be/ENZjCX9HjVI?si=gdLZCVhHGqq16S_R",
    inDepthYouTubeExplanation:
      "https://youtu.be/LDU_yVvp7pA?si=MGZ7zoqpg43J_Iej",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Biceps Femoris",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Plyo Box",
    CountSecondaryItems: 1,
    posture: "Single Leg Standing",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Foot Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Plyometric",
  },
  {
    name: "Miniband March",
    shortYouTubeDemonstration:
      "https://youtu.be/7rkzWjwrazQ?si=poAx5_jLTfV0N0Up",
    inDepthYouTubeExplanation:
      "https://youtu.be/_RNycAehg94?si=UglKQNm2drza_2co",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Sandbag Front Rack March",
    shortYouTubeDemonstration:
      "https://youtu.be/QU0tbSNu0-8?si=KcVtyY0N6KP7lrb_",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Sandbag Shoulder March",
    shortYouTubeDemonstration:
      "https://youtu.be/P_coucNMiK0?si=6WAs2e4x_zEuxZLz",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Shoulder",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Sandbag Overhead March",
    shortYouTubeDemonstration:
      "https://youtu.be/pCO1EJ0WL30?si=y4xIpqM8QUMlG_ia",
    inDepthYouTubeExplanation:
      "https://youtu.be/RsFycSOPD_E?si=uOChpvQ7-d6cCRVh",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Sandbag Back Rack March",
    shortYouTubeDemonstration:
      "https://youtu.be/-s80JT1GZRs?si=qKXPOlVNn8DU_o2f",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Dumbbell Crush Grip Front Rack March",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bulgarian Bag Back Rack March",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bulgarian Bag Thruster",
    shortYouTubeDemonstration:
      "https://youtu.be/-Am9J90oDK4?si=DzyEzfiwzZAs3ckF",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Sandbag Thruster",
    shortYouTubeDemonstration:
      "https://youtu.be/Zw0q4TYy8eI?si=-MWyXSvjBoei8Mmn",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: null,
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: "Vertical Push",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Sandbag Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/OZT20vP92ls?si=msixASyZYFzp43En",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Sandbag Half Kneeling Overhead Press",
    shortYouTubeDemonstration:
      "https://youtu.be/y6k_0YpUP44?si=QEPu230wf0aPiJsJ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Sandbag Tall Kneeling Overhead Press",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Triceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Sandbag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Push",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Landmine Goblet March",
    shortYouTubeDemonstration:
      "https://youtu.be/OW3qG0eSgK4?si=ilF_TQTIcKH04qVz",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Goblet",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Landmine Overhead March",
    shortYouTubeDemonstration:
      "https://youtu.be/019lukD1BrU?si=Z3NYagSLu7vpxllW",
    inDepthYouTubeExplanation:
      "https://youtu.be/_iPceq-DawY?si=hEzoq92VoPNx4eVr",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Single Arm Landmine Suitcase March",
    shortYouTubeDemonstration:
      "https://youtu.be/l1Z6ltvHwcM?si=g47yzABqexq3NE7E",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Suitcase",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Bulgarian Bag Overhead March",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Hip Flexors",
    primeMoverMuscle: "Iliopsoas",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: "Gluteus Medius",
    primaryEquipment: "Bulgarian Bag",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "March",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Locomotion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Superband Tall Kneeling Pull Through",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Hinge",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Unsorted*",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Skull Crusher",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/v6uHja-uSHY?si=TxCpvOrcAQAlPb1w",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Incline Bench Skull Crusher",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/78HIGlbhFgo?si=KGdcqTeAy4sLb8nH",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Decline Bench Skull Crusher",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Floor Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/i3j2R28TKH4?si=Vq9ICK3WiYcphvd9",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Barbell Floor Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/0LSPT_gJcTk?si=oTv9Tc_18B1V8E3E",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Barbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Straight Bar Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/IlNtRJkIAfg?si=H3-HtM3eVSx3c8T-",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Straight Bar Incline Bench Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/QgzOgnBBivE?si=WqHP0U99yC8T0Pz_",
    inDepthYouTubeExplanation:
      "https://youtu.be/Jv8czugwnKM?si=8iZoA_5S8C4Zbyv0",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Rope Incline Bench Skull Crusher",
    shortYouTubeDemonstration: "https://youtu.be/MVC7c73K61I?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Straight Bar Decline Bench Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/y0IdUZhZ87s?si=g54AKBchD_Tow6sM",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Dumbbell Floor Skull Crusher",
    shortYouTubeDemonstration: "https://youtu.be/hLKejvgR5xY?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/9oUcNuuTMMA?si=BHDHOiWHZmbsjxgO",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Dumbbell Crush Grip Floor Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/-V2SqBSUh_A?si=eUQCnSpJ8s-ZcScI",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Crush Grip",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Rope Decline Bench Skull Crusher",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Rope Floor Skull Crusher",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Straight Bar Floor Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/si8q23nPVHk?si=aeyG4_3OSRLAIpiA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/DvgvfUFjb4E?si=Yw6liGivI_UnZu76",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Incline Bench Skull Crusher",
    shortYouTubeDemonstration:
      "https://youtu.be/XxVWmNbY6yo?si=7n1rTCkP0feHM1xA",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Decline Bench Skull Crusher",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Floor Skull Crusher",
    shortYouTubeDemonstration: "https://youtu.be/fRnRcmn7iWk?feature=shared",
    inDepthYouTubeExplanation:
      "https://youtu.be/jk9jfNrqAt0?si=lZYziWGgH_U4gaEu",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anconeus",
    tertiaryMuscle: "Flexor Carpi Radialis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Seated Overhead Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/kZ-ReOdn2qk?si=00jzpKZzHCr2EIm3",
    inDepthYouTubeExplanation:
      "https://youtu.be/muTfQlepBHI?si=-GAKVa0UVZS-ZchO",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Overhead Tricep Extension",
    shortYouTubeDemonstration:
      "https://youtu.be/2HBq-Tee-14?si=tTQPp2-MoSzG_hJL",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Single Arm Dumbbell Tall Kneeling Overhead Tricep Extension",
    shortYouTubeDemonstration: "https://youtu.be/cDkzaJaOYMo?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Triceps",
    primeMoverMuscle: "Triceps Brachii ",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Rectus Abdominis",
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Tall Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Elbow Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Miniband Dead Bug",
    shortYouTubeDemonstration:
      "https://youtu.be/hSVxpNktAZ4?si=X2QXPPV90G-NjXyx",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Rectus Femoris",
    primaryEquipment: "Miniband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Contralateral",
    primaryExerciseClassification: "Postural",
  },
  {
    name: "Stability Ball Body Saw",
    shortYouTubeDemonstration:
      "https://youtu.be/fgP2oii-GiQ?si=mbhNYj3pW612wBRY",
    inDepthYouTubeExplanation:
      "https://youtu.be/7vsBQIR3Mfc?si=2DY9VK3jUbXwHnQ6",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Medicine Ball Alternating Single Leg V Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/Pp32aIWX-XQ?si=nbvgHN2LwSgXB904",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Medicine Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Medicine Ball Alternating Single Leg V Up Pass Through",
    shortYouTubeDemonstration:
      "https://youtu.be/CB6AROCPwm4?si=cG6vqjgcH__bn9KN",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Medicine Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Alternating",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Medicine Ball Otis Up",
    shortYouTubeDemonstration:
      "https://youtu.be/b-06cnxJ2YY?si=wCCcWK7wyR8RgwCV",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Medicine Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slam Ball Otis Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Slam Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Ring Body Saw",
    shortYouTubeDemonstration:
      "https://youtu.be/EqGVH1qHzwU?si=hyDFD2YkFH9OLT29",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Kneeling Body Saw",
    shortYouTubeDemonstration:
      "https://youtu.be/pYy3IaD55OM?si=zoWOIZ-SmoJywASH",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Kneeling Stir the Pot",
    shortYouTubeDemonstration:
      "https://youtu.be/GMbT_cHg0dU?si=cnXGlMZAT5YjS73B",
    inDepthYouTubeExplanation:
      "https://youtu.be/4aMczP5KogY?si=5-mCFarYa4iburVN",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: "Spinal Rotational",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Medicine Ball Half Kneeling Low to High Chop",
    shortYouTubeDemonstration:
      "https://youtu.be/CWwVvvgiwxQ?si=16DmFUoBfHBpmKm_",
    inDepthYouTubeExplanation:
      "https://youtu.be/jGz4Re9ZSlM?si=C7MgBmsGlTm85eVC",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Medicine Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Medicine Ball Isometric Split Squat Low to High Chop",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Medicine Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Wall Ball Half Kneeling Low to High Chop",
    shortYouTubeDemonstration:
      "https://youtu.be/3-EuiQhr9fA?si=ZKO5oh7NHF8_OfxJ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Wall Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Wall Ball Isometric Split Squat Low to High Chop",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/Kgut72989Us?si=SZrVkt5Bcd91nsmK",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Wall Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Slam Ball Half Kneeling Low to High Chop",
    shortYouTubeDemonstration:
      "https://youtu.be/18B_3fISG48?si=Tj8Ufhup9wvyOjvB",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Slam Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slam Ball Isometric Split Squat Low to High Chop",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Slam Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Dumbbell Half Kneeling Low to High Chop",
    shortYouTubeDemonstration:
      "https://youtu.be/qyM7NdixJzI?si=NCooBu364vvvPnk3",
    inDepthYouTubeExplanation:
      "https://youtu.be/qH9zfcN_xh4?si=JMwQ1ZqTdbeNvroS",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Dumbbell Isometric Split Squat Low to High Chop",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Dumbbell",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Plate Half Kneeling Low to High Chop",
    shortYouTubeDemonstration:
      "https://youtu.be/FAZ-h5wEKr8?si=Vh1vqHW2hgIn69vC",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Half Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Plate Isometric Split Squat Low to High Chop",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Wall Ball Body Saw",
    shortYouTubeDemonstration:
      "https://youtu.be/Ke3i_CAVF6E?si=pJ9XGgJjXXGUnY95",
    inDepthYouTubeExplanation:
      "https://youtu.be/z1bpinbA5hc?si=_OvFWnWAIX_vmWHZ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Wall Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Plate Turkish Sit Up",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Iliopsoas",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Climbing Rope Pull Up",
    shortYouTubeDemonstration:
      "https://youtu.be/ifMzUGTW5WA?si=EnT0Z-s6UM5TbSHH",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Back",
    primeMoverMuscle: "Latissimus Dorsi",
    secondaryMuscle: "Biceps Brachii",
    tertiaryMuscle: null,
    primaryEquipment: "Climbing Rope",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Mixed Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Vertical Pull",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Pull",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Climbing Rope Hanging Leg Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/F8A92P9zf-g?si=DNpM-zIiWn0alOvD",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Climbing Rope",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Mixed Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Climbing Rope Hanging Toes to Rope",
    shortYouTubeDemonstration: "https://youtu.be/aCmbZCGQ68U?feature=shared",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: "Obliques",
    primaryEquipment: "Climbing Rope",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Hanging",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Mixed Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Double Cable Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/rmwijjkuXug?si=KrHxKYPbcDVtz1gH",
    inDepthYouTubeExplanation:
      "https://youtu.be/WEM9FCIPlxQ?si=PLumKQTIRgnkSzXY",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Cable",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Cable High to Low Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/ixn_1zDpCPc?si=5L7Yqa5uoLVVlY6W",
    inDepthYouTubeExplanation:
      "https://youtu.be/8Um35Es-ROE?si=fu1dvpePywv0aNV2",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Cable",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Cable Low to High Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/mlONJDFVtAY?si=T4BhC9LNsFQmK0y7",
    inDepthYouTubeExplanation:
      "https://youtu.be/M1N804yWA-8?si=2udfgaCcvhbe_pVY",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Cable",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band High to Low Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/7t-rTOsyaxY?si=qYz3L4NU58UcOR3w",
    inDepthYouTubeExplanation:
      "https://youtu.be/ikG2r3LK2UM?si=xiprMGEZ_SWNMyJl",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Resistance Band Low to High Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/MEVNntk8yEw?si=WwgxgS5XSi0p1o2k",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Resistance Band",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Staggered Stance",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Rope Isometric Split Squat High to Low Chop",
    shortYouTubeDemonstration:
      "https://youtu.be/WQnC460je7w?si=JmHZRydzDe7MFsRg",
    inDepthYouTubeExplanation:
      "https://youtu.be/dQmzbRou8eM?si=Peo4RyN1izvyMwr1",
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Cable Rope Isometric Split Squat Low to High Chop",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Isometric Split Squat",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Rotational",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Balance",
  },
  {
    name: "Landmine Kneeling Rollout",
    shortYouTubeDemonstration:
      "https://youtu.be/2ANZ7BhSH4Y?si=3LCewsDbR_PJEwYi",
    inDepthYouTubeExplanation:
      "https://youtu.be/ZQ22BA3U1A8?si=0-aMqL6QnZHVb2AD",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Latissimus Dorsi",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Landmine Kneeling Rollout",
    shortYouTubeDemonstration:
      "https://youtu.be/wzeTk8XAGt4?si=5TCEG3ZxGjOGYntF",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Latissimus Dorsi",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Kneeling Rollout",
    shortYouTubeDemonstration:
      "https://youtu.be/1ZFeqxlx-po?si=JUko8jYOJ3fI_TxM",
    inDepthYouTubeExplanation: "https://youtu.be/VEEuMSWlli4?feature=shared",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Standing Rollout",
    shortYouTubeDemonstration:
      "https://youtu.be/CR3CS7qhG_s?si=OjHoBQJlQQrmEXfw",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Slider Kneeling Rollout",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Latissimus Dorsi",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Kneeling",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Standing Rollout",
    shortYouTubeDemonstration:
      "https://youtu.be/PEzA_n3woFs?si=4l_G-stlnHUfbhiB",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Ring Standing Rollout",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Gymnastic Rings",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Calisthenics",
  },
  {
    name: "Single Arm Slider Standing Rollout",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Suspension Standing Rollout",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Latissimus Dorsi",
    tertiaryMuscle: "Serratus Anterior",
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Landmine Standing Rollout",
    shortYouTubeDemonstration:
      "https://youtu.be/MOS9lnGCnqM?si=4svtReY62yrKd7qk",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Advanced",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Latissimus Dorsi",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Single Arm Landmine Standing Rollout",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Expert",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: "Latissimus Dorsi",
    primaryEquipment: "Landmine",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Pronated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Plate Hollow Body Flutter Kicks",
    shortYouTubeDemonstration:
      "https://youtu.be/If7pn5ZFY60?si=izUCZfaNWALhCSat",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: "Iliopsoas",
    tertiaryMuscle: null,
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Isometric Hold",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Superband Side Lying Hanging Hip Adduction",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Adductors",
    primeMoverMuscle: "Adductor Magnus",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Superband",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Lying",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Plate Side Lying Bent Knee Hip Abduction",
    shortYouTubeDemonstration:
      "https://youtu.be/jpxdm8SJ5wM?si=35jEMaJ1JRWnO1ET",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Lying",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Side Lying Hip Abduction",
    shortYouTubeDemonstration:
      "https://youtu.be/m6dHgVYxAyc?si=NjK1qTP-dcOSCced",
    inDepthYouTubeExplanation:
      "https://youtu.be/n2SmT99Dr70?si=FaG-OeO4Or-lgqGm",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Lying",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Extended Range Side Lying Hip Abduction",
    shortYouTubeDemonstration:
      "https://youtu.be/s6API4Yeqxs?si=apjN7JBTfdY-DW16",
    inDepthYouTubeExplanation:
      "https://youtu.be/kfbS8bJmnN0?si=WRtJRJ_lIJLcNrbv",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Abductors",
    primeMoverMuscle: "Gluteus Medius",
    secondaryMuscle: "Gluteus Minimus",
    tertiaryMuscle: "Tensor Fasciae Latae",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Side Lying",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip Abduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Side Lying Clamshell",
    shortYouTubeDemonstration:
      "https://youtu.be/G3yQITNPIz8?si=V_AVSgSWE_RFAsSE",
    inDepthYouTubeExplanation:
      "https://youtu.be/fOCd_nC1HBQ?si=6ti9IkrenmKRDFGm",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Lying",
    singleOrDoubleArm: "No Arms",
    continuousOrAlternatingArms: "Continuous",
    grip: "No Grip",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip External Rotation",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Isolation",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Bodyweight Kneeling Side Plank Clamshell",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation:
      "https://youtu.be/0BhP8_plU_U?si=KupbrDjjj8HjKMrv",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Glutes",
    primeMoverMuscle: "Gluteus Maximus",
    secondaryMuscle: "Gluteus Medius",
    tertiaryMuscle: "Gluteus Minimus",
    primaryEquipment: "Bodyweight",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Hip External Rotation",
    MovementPatternCount2: "Anti-Lateral Flexion",
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Cable Incline Bench Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/i6WHN9L5uYk?si=YLzKzoCoztvNvlQl&utm_source=MTQxZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/LGDCjwO-hFg?si=PGdl-Al6d9xjHoVi&utm_source=MTQxZ",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Cable",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Incline)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Cable Seated Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/kMmV0thhwnA?si=JAh7-DW4Wpz2xBJd&utm_source=MTQxZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/CT7vDnPJZ9w?feature=shared&utm_source=MTQxZ",
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Cable",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Flat)",
    CountSecondaryItems: 1,
    posture: "Seated",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Double Cable Decline Bench Chest Fly",
    shortYouTubeDemonstration:
      "https://youtu.be/jIt8nG02Ss0?si=eVQ-M_zbzpxQN1mL&utm_source=MTQxZ",
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Beginner",
    targetMuscleGroup: "Chest",
    primeMoverMuscle: "Pectoralis Major",
    secondaryMuscle: "Anterior Deltoids",
    tertiaryMuscle: "Biceps Brachii",
    primaryEquipment: "Cable",
    CountPrimaryItems: 2,
    secondaryEquipment: "Bench (Decline)",
    CountSecondaryItems: 1,
    posture: "Supine",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Horizontal Adduction",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Transverse Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Plate Overhead Carry",
    shortYouTubeDemonstration:
      "https://youtu.be/pzWVXEdABFg?si=rDT20cfa7nGutLCH&utm_source=MTQxZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/Skm6ibphE_s?si=AbSvolRmnCc2zDSL&utm_source=MTQxZ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Obliques",
    tertiaryMuscle: null,
    primaryEquipment: "Weight Plate",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Walking",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Overhead",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Loaded Carry",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Full Body",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Plank Jack",
    shortYouTubeDemonstration:
      "https://youtu.be/lM33VtF6SCg?si=JG_kyBmQ8H-MspnB&utm_source=MTQxZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/_qA7Y5THdy4?si=N7XpQwI0fEXBPukL&utm_source=MTQxZ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Sliders",
    CountPrimaryItems: 2,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Spinal Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Feet Elevated Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/g93DurTL79E?si=BG_2IXTND6t0_DRn&utm_source=MTQxZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/ul4MZApW4-c?feature=shared&utm_source=MTQxZ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Feet Elevated Forearm Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/hRWpFtDyofg?si=Xwts69VNdiYCB5-r&utm_source=MTQxZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/-46840SWRuw?si=Y5mdJ7OJ8HcQqDfS&utm_source=MTQxZ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Suspension Feet Elevated Side Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/Wkeg0Gr1n7g?si=Xq62yMZ9kUc0lizD&utm_source=MTQxZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/FJ4E_dy6g-0?si=30zuwZgKl_aYWLvq&utm_source=MTQxZ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Obliques",
    secondaryMuscle: "Rectus Abdominis",
    tertiaryMuscle: null,
    primaryEquipment: "Suspension Trainer",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Side Plank",
    singleOrDoubleArm: "Single Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Forearm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Lateral Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Frontal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Stability Ball Feet Elevated Plank",
    shortYouTubeDemonstration:
      "https://youtu.be/MepSU7ua6Dw?si=wDktIQCYf3BtFlRS&utm_source=MTQxZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/7f_htgPOAYQ?si=oCp3TURwXZ6IroMC&utm_source=MTQxZ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Abdominals",
    primeMoverMuscle: "Rectus Abdominis",
    secondaryMuscle: null,
    tertiaryMuscle: null,
    primaryEquipment: "Stability Ball",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Prone",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Flat Palm",
    loadPositionEnding: "No Load",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "Feet Elevated",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Anti-Extension",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Core",
    forceType: "Other",
    mechanics: "Compound",
    laterality: "Bilateral",
    primaryExerciseClassification: "Unsorted*",
  },
  {
    name: "Slider Sandbag Front Rack Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Sandbag",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Front Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Slider Sandbag Back Rack Reverse Lunge",
    shortYouTubeDemonstration: null,
    inDepthYouTubeExplanation: null,
    difficultyLevel: "Novice",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Adductor Magnus",
    primaryEquipment: "Sliders",
    CountPrimaryItems: 1,
    secondaryEquipment: "Sandbag",
    CountSecondaryItems: 1,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Back Rack",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Cable Straight Bar Reverse Grip Front Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/7W7yCOrQMsA?si=fMaW2CwMSudtqBx5&utm_source=MTQxZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/yIoAcMD3jcE?si=1Aatvz7o_SifGMDt&utm_source=MTQxZ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "Cable",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "EZ Bar Reverse Grip Front Raise",
    shortYouTubeDemonstration:
      "https://youtu.be/yTHdkQntOy0?si=MyTLO7RESotzfRsT&utm_source=MTQxZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/ylDqoxFs5kg?si=GJ8Ya6LR8d1YAvL1&utm_source=MTQxZ",
    difficultyLevel: "Novice",
    targetMuscleGroup: "Shoulders",
    primeMoverMuscle: "Anterior Deltoids",
    secondaryMuscle: "Pectoralis Major",
    tertiaryMuscle: null,
    primaryEquipment: "EZ Bar",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Standing",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Supinated",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Continuous",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Shoulder Flexion",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Upper Body",
    forceType: "Push",
    mechanics: "Isolation",
    laterality: "Bilateral",
    primaryExerciseClassification: "Bodybuilding",
  },
  {
    name: "Sled Sprint",
    shortYouTubeDemonstration:
      "https://youtu.be/LyN1Mt53HI4?si=D2E6-rpfLFoTHTc8&utm_source=MTQxZ",
    inDepthYouTubeExplanation:
      "https://youtu.be/EIa4gGQEr1E?feature=shared&utm_source=MTQxZ",
    difficultyLevel: "Intermediate",
    targetMuscleGroup: "Quadriceps",
    primeMoverMuscle: "Quadriceps Femoris",
    secondaryMuscle: "Gluteus Maximus",
    tertiaryMuscle: "Gastrocnemius",
    primaryEquipment: "Sled",
    CountPrimaryItems: 1,
    secondaryEquipment: "None",
    CountSecondaryItems: 0,
    posture: "Running",
    singleOrDoubleArm: "Double Arm",
    continuousOrAlternatingArms: "Continuous",
    grip: "Neutral",
    loadPositionEnding: "Other",
    continuousOrAlternatingLegs: "Alternating",
    footElevation: "No Elevation",
    combinationExercises: "Single Exercise",
    MovementPatternCount1: "Knee Dominullt",
    MovementPatternCount2: null,
    MovementPatternCount3: null,
    PlaneOfMotionCount1: "Sagittal Plane",
    PlaneOfMotionCount2: null,
    PlaneOfMotionCount3: null,
    bodyRegion: "Lower Body",
    forceType: "Push",
    mechanics: "Compound",
    laterality: "Unilateral",
    primaryExerciseClassification: "Unsorted*",
  },
];
